// tslint:disable
import { Injectable } from '@angular/core';

import { DwQuery, DwQueryBuilderGen, DwItem2, DwItemAttributeCollection, DwItemAttribute, DwItemRelationshipCollection, DwItemRelationship, DwItemDetail2, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.58
   Code Gen Name   App
   API Url         https://fitness-challenge-test-api.azurewebsites.net

   Generated By    DEVWARE/Anthony.Monsees
   Generate On     11/3/2026 6:30:31 PM
************************************************/

export enum AppMetaDataItemNames {
    AppearanceBackfillAssignment = 'AppearanceBackfillAssignment',
    AppearancePreset = 'AppearancePreset',
    BadgeAward = 'BadgeAward',
    BadgeAwardEvent = 'BadgeAwardEvent',
    BadgeAwardEventType = 'BadgeAwardEventType',
    BadgeAwardMode = 'BadgeAwardMode',
    BadgeAwardRetentionPolicy = 'BadgeAwardRetentionPolicy',
    BadgeAwardState = 'BadgeAwardState',
    BadgeAwardType = 'BadgeAwardType',
    BadgeCalculationRun = 'BadgeCalculationRun',
    BadgeCalculationRunState = 'BadgeCalculationRunState',
    BadgeCalculationRunType = 'BadgeCalculationRunType',
    BadgeCalculationType = 'BadgeCalculationType',
    BadgeCategory = 'BadgeCategory',
    BadgeDefinition = 'BadgeDefinition',
    BadgeMetricType = 'BadgeMetricType',
    BadgeProgress = 'BadgeProgress',
    BadgeProgressState = 'BadgeProgressState',
    BadgeRecipientType = 'BadgeRecipientType',
    BadgeSubject = 'BadgeSubject',
    BadgeTeamAggregationType = 'BadgeTeamAggregationType',
    BadgeTiePolicy = 'BadgeTiePolicy',
    BadgeTier = 'BadgeTier',
    BannerAnimation = 'BannerAnimation',
    ChallengeBadgeConfiguration = 'ChallengeBadgeConfiguration',
    ChallengeBadgeRule = 'ChallengeBadgeRule',
    ChallengeDefActivityType = 'ChallengeDefActivityType',
    ChallengeDefinition = 'ChallengeDefinition',
    ChallengeDefinitionProduct = 'ChallengeDefinitionProduct',
    ChallengeGoal = 'ChallengeGoal',
    ChallengeMedia = 'ChallengeMedia',
    ChallengeTeam = 'ChallengeTeam',
    ChallengeTeamJoinRequest = 'ChallengeTeamJoinRequest',
    ChallengeTeamJoinRequestStatus = 'ChallengeTeamJoinRequestStatus',
    ChallengeTeamMember = 'ChallengeTeamMember',
    DwAddress = 'dw_Address',
    DwAnnouncement = 'dw_Announcement',
    DwCodeSet = 'dw_CodeSet',
    DwCodeValue = 'dw_CodeValue',
    DwCodeValueRelation = 'dw_CodeValueRelation',
    DwCodeValueTransition = 'dw_CodeValueTransition',
    DwCountry = 'dw_Country',
    DwOrder = 'dw_Order',
    DwOrderBatch = 'dw_OrderBatch',
    DwOrderBatchStatus = 'dw_OrderBatchStatus',
    DwOrderDetail = 'dw_OrderDetail',
    DwOrderStatus = 'dw_OrderStatus',
    DwPostalCode = 'dw_PostalCode',
    DwProduct = 'dw_Product',
    DwProductCategory = 'dw_ProductCategory',
    DwProductColor = 'dw_ProductColor',
    DwProductMedia = 'dw_ProductMedia',
    DwProductOption = 'dw_ProductOption',
    DwProductOptionDetail = 'dw_ProductOptionDetail',
    DwProductSize = 'dw_ProductSize',
    DwProductType = 'dw_ProductType',
    DwShippingRate = 'dw_ShippingRate',
    DwShoppingCartRule = 'dw_ShoppingCartRule',
    DwShoppingCartRuleAction = 'dw_ShoppingCartRuleAction',
    DwShoppingCartRuleActionType = 'dw_ShoppingCartRuleActionType',
    DwShoppingCartRuleCondition = 'dw_ShoppingCartRuleCondition',
    DwShoppingCartRuleConditionType = 'dw_ShoppingCartRuleConditionType',
    DwStateProvince = 'dw_StateProvince',
    DwTimeZone = 'dw_TimeZone',
    DwUser = 'dw_User',
    DwUserPayment = 'dw_UserPayment',
    EmailChallenge = 'EmailChallenge',
    FitnessActivity = 'FitnessActivity',
    FitnessActivityDisplayGroup = 'FitnessActivityDisplayGroup',
    FitnessActivityDisplayGroupUOM = 'FitnessActivityDisplayGroupUOM',
    FitnessActivityType = 'FitnessActivityType',
    InformationRequest = 'InformationRequest',
    LeaderboardEntry = 'LeaderboardEntry',
    LeaderboardSnapshot = 'LeaderboardSnapshot',
    MarketingSource = 'MarketingSource',
    MediaCommentType = 'MediaCommentType',
    MediaPost = 'MediaPost',
    MediaPostComment = 'MediaPostComment',
    Recipient = 'Recipient',
    RecipientPhoto = 'RecipientPhoto',
    RecipientUpdate = 'RecipientUpdate',
    RecipientUpdatePhoto = 'RecipientUpdatePhoto',
    RegistrationOrderDetail = 'RegistrationOrderDetail',
    RoActivityDisplay = 'roActivityDisplay',
    RoChallengeAdminSummary = 'roChallengeAdminSummary',
    RoChallengeCollectionSummary = 'roChallengeCollectionSummary',
    RoChallengeDonationAdmin = 'roChallengeDonationAdmin',
    RoChallengeRegistrationDaily = 'roChallengeRegistrationDaily',
    RoChallengeStreakerAdmin = 'roChallengeStreakerAdmin',
    RoChallengeTeamDonationAdmin = 'roChallengeTeamDonationAdmin',
    RoDonationsByTeam = 'roDonationsByTeam',
    RoPublicDisplayImage = 'roPublicDisplayImage',
    RoStreakerDisplay = 'roStreakerDisplay',
    RoTeamDisplay = 'roTeamDisplay',
    RoTeamFitnessActivityStats = 'roTeamFitnessActivityStats',
    RoTeamFitnessStats = 'roTeamFitnessStats',
    RoUserDonations = 'roUserDonations',
    RoUserFitnessActivityStats = 'roUserFitnessActivityStats',
    RoUserFitnessStats = 'roUserFitnessStats',
    RoUserProfileDisplay = 'roUserProfileDisplay',
    ShirtSize = 'ShirtSize',
    StatsDedup20261015RollupBackup = 'StatsDedup20261015RollupBackup',
    StatsDedup20261015SummaryBackup = 'StatsDedup20261015SummaryBackup',
    UnitOfMeasure = 'UnitOfMeasure',
    UnitOfMeasureType = 'UnitOfMeasureType',
    UserChallenge = 'UserChallenge',
    UserChallengeComment = 'UserChallengeComment',
    UserChallengeCommentLegacyLikeBackup20261013 = 'UserChallengeComment_LegacyLikeBackup_20261013',
    UserChallengeCommentRecipient = 'UserChallengeCommentRecipient',
    UserChallengeCommentType = 'UserChallengeCommentType',
    UserChallengeEmail = 'UserChallengeEmail',
    UserChallengeFriend = 'UserChallengeFriend',
    UserChallengeStatus = 'UserChallengeStatus',
    UserFitnessSummary = 'UserFitnessSummary',
    UserFitnessSummaryRollup = 'UserFitnessSummaryRollup',
    UserProfile = 'UserProfile',
    YearsStreaking = 'YearsStreaking',
}

export enum AppMetaDataLookups {
    AddressAllItems = 264,
    AnnouncementAllItems = 166,
    AppearanceBackfillAssignmentAllItems = 289,
    AppearancePresetAllItems = 281,
    BadgeDefinitionAllItems = 298,
    BannerAnimationAllItems = 282,
    ChallengeDefActivityTypeAllItems = 285,
    ChallengeDefinitionAllItems = 192,
    ChallengeDefinitionProductAllItems = 194,
    ChallengeGoalAllItems = 277,
    ChallengeMediaAllItems = 195,
    ChallengeTeamAllItems = 193,
    ChallengeTeamJoinRequestAllItems = 197,
    ChallengeTeamJoinRequestStatusAllItems = 199,
    ChallengeTeamMemberAllItems = 203,
    CodeSetAllItems = 183,
    CodeValueAllItems = 170,
    CodeValueRelationAllItems = 186,
    CodeValueTransitionAllItems = 188,
    CountryAllItems = 263,
    EmailChallengeAllItems = 205,
    FitnessActivityAllItems = 206,
    FitnessActivityDisplayGroupAllItems = 207,
    FitnessActivityDisplayGroupUOMAllItems = 209,
    FitnessActivityTypeAllItems = 219,
    InformationRequestAllItems = 218,
    MarketingSourceAllItems = 221,
    MediaCommentTypeAllItems = 213,
    MediaPostAllItems = 216,
    MediaPostCommentAllItems = 214,
    OrderAllItems = 179,
    OrderBatchAllItems = 178,
    OrderBatchStatusAllItems = 182,
    OrderDetailAllItems = 184,
    OrderStatusAllItems = 180,
    PostalCodeAllItems = 265,
    ProductAllItems = 173,
    ProductCategoryAllItems = 189,
    ProductColorAllItems = 191,
    ProductMediaAllItems = 167,
    ProductOptionAllItems = 168,
    ProductOptionDetailAllItems = 185,
    ProductSizeAllItems = 187,
    ProductTypeAllItems = 190,
    RecipientAllItems = 301,
    RecipientPhotoAllItems = 302,
    RecipientUpdateAllItems = 299,
    RecipientUpdatePhotoAllItems = 300,
    RegistrationOrderDetailAllItems = 276,
    RoActivityDisplayAllItems = 286,
    RoChallengeCollectionSummaryAllItems = 305,
    RoChallengeRegistrationDailyAllItems = 304,
    RoDonationsByTeamAllItems = 279,
    RoPublicDisplayImageAllItems = 288,
    RoStreakerDisplayAllItems = 290,
    RoTeamDisplayAllItems = 291,
    RoTeamFitnessActivityStatsAllItems = 293,
    RoTeamFitnessStatsAllItems = 292,
    RoUserDonationsAllItems = 280,
    RoUserFitnessActivityStatsAllItems = 296,
    RoUserFitnessStatsAllItems = 297,
    RoUserProfileDisplayAllItems = 287,
    ShippingRateAllItems = 275,
    ShirtSizeAllItems = 208,
    ShoppingCartRuleAllItems = 169,
    ShoppingCartRuleActionAllItems = 171,
    ShoppingCartRuleActionTypeAllItems = 172,
    ShoppingCartRuleConditionAllItems = 174,
    ShoppingCartRuleConditionTypeAllItems = 176,
    StateProvinceByCountry = 278,
    StateProvinceAllItems = 266,
    StatsDedup20261015RollupBackupAllItems = 294,
    StatsDedup20261015SummaryBackupAllItems = 295,
    TimeZoneAllItems = 267,
    UnitOfMeasureAllItems = 210,
    UnitOfMeasureTypeAllItems = 212,
    UserAllItems = 54,
    UserChallengeAllItems = 201,
    UserChallengeCommentAllItems = 196,
    UserChallengeCommentLegacyLikeBackup20261013All = 283,
    UserChallengeCommentRecipientAllItems = 284,
    UserChallengeCommentTypeAllItems = 198,
    UserChallengeEmailAllItems = 200,
    UserChallengeFriendAllItems = 202,
    UserChallengeStatusAllItems = 204,
    UserFitnessSummaryAllItems = 217,
    UserFitnessSummaryRollupAllItems = 211,
    UserPaymentAllItems = 181,
    UserProfileAllItems = 215,
    YearsStreakingAllItems = 220,
}


// Generated Classes for MetaData service
export class DwAddressMetaData implements DwItem2<DwAddressEntity, DwAddressMetaDataAttributes,DwAddressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=255;
        this.ItemDetail.itemName='dw_Address';
        this.ItemDetail.keyName='AddressId';
    }

    CreateEntity(): DwAddressEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwAddressQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwAddressEntity, DwAddressMetaDataAttributes,DwAddressMetaDataRelations>(query, this);
    }
     Attributes = new DwAddressMetaDataAttributes();
     Relations = new DwAddressMetaDataRelations();

}


export type DwAddressQueryBuilder = DwQueryBuilderGen<DwAddressEntity, DwAddressMetaDataAttributes,DwAddressMetaDataRelations>


export class DwAddressMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Address';
    // Attributes
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    CountyName = new DwItemAttribute(this.i, 'CountyName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    PostalCodePlus4 = new DwItemAttribute(this.i, 'PostalCodePlus4');
    Phone = new DwItemAttribute(this.i, 'Phone');
    Fax = new DwItemAttribute(this.i, 'Fax');
    Latitude = new DwItemAttribute(this.i, 'Latitude');
    Longitude = new DwItemAttribute(this.i, 'Longitude');
    TimezoneId = new DwItemAttribute(this.i, 'TimezoneId');
    ObservesDst = new DwItemAttribute(this.i, 'ObservesDst');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class DwAddressMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Country */
            DwCountry = new DwItemRelationship('dw_Country|dw_Address|CountryId', 'DwCountry', 'DwCountry');
            /** Relation: State Province */
            DwStateProvince = new DwItemRelationship('dw_StateProvince|dw_Address|StateProvinceId', 'DwStateProvince', 'DwStateProvince');
            /** Relation: Time Zone - Timezone */
            DwTimeZoneByTimezoneId = new DwItemRelationship('dw_TimeZone|dw_Address|TimezoneId', 'TimezoneIdDwTimeZone', 'TimezoneIdDwTimeZone');
            /** Relation: Order - Billing - Many */
            DwOrderByBillingAddressId = new DwItemRelationship('dw_Address|dw_Order|BillingAddressId', 'BillingDwOrder', 'BillingDwOrder');
            /** Relation: Order - Shipping - Many */
            DwOrderByShippingAddressId = new DwItemRelationship('dw_Address|dw_Order|ShippingAddressId', 'ShippingDwOrder', 'ShippingDwOrder');
            /** Relation: User Profile */
            UserProfile = new DwItemRelationship('dw_Address|UserProfile|AddressId', 'UserProfile', 'UserProfile');
    };
export class DwAnnouncementMetaData implements DwItem2<DwAnnouncementEntity, DwAnnouncementMetaDataAttributes,DwAnnouncementMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=208;
        this.ItemDetail.itemName='dw_Announcement';
        this.ItemDetail.keyName='AnnouncementId';
    }

    CreateEntity(): DwAnnouncementEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwAnnouncementQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwAnnouncementEntity, DwAnnouncementMetaDataAttributes,DwAnnouncementMetaDataRelations>(query, this);
    }
     Attributes = new DwAnnouncementMetaDataAttributes();
     Relations = new DwAnnouncementMetaDataRelations();

}


export type DwAnnouncementQueryBuilder = DwQueryBuilderGen<DwAnnouncementEntity, DwAnnouncementMetaDataAttributes,DwAnnouncementMetaDataRelations>


export class DwAnnouncementMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Announcement';
    // Attributes
    AnnouncementId = new DwItemAttribute(this.i, 'AnnouncementId');
    AnnouncementTitle = new DwItemAttribute(this.i, 'AnnouncementTitle');
    AnnouncementShortDesc = new DwItemAttribute(this.i, 'AnnouncementShortDesc');
    AnnouncementFull = new DwItemAttribute(this.i, 'AnnouncementFull');
    AnnouncementDate = new DwItemAttribute(this.i, 'AnnouncementDate');
    ExpirationDate = new DwItemAttribute(this.i, 'ExpirationDate');
    Priority = new DwItemAttribute(this.i, 'Priority');
    ShowDate = new DwItemAttribute(this.i, 'ShowDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwAnnouncementMetaDataRelations implements DwItemRelationshipCollection {
    };
export class AppearanceBackfillAssignmentMetaData implements DwItem2<AppearanceBackfillAssignmentEntity, AppearanceBackfillAssignmentMetaDataAttributes,AppearanceBackfillAssignmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=304;
        this.ItemDetail.itemName='AppearanceBackfillAssignment';
        this.ItemDetail.keyName='BatchId';
    }

    CreateEntity(): AppearanceBackfillAssignmentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AppearanceBackfillAssignmentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AppearanceBackfillAssignmentEntity, AppearanceBackfillAssignmentMetaDataAttributes,AppearanceBackfillAssignmentMetaDataRelations>(query, this);
    }
     Attributes = new AppearanceBackfillAssignmentMetaDataAttributes();
     Relations = new AppearanceBackfillAssignmentMetaDataRelations();

}


export type AppearanceBackfillAssignmentQueryBuilder = DwQueryBuilderGen<AppearanceBackfillAssignmentEntity, AppearanceBackfillAssignmentMetaDataAttributes,AppearanceBackfillAssignmentMetaDataRelations>


export class AppearanceBackfillAssignmentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AppearanceBackfillAssignment';
    // Attributes
    BatchId = new DwItemAttribute(this.i, 'BatchId');
    EntityType = new DwItemAttribute(this.i, 'EntityType');
    EntityId = new DwItemAttribute(this.i, 'EntityId');
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    PreviousModifiedBy = new DwItemAttribute(this.i, 'PreviousModifiedBy');
    PreviousModifiedDateTime = new DwItemAttribute(this.i, 'PreviousModifiedDateTime');
    AssignedModifiedDateTime = new DwItemAttribute(this.i, 'AssignedModifiedDateTime');
    AppliedDateTime = new DwItemAttribute(this.i, 'AppliedDateTime');
    RolledBackDateTime = new DwItemAttribute(this.i, 'RolledBackDateTime');
}

class AppearanceBackfillAssignmentMetaDataRelations implements DwItemRelationshipCollection {
    };
export class AppearancePresetMetaData implements DwItem2<AppearancePresetEntity, AppearancePresetMetaDataAttributes,AppearancePresetMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=271;
        this.ItemDetail.itemName='AppearancePreset';
        this.ItemDetail.keyName='AppearancePresetId';
    }

    CreateEntity(): AppearancePresetEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AppearancePresetQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AppearancePresetEntity, AppearancePresetMetaDataAttributes,AppearancePresetMetaDataRelations>(query, this);
    }
     Attributes = new AppearancePresetMetaDataAttributes();
     Relations = new AppearancePresetMetaDataRelations();

}


export type AppearancePresetQueryBuilder = DwQueryBuilderGen<AppearancePresetEntity, AppearancePresetMetaDataAttributes,AppearancePresetMetaDataRelations>


export class AppearancePresetMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AppearancePreset';
    // Attributes
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    PresetKey = new DwItemAttribute(this.i, 'PresetKey');
    Name = new DwItemAttribute(this.i, 'Name');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BannerColorStart = new DwItemAttribute(this.i, 'BannerColorStart');
    BannerColorEnd = new DwItemAttribute(this.i, 'BannerColorEnd');
    BannerMediaId = new DwItemAttribute(this.i, 'BannerMediaId');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AppliesToUsers = new DwItemAttribute(this.i, 'AppliesToUsers');
    AppliesToTeams = new DwItemAttribute(this.i, 'AppliesToTeams');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    AllowRandomDefault = new DwItemAttribute(this.i, 'AllowRandomDefault');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    BannerAnimationKey = new DwItemAttribute(this.i, 'BannerAnimationKey');
}

class AppearancePresetMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Banner Animation - Banner Animation Key */
            BannerAnimationByBannerAnimationKey = new DwItemRelationship('BannerAnimation|AppearancePreset|BannerAnimationKey', 'BannerBannerAnimation', 'BannerBannerAnimation');
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|AppearancePreset|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Challenge Team */
            ChallengeTeam = new DwItemRelationship('AppearancePreset|ChallengeTeam|AppearancePresetId', 'ChallengeTeam', 'ChallengeTeam');
            /** Relation: User Profile */
            UserProfile = new DwItemRelationship('AppearancePreset|UserProfile|AppearancePresetId', 'UserProfile', 'UserProfile');
    };
export class BadgeAwardMetaData implements DwItem2<BadgeAwardEntity, BadgeAwardMetaDataAttributes,BadgeAwardMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=281;
        this.ItemDetail.itemName='BadgeAward';
        this.ItemDetail.keyName='BadgeAwardId';
    }

    CreateEntity(): BadgeAwardEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeAwardQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeAwardEntity, BadgeAwardMetaDataAttributes,BadgeAwardMetaDataRelations>(query, this);
    }
     Attributes = new BadgeAwardMetaDataAttributes();
     Relations = new BadgeAwardMetaDataRelations();

}


export type BadgeAwardQueryBuilder = DwQueryBuilderGen<BadgeAwardEntity, BadgeAwardMetaDataAttributes,BadgeAwardMetaDataRelations>


export class BadgeAwardMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAward';
    // Attributes
    BadgeAwardId = new DwItemAttribute(this.i, 'BadgeAwardId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeDefinitionId = new DwItemAttribute(this.i, 'BadgeDefinitionId');
    BadgeRecipientTypeId = new DwItemAttribute(this.i, 'BadgeRecipientTypeId');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    BadgeSubjectId = new DwItemAttribute(this.i, 'BadgeSubjectId');
    ChallengeBadgeRuleId = new DwItemAttribute(this.i, 'ChallengeBadgeRuleId');
    BadgeTierId = new DwItemAttribute(this.i, 'BadgeTierId');
    BadgeAwardTypeId = new DwItemAttribute(this.i, 'BadgeAwardTypeId');
    EarnedDateTime = new DwItemAttribute(this.i, 'EarnedDateTime');
    AwardedDateTime = new DwItemAttribute(this.i, 'AwardedDateTime');
    MetricValueAtAward = new DwItemAttribute(this.i, 'MetricValueAtAward');
    RankAtAward = new DwItemAttribute(this.i, 'RankAtAward');
    BadgeCalculationRunId = new DwItemAttribute(this.i, 'BadgeCalculationRunId');
    LeaderboardEntryId = new DwItemAttribute(this.i, 'LeaderboardEntryId');
    BadgeAwardStateId = new DwItemAttribute(this.i, 'BadgeAwardStateId');
    IsBackfilled = new DwItemAttribute(this.i, 'IsBackfilled');
    CorrectionReason = new DwItemAttribute(this.i, 'CorrectionReason');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeAwardMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeAwardEventMetaData implements DwItem2<BadgeAwardEventEntity, BadgeAwardEventMetaDataAttributes,BadgeAwardEventMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=278;
        this.ItemDetail.itemName='BadgeAwardEvent';
        this.ItemDetail.keyName='BadgeAwardEventId';
    }

    CreateEntity(): BadgeAwardEventEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeAwardEventQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeAwardEventEntity, BadgeAwardEventMetaDataAttributes,BadgeAwardEventMetaDataRelations>(query, this);
    }
     Attributes = new BadgeAwardEventMetaDataAttributes();
     Relations = new BadgeAwardEventMetaDataRelations();

}


export type BadgeAwardEventQueryBuilder = DwQueryBuilderGen<BadgeAwardEventEntity, BadgeAwardEventMetaDataAttributes,BadgeAwardEventMetaDataRelations>


export class BadgeAwardEventMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAwardEvent';
    // Attributes
    BadgeAwardEventId = new DwItemAttribute(this.i, 'BadgeAwardEventId');
    BadgeAwardId = new DwItemAttribute(this.i, 'BadgeAwardId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeAwardEventTypeId = new DwItemAttribute(this.i, 'BadgeAwardEventTypeId');
    EffectiveDateTime = new DwItemAttribute(this.i, 'EffectiveDateTime');
    RecordedDateTime = new DwItemAttribute(this.i, 'RecordedDateTime');
    Reason = new DwItemAttribute(this.i, 'Reason');
    BadgeCalculationRunId = new DwItemAttribute(this.i, 'BadgeCalculationRunId');
    MetricValue = new DwItemAttribute(this.i, 'MetricValue');
    RankPosition = new DwItemAttribute(this.i, 'RankPosition');
    OperationKey = new DwItemAttribute(this.i, 'OperationKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeAwardEventMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeAwardEventTypeMetaData implements DwItem2<BadgeAwardEventTypeEntity, BadgeAwardEventTypeMetaDataAttributes,BadgeAwardEventTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=294;
        this.ItemDetail.itemName='BadgeAwardEventType';
        this.ItemDetail.keyName='BadgeAwardEventTypeId';
    }

    CreateEntity(): BadgeAwardEventTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeAwardEventTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeAwardEventTypeEntity, BadgeAwardEventTypeMetaDataAttributes,BadgeAwardEventTypeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeAwardEventTypeMetaDataAttributes();
     Relations = new BadgeAwardEventTypeMetaDataRelations();

}


export type BadgeAwardEventTypeQueryBuilder = DwQueryBuilderGen<BadgeAwardEventTypeEntity, BadgeAwardEventTypeMetaDataAttributes,BadgeAwardEventTypeMetaDataRelations>


export class BadgeAwardEventTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAwardEventType';
    // Attributes
    BadgeAwardEventTypeId = new DwItemAttribute(this.i, 'BadgeAwardEventTypeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeAwardEventTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeAwardModeMetaData implements DwItem2<BadgeAwardModeEntity, BadgeAwardModeMetaDataAttributes,BadgeAwardModeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=279;
        this.ItemDetail.itemName='BadgeAwardMode';
        this.ItemDetail.keyName='BadgeAwardModeId';
    }

    CreateEntity(): BadgeAwardModeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeAwardModeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeAwardModeEntity, BadgeAwardModeMetaDataAttributes,BadgeAwardModeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeAwardModeMetaDataAttributes();
     Relations = new BadgeAwardModeMetaDataRelations();

}


export type BadgeAwardModeQueryBuilder = DwQueryBuilderGen<BadgeAwardModeEntity, BadgeAwardModeMetaDataAttributes,BadgeAwardModeMetaDataRelations>


export class BadgeAwardModeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAwardMode';
    // Attributes
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeAwardModeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeAwardRetentionPolicyMetaData implements DwItem2<BadgeAwardRetentionPolicyEntity, BadgeAwardRetentionPolicyMetaDataAttributes,BadgeAwardRetentionPolicyMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=286;
        this.ItemDetail.itemName='BadgeAwardRetentionPolicy';
        this.ItemDetail.keyName='BadgeAwardRetentionPolicyId';
    }

    CreateEntity(): BadgeAwardRetentionPolicyEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeAwardRetentionPolicyQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeAwardRetentionPolicyEntity, BadgeAwardRetentionPolicyMetaDataAttributes,BadgeAwardRetentionPolicyMetaDataRelations>(query, this);
    }
     Attributes = new BadgeAwardRetentionPolicyMetaDataAttributes();
     Relations = new BadgeAwardRetentionPolicyMetaDataRelations();

}


export type BadgeAwardRetentionPolicyQueryBuilder = DwQueryBuilderGen<BadgeAwardRetentionPolicyEntity, BadgeAwardRetentionPolicyMetaDataAttributes,BadgeAwardRetentionPolicyMetaDataRelations>


export class BadgeAwardRetentionPolicyMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAwardRetentionPolicy';
    // Attributes
    BadgeAwardRetentionPolicyId = new DwItemAttribute(this.i, 'BadgeAwardRetentionPolicyId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeAwardRetentionPolicyMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeAwardStateMetaData implements DwItem2<BadgeAwardStateEntity, BadgeAwardStateMetaDataAttributes,BadgeAwardStateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=291;
        this.ItemDetail.itemName='BadgeAwardState';
        this.ItemDetail.keyName='BadgeAwardStateId';
    }

    CreateEntity(): BadgeAwardStateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeAwardStateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeAwardStateEntity, BadgeAwardStateMetaDataAttributes,BadgeAwardStateMetaDataRelations>(query, this);
    }
     Attributes = new BadgeAwardStateMetaDataAttributes();
     Relations = new BadgeAwardStateMetaDataRelations();

}


export type BadgeAwardStateQueryBuilder = DwQueryBuilderGen<BadgeAwardStateEntity, BadgeAwardStateMetaDataAttributes,BadgeAwardStateMetaDataRelations>


export class BadgeAwardStateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAwardState';
    // Attributes
    BadgeAwardStateId = new DwItemAttribute(this.i, 'BadgeAwardStateId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeAwardStateMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeAwardTypeMetaData implements DwItem2<BadgeAwardTypeEntity, BadgeAwardTypeMetaDataAttributes,BadgeAwardTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=292;
        this.ItemDetail.itemName='BadgeAwardType';
        this.ItemDetail.keyName='BadgeAwardTypeId';
    }

    CreateEntity(): BadgeAwardTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeAwardTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeAwardTypeEntity, BadgeAwardTypeMetaDataAttributes,BadgeAwardTypeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeAwardTypeMetaDataAttributes();
     Relations = new BadgeAwardTypeMetaDataRelations();

}


export type BadgeAwardTypeQueryBuilder = DwQueryBuilderGen<BadgeAwardTypeEntity, BadgeAwardTypeMetaDataAttributes,BadgeAwardTypeMetaDataRelations>


export class BadgeAwardTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAwardType';
    // Attributes
    BadgeAwardTypeId = new DwItemAttribute(this.i, 'BadgeAwardTypeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeAwardTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeCalculationRunMetaData implements DwItem2<BadgeCalculationRunEntity, BadgeCalculationRunMetaDataAttributes,BadgeCalculationRunMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=288;
        this.ItemDetail.itemName='BadgeCalculationRun';
        this.ItemDetail.keyName='BadgeCalculationRunId';
    }

    CreateEntity(): BadgeCalculationRunEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeCalculationRunQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeCalculationRunEntity, BadgeCalculationRunMetaDataAttributes,BadgeCalculationRunMetaDataRelations>(query, this);
    }
     Attributes = new BadgeCalculationRunMetaDataAttributes();
     Relations = new BadgeCalculationRunMetaDataRelations();

}


export type BadgeCalculationRunQueryBuilder = DwQueryBuilderGen<BadgeCalculationRunEntity, BadgeCalculationRunMetaDataAttributes,BadgeCalculationRunMetaDataRelations>


export class BadgeCalculationRunMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeCalculationRun';
    // Attributes
    BadgeCalculationRunId = new DwItemAttribute(this.i, 'BadgeCalculationRunId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeCalculationRunTypeId = new DwItemAttribute(this.i, 'BadgeCalculationRunTypeId');
    BadgeCalculationRunStateId = new DwItemAttribute(this.i, 'BadgeCalculationRunStateId');
    ReportingDate = new DwItemAttribute(this.i, 'ReportingDate');
    ScoreThroughDate = new DwItemAttribute(this.i, 'ScoreThroughDate');
    SourceReadStartedDateTime = new DwItemAttribute(this.i, 'SourceReadStartedDateTime');
    SourceReadCompletedDateTime = new DwItemAttribute(this.i, 'SourceReadCompletedDateTime');
    ConfigurationRevision = new DwItemAttribute(this.i, 'ConfigurationRevision');
    StartedDateTime = new DwItemAttribute(this.i, 'StartedDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    PublishedDateTime = new DwItemAttribute(this.i, 'PublishedDateTime');
    PreviousBadgeCalculationRunId = new DwItemAttribute(this.i, 'PreviousBadgeCalculationRunId');
    OperationKey = new DwItemAttribute(this.i, 'OperationKey');
    BoardCount = new DwItemAttribute(this.i, 'BoardCount');
    EntryCount = new DwItemAttribute(this.i, 'EntryCount');
    AwardCount = new DwItemAttribute(this.i, 'AwardCount');
    ErrorSummary = new DwItemAttribute(this.i, 'ErrorSummary');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeCalculationRunMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|BadgeCalculationRun|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
    };
export class BadgeCalculationRunStateMetaData implements DwItem2<BadgeCalculationRunStateEntity, BadgeCalculationRunStateMetaDataAttributes,BadgeCalculationRunStateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=295;
        this.ItemDetail.itemName='BadgeCalculationRunState';
        this.ItemDetail.keyName='BadgeCalculationRunStateId';
    }

    CreateEntity(): BadgeCalculationRunStateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeCalculationRunStateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeCalculationRunStateEntity, BadgeCalculationRunStateMetaDataAttributes,BadgeCalculationRunStateMetaDataRelations>(query, this);
    }
     Attributes = new BadgeCalculationRunStateMetaDataAttributes();
     Relations = new BadgeCalculationRunStateMetaDataRelations();

}


export type BadgeCalculationRunStateQueryBuilder = DwQueryBuilderGen<BadgeCalculationRunStateEntity, BadgeCalculationRunStateMetaDataAttributes,BadgeCalculationRunStateMetaDataRelations>


export class BadgeCalculationRunStateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeCalculationRunState';
    // Attributes
    BadgeCalculationRunStateId = new DwItemAttribute(this.i, 'BadgeCalculationRunStateId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeCalculationRunStateMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeCalculationRunTypeMetaData implements DwItem2<BadgeCalculationRunTypeEntity, BadgeCalculationRunTypeMetaDataAttributes,BadgeCalculationRunTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=293;
        this.ItemDetail.itemName='BadgeCalculationRunType';
        this.ItemDetail.keyName='BadgeCalculationRunTypeId';
    }

    CreateEntity(): BadgeCalculationRunTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeCalculationRunTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeCalculationRunTypeEntity, BadgeCalculationRunTypeMetaDataAttributes,BadgeCalculationRunTypeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeCalculationRunTypeMetaDataAttributes();
     Relations = new BadgeCalculationRunTypeMetaDataRelations();

}


export type BadgeCalculationRunTypeQueryBuilder = DwQueryBuilderGen<BadgeCalculationRunTypeEntity, BadgeCalculationRunTypeMetaDataAttributes,BadgeCalculationRunTypeMetaDataRelations>


export class BadgeCalculationRunTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeCalculationRunType';
    // Attributes
    BadgeCalculationRunTypeId = new DwItemAttribute(this.i, 'BadgeCalculationRunTypeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeCalculationRunTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeCalculationTypeMetaData implements DwItem2<BadgeCalculationTypeEntity, BadgeCalculationTypeMetaDataAttributes,BadgeCalculationTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=297;
        this.ItemDetail.itemName='BadgeCalculationType';
        this.ItemDetail.keyName='BadgeCalculationTypeId';
    }

    CreateEntity(): BadgeCalculationTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeCalculationTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeCalculationTypeEntity, BadgeCalculationTypeMetaDataAttributes,BadgeCalculationTypeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeCalculationTypeMetaDataAttributes();
     Relations = new BadgeCalculationTypeMetaDataRelations();

}


export type BadgeCalculationTypeQueryBuilder = DwQueryBuilderGen<BadgeCalculationTypeEntity, BadgeCalculationTypeMetaDataAttributes,BadgeCalculationTypeMetaDataRelations>


export class BadgeCalculationTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeCalculationType';
    // Attributes
    BadgeCalculationTypeId = new DwItemAttribute(this.i, 'BadgeCalculationTypeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeCalculationTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Badge Definition */
            BadgeDefinitionByBadgeAwardModeId = new DwItemRelationship('BadgeCalculationType|BadgeDefinition|BadgeAwardModeId', 'BadgeDefinitionBadgeAwardModeId', 'BadgeDefinitionBadgeAwardModeId');
    };
export class BadgeCategoryMetaData implements DwItem2<BadgeCategoryEntity, BadgeCategoryMetaDataAttributes,BadgeCategoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=276;
        this.ItemDetail.itemName='BadgeCategory';
        this.ItemDetail.keyName='BadgeCategoryId';
    }

    CreateEntity(): BadgeCategoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeCategoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeCategoryEntity, BadgeCategoryMetaDataAttributes,BadgeCategoryMetaDataRelations>(query, this);
    }
     Attributes = new BadgeCategoryMetaDataAttributes();
     Relations = new BadgeCategoryMetaDataRelations();

}


export type BadgeCategoryQueryBuilder = DwQueryBuilderGen<BadgeCategoryEntity, BadgeCategoryMetaDataAttributes,BadgeCategoryMetaDataRelations>


export class BadgeCategoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeCategory';
    // Attributes
    BadgeCategoryId = new DwItemAttribute(this.i, 'BadgeCategoryId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeCategoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Badge Definition */
            BadgeDefinition = new DwItemRelationship('BadgeCategory|BadgeDefinition|BadgeCategoryId', 'BadgeDefinition', 'BadgeDefinition');
    };
export class BadgeDefinitionMetaData implements DwItem2<BadgeDefinitionEntity, BadgeDefinitionMetaDataAttributes,BadgeDefinitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=284;
        this.ItemDetail.itemName='BadgeDefinition';
        this.ItemDetail.keyName='BadgeDefinitionId';
    }

    CreateEntity(): BadgeDefinitionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeDefinitionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeDefinitionEntity, BadgeDefinitionMetaDataAttributes,BadgeDefinitionMetaDataRelations>(query, this);
    }
     Attributes = new BadgeDefinitionMetaDataAttributes();
     Relations = new BadgeDefinitionMetaDataRelations();

}


export type BadgeDefinitionQueryBuilder = DwQueryBuilderGen<BadgeDefinitionEntity, BadgeDefinitionMetaDataAttributes,BadgeDefinitionMetaDataRelations>


export class BadgeDefinitionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeDefinition';
    // Attributes
    BadgeDefinitionId = new DwItemAttribute(this.i, 'BadgeDefinitionId');
    BadgeKey = new DwItemAttribute(this.i, 'BadgeKey');
    DefinitionVersion = new DwItemAttribute(this.i, 'DefinitionVersion');
    Name = new DwItemAttribute(this.i, 'Name');
    Description = new DwItemAttribute(this.i, 'Description');
    BadgeCategoryId = new DwItemAttribute(this.i, 'BadgeCategoryId');
    BadgeCalculationTypeId = new DwItemAttribute(this.i, 'BadgeCalculationTypeId');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    DefaultIconKey = new DwItemAttribute(this.i, 'DefaultIconKey');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeDefinitionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Badge Calculation Type */
            BadgeCalculationTypeByBadgeAwardModeId = new DwItemRelationship('BadgeCalculationType|BadgeDefinition|BadgeAwardModeId', 'BadgeCalculationTypeBadgeAwardModeId', 'BadgeCalculationTypeBadgeAwardModeId');
            /** Relation: Badge Category */
            BadgeCategory = new DwItemRelationship('BadgeCategory|BadgeDefinition|BadgeCategoryId', 'BadgeCategory', 'BadgeCategory');
            /** Relation: Badge Tier */
            BadgeTierByBadgeAwardModeId = new DwItemRelationship('BadgeDefinition|BadgeTier|BadgeAwardModeId', 'BadgeTierBadgeAwardModeId', 'BadgeTierBadgeAwardModeId');
            /** Relation: Challenge Badge Rule */
            ChallengeBadgeRule = new DwItemRelationship('BadgeDefinition|ChallengeBadgeRule|BadgeDefinitionId', 'ChallengeBadgeRule', 'ChallengeBadgeRule');
            /** Relation: Challenge Badge Rule */
            ChallengeBadgeRuleByBadgeAwardModeId = new DwItemRelationship('BadgeDefinition|ChallengeBadgeRule|BadgeAwardModeId', 'ChallengeBadgeRuleBadgeAwardModeId', 'ChallengeBadgeRuleBadgeAwardModeId');
    };
export class BadgeMetricTypeMetaData implements DwItem2<BadgeMetricTypeEntity, BadgeMetricTypeMetaDataAttributes,BadgeMetricTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=282;
        this.ItemDetail.itemName='BadgeMetricType';
        this.ItemDetail.keyName='BadgeMetricTypeId';
    }

    CreateEntity(): BadgeMetricTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeMetricTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeMetricTypeEntity, BadgeMetricTypeMetaDataAttributes,BadgeMetricTypeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeMetricTypeMetaDataAttributes();
     Relations = new BadgeMetricTypeMetaDataRelations();

}


export type BadgeMetricTypeQueryBuilder = DwQueryBuilderGen<BadgeMetricTypeEntity, BadgeMetricTypeMetaDataAttributes,BadgeMetricTypeMetaDataRelations>


export class BadgeMetricTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeMetricType';
    // Attributes
    BadgeMetricTypeId = new DwItemAttribute(this.i, 'BadgeMetricTypeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    BadgeCalculationTypeId = new DwItemAttribute(this.i, 'BadgeCalculationTypeId');
    UnitKey = new DwItemAttribute(this.i, 'UnitKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeMetricTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeProgressMetaData implements DwItem2<BadgeProgressEntity, BadgeProgressMetaDataAttributes,BadgeProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=289;
        this.ItemDetail.itemName='BadgeProgress';
        this.ItemDetail.keyName='BadgeProgressId';
    }

    CreateEntity(): BadgeProgressEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeProgressQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeProgressEntity, BadgeProgressMetaDataAttributes,BadgeProgressMetaDataRelations>(query, this);
    }
     Attributes = new BadgeProgressMetaDataAttributes();
     Relations = new BadgeProgressMetaDataRelations();

}


export type BadgeProgressQueryBuilder = DwQueryBuilderGen<BadgeProgressEntity, BadgeProgressMetaDataAttributes,BadgeProgressMetaDataRelations>


export class BadgeProgressMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeProgress';
    // Attributes
    BadgeProgressId = new DwItemAttribute(this.i, 'BadgeProgressId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeDefinitionId = new DwItemAttribute(this.i, 'BadgeDefinitionId');
    BadgeRecipientTypeId = new DwItemAttribute(this.i, 'BadgeRecipientTypeId');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    BadgeSubjectId = new DwItemAttribute(this.i, 'BadgeSubjectId');
    ChallengeBadgeRuleId = new DwItemAttribute(this.i, 'ChallengeBadgeRuleId');
    CurrentMetricValue = new DwItemAttribute(this.i, 'CurrentMetricValue');
    CurrentBadgeTierId = new DwItemAttribute(this.i, 'CurrentBadgeTierId');
    NextBadgeTierId = new DwItemAttribute(this.i, 'NextBadgeTierId');
    NextThresholdValue = new DwItemAttribute(this.i, 'NextThresholdValue');
    ProgressPercent = new DwItemAttribute(this.i, 'ProgressPercent');
    BadgeProgressStateId = new DwItemAttribute(this.i, 'BadgeProgressStateId');
    LastBadgeCalculationRunId = new DwItemAttribute(this.i, 'LastBadgeCalculationRunId');
    LastCalculatedDateTime = new DwItemAttribute(this.i, 'LastCalculatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeProgressMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeProgressStateMetaData implements DwItem2<BadgeProgressStateEntity, BadgeProgressStateMetaDataAttributes,BadgeProgressStateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=285;
        this.ItemDetail.itemName='BadgeProgressState';
        this.ItemDetail.keyName='BadgeProgressStateId';
    }

    CreateEntity(): BadgeProgressStateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeProgressStateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeProgressStateEntity, BadgeProgressStateMetaDataAttributes,BadgeProgressStateMetaDataRelations>(query, this);
    }
     Attributes = new BadgeProgressStateMetaDataAttributes();
     Relations = new BadgeProgressStateMetaDataRelations();

}


export type BadgeProgressStateQueryBuilder = DwQueryBuilderGen<BadgeProgressStateEntity, BadgeProgressStateMetaDataAttributes,BadgeProgressStateMetaDataRelations>


export class BadgeProgressStateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeProgressState';
    // Attributes
    BadgeProgressStateId = new DwItemAttribute(this.i, 'BadgeProgressStateId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeProgressStateMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeRecipientTypeMetaData implements DwItem2<BadgeRecipientTypeEntity, BadgeRecipientTypeMetaDataAttributes,BadgeRecipientTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=275;
        this.ItemDetail.itemName='BadgeRecipientType';
        this.ItemDetail.keyName='BadgeRecipientTypeId';
    }

    CreateEntity(): BadgeRecipientTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeRecipientTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeRecipientTypeEntity, BadgeRecipientTypeMetaDataAttributes,BadgeRecipientTypeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeRecipientTypeMetaDataAttributes();
     Relations = new BadgeRecipientTypeMetaDataRelations();

}


export type BadgeRecipientTypeQueryBuilder = DwQueryBuilderGen<BadgeRecipientTypeEntity, BadgeRecipientTypeMetaDataAttributes,BadgeRecipientTypeMetaDataRelations>


export class BadgeRecipientTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeRecipientType';
    // Attributes
    BadgeRecipientTypeId = new DwItemAttribute(this.i, 'BadgeRecipientTypeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeRecipientTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeSubjectMetaData implements DwItem2<BadgeSubjectEntity, BadgeSubjectMetaDataAttributes,BadgeSubjectMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=280;
        this.ItemDetail.itemName='BadgeSubject';
        this.ItemDetail.keyName='BadgeSubjectId';
    }

    CreateEntity(): BadgeSubjectEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeSubjectQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeSubjectEntity, BadgeSubjectMetaDataAttributes,BadgeSubjectMetaDataRelations>(query, this);
    }
     Attributes = new BadgeSubjectMetaDataAttributes();
     Relations = new BadgeSubjectMetaDataRelations();

}


export type BadgeSubjectQueryBuilder = DwQueryBuilderGen<BadgeSubjectEntity, BadgeSubjectMetaDataAttributes,BadgeSubjectMetaDataRelations>


export class BadgeSubjectMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeSubject';
    // Attributes
    BadgeSubjectId = new DwItemAttribute(this.i, 'BadgeSubjectId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeRecipientTypeId = new DwItemAttribute(this.i, 'BadgeRecipientTypeId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeSubjectMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|BadgeSubject|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Challenge Team */
            ChallengeTeam = new DwItemRelationship('ChallengeTeam|BadgeSubject|ChallengeTeamId', 'ChallengeTeam', 'ChallengeTeam');
            /** Relation: Challenge Team - Challenge Definition */
            ChallengeTeamByChallengeDefinitionId = new DwItemRelationship('ChallengeTeam|BadgeSubject|ChallengeDefinitionId', 'ChallengeDefinitionIdChallengeTeam', 'ChallengeDefinitionIdChallengeTeam');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|BadgeSubject|UserChallengeId', 'UserChallenge', 'UserChallenge');
            /** Relation: User Challenge - Challenge Definition */
            UserChallengeByChallengeDefinitionId = new DwItemRelationship('UserChallenge|BadgeSubject|ChallengeDefinitionId', 'ChallengeDefinitionIdUserChallenge', 'ChallengeDefinitionIdUserChallenge');
    };
export class BadgeTeamAggregationTypeMetaData implements DwItem2<BadgeTeamAggregationTypeEntity, BadgeTeamAggregationTypeMetaDataAttributes,BadgeTeamAggregationTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=273;
        this.ItemDetail.itemName='BadgeTeamAggregationType';
        this.ItemDetail.keyName='BadgeTeamAggregationTypeId';
    }

    CreateEntity(): BadgeTeamAggregationTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeTeamAggregationTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeTeamAggregationTypeEntity, BadgeTeamAggregationTypeMetaDataAttributes,BadgeTeamAggregationTypeMetaDataRelations>(query, this);
    }
     Attributes = new BadgeTeamAggregationTypeMetaDataAttributes();
     Relations = new BadgeTeamAggregationTypeMetaDataRelations();

}


export type BadgeTeamAggregationTypeQueryBuilder = DwQueryBuilderGen<BadgeTeamAggregationTypeEntity, BadgeTeamAggregationTypeMetaDataAttributes,BadgeTeamAggregationTypeMetaDataRelations>


export class BadgeTeamAggregationTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeTeamAggregationType';
    // Attributes
    BadgeTeamAggregationTypeId = new DwItemAttribute(this.i, 'BadgeTeamAggregationTypeId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeTeamAggregationTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeTiePolicyMetaData implements DwItem2<BadgeTiePolicyEntity, BadgeTiePolicyMetaDataAttributes,BadgeTiePolicyMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=287;
        this.ItemDetail.itemName='BadgeTiePolicy';
        this.ItemDetail.keyName='BadgeTiePolicyId';
    }

    CreateEntity(): BadgeTiePolicyEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeTiePolicyQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeTiePolicyEntity, BadgeTiePolicyMetaDataAttributes,BadgeTiePolicyMetaDataRelations>(query, this);
    }
     Attributes = new BadgeTiePolicyMetaDataAttributes();
     Relations = new BadgeTiePolicyMetaDataRelations();

}


export type BadgeTiePolicyQueryBuilder = DwQueryBuilderGen<BadgeTiePolicyEntity, BadgeTiePolicyMetaDataAttributes,BadgeTiePolicyMetaDataRelations>


export class BadgeTiePolicyMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeTiePolicy';
    // Attributes
    BadgeTiePolicyId = new DwItemAttribute(this.i, 'BadgeTiePolicyId');
    Code = new DwItemAttribute(this.i, 'Code');
    Name = new DwItemAttribute(this.i, 'Name');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeTiePolicyMetaDataRelations implements DwItemRelationshipCollection {
    };
export class BadgeTierMetaData implements DwItem2<BadgeTierEntity, BadgeTierMetaDataAttributes,BadgeTierMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=277;
        this.ItemDetail.itemName='BadgeTier';
        this.ItemDetail.keyName='BadgeTierId';
    }

    CreateEntity(): BadgeTierEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BadgeTierQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BadgeTierEntity, BadgeTierMetaDataAttributes,BadgeTierMetaDataRelations>(query, this);
    }
     Attributes = new BadgeTierMetaDataAttributes();
     Relations = new BadgeTierMetaDataRelations();

}


export type BadgeTierQueryBuilder = DwQueryBuilderGen<BadgeTierEntity, BadgeTierMetaDataAttributes,BadgeTierMetaDataRelations>


export class BadgeTierMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeTier';
    // Attributes
    BadgeTierId = new DwItemAttribute(this.i, 'BadgeTierId');
    BadgeDefinitionId = new DwItemAttribute(this.i, 'BadgeDefinitionId');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    TierKey = new DwItemAttribute(this.i, 'TierKey');
    TierOrder = new DwItemAttribute(this.i, 'TierOrder');
    Name = new DwItemAttribute(this.i, 'Name');
    ThresholdValue = new DwItemAttribute(this.i, 'ThresholdValue');
    MinRank = new DwItemAttribute(this.i, 'MinRank');
    MaxRank = new DwItemAttribute(this.i, 'MaxRank');
    RequirementText = new DwItemAttribute(this.i, 'RequirementText');
    FrameKey = new DwItemAttribute(this.i, 'FrameKey');
    SymbolMaterialKey = new DwItemAttribute(this.i, 'SymbolMaterialKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BadgeTierMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Badge Definition */
            BadgeDefinitionByBadgeAwardModeId = new DwItemRelationship('BadgeDefinition|BadgeTier|BadgeAwardModeId', 'BadgeDefinitionBadgeAwardModeId', 'BadgeDefinitionBadgeAwardModeId');
    };
export class BannerAnimationMetaData implements DwItem2<BannerAnimationEntity, BannerAnimationMetaDataAttributes,BannerAnimationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=272;
        this.ItemDetail.itemName='BannerAnimation';
        this.ItemDetail.keyName='BannerAnimationId';
    }

    CreateEntity(): BannerAnimationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BannerAnimationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BannerAnimationEntity, BannerAnimationMetaDataAttributes,BannerAnimationMetaDataRelations>(query, this);
    }
     Attributes = new BannerAnimationMetaDataAttributes();
     Relations = new BannerAnimationMetaDataRelations();

}


export type BannerAnimationQueryBuilder = DwQueryBuilderGen<BannerAnimationEntity, BannerAnimationMetaDataAttributes,BannerAnimationMetaDataRelations>


export class BannerAnimationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BannerAnimation';
    // Attributes
    BannerAnimationId = new DwItemAttribute(this.i, 'BannerAnimationId');
    AnimationKey = new DwItemAttribute(this.i, 'AnimationKey');
    Name = new DwItemAttribute(this.i, 'Name');
    RendererKey = new DwItemAttribute(this.i, 'RendererKey');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsSelectable = new DwItemAttribute(this.i, 'IsSelectable');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class BannerAnimationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Appearance Preset - Animation Key - Many */
            AppearancePresetByBannerAnimationKey = new DwItemRelationship('BannerAnimation|AppearancePreset|BannerAnimationKey', 'BannerAppearancePreset', 'BannerAppearancePreset');
            /** Relation: Challenge Team - Animation Key - Many */
            ChallengeTeamByBannerAnimationKey = new DwItemRelationship('BannerAnimation|ChallengeTeam|BannerAnimationKey', 'BannerChallengeTeam', 'BannerChallengeTeam');
            /** Relation: User Profile - Animation Key - Many */
            UserProfileByBannerAnimationKey = new DwItemRelationship('BannerAnimation|UserProfile|BannerAnimationKey', 'BannerUserProfile', 'BannerUserProfile');
    };
export class ChallengeBadgeConfigurationMetaData implements DwItem2<ChallengeBadgeConfigurationEntity, ChallengeBadgeConfigurationMetaDataAttributes,ChallengeBadgeConfigurationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=290;
        this.ItemDetail.itemName='ChallengeBadgeConfiguration';
        this.ItemDetail.keyName='ChallengeBadgeConfigurationId';
    }

    CreateEntity(): ChallengeBadgeConfigurationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeBadgeConfigurationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeBadgeConfigurationEntity, ChallengeBadgeConfigurationMetaDataAttributes,ChallengeBadgeConfigurationMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeBadgeConfigurationMetaDataAttributes();
     Relations = new ChallengeBadgeConfigurationMetaDataRelations();

}


export type ChallengeBadgeConfigurationQueryBuilder = DwQueryBuilderGen<ChallengeBadgeConfigurationEntity, ChallengeBadgeConfigurationMetaDataAttributes,ChallengeBadgeConfigurationMetaDataRelations>


export class ChallengeBadgeConfigurationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeBadgeConfiguration';
    // Attributes
    ChallengeBadgeConfigurationId = new DwItemAttribute(this.i, 'ChallengeBadgeConfigurationId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    Enabled = new DwItemAttribute(this.i, 'Enabled');
    ConfigurationRevision = new DwItemAttribute(this.i, 'ConfigurationRevision');
    TimeZoneIdentifier = new DwItemAttribute(this.i, 'TimeZoneIdentifier');
    NightlyCalculationLocalTime = new DwItemAttribute(this.i, 'NightlyCalculationLocalTime');
    FinalizationEligibleDateTime = new DwItemAttribute(this.i, 'FinalizationEligibleDateTime');
    PublishedBadgeCalculationRunId = new DwItemAttribute(this.i, 'PublishedBadgeCalculationRunId');
    FinalBadgeCalculationRunId = new DwItemAttribute(this.i, 'FinalBadgeCalculationRunId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ChallengeBadgeConfigurationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ChallengeBadgeConfiguration|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
    };
export class ChallengeBadgeRuleMetaData implements DwItem2<ChallengeBadgeRuleEntity, ChallengeBadgeRuleMetaDataAttributes,ChallengeBadgeRuleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=274;
        this.ItemDetail.itemName='ChallengeBadgeRule';
        this.ItemDetail.keyName='ChallengeBadgeRuleId';
    }

    CreateEntity(): ChallengeBadgeRuleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeBadgeRuleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeBadgeRuleEntity, ChallengeBadgeRuleMetaDataAttributes,ChallengeBadgeRuleMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeBadgeRuleMetaDataAttributes();
     Relations = new ChallengeBadgeRuleMetaDataRelations();

}


export type ChallengeBadgeRuleQueryBuilder = DwQueryBuilderGen<ChallengeBadgeRuleEntity, ChallengeBadgeRuleMetaDataAttributes,ChallengeBadgeRuleMetaDataRelations>


export class ChallengeBadgeRuleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeBadgeRule';
    // Attributes
    ChallengeBadgeRuleId = new DwItemAttribute(this.i, 'ChallengeBadgeRuleId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeDefinitionId = new DwItemAttribute(this.i, 'BadgeDefinitionId');
    BadgeCalculationTypeId = new DwItemAttribute(this.i, 'BadgeCalculationTypeId');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    RuleKey = new DwItemAttribute(this.i, 'RuleKey');
    RuleVersion = new DwItemAttribute(this.i, 'RuleVersion');
    BadgeRecipientTypeId = new DwItemAttribute(this.i, 'BadgeRecipientTypeId');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    BadgeMetricTypeId = new DwItemAttribute(this.i, 'BadgeMetricTypeId');
    BadgeTeamAggregationTypeId = new DwItemAttribute(this.i, 'BadgeTeamAggregationTypeId');
    BadgeTiePolicyId = new DwItemAttribute(this.i, 'BadgeTiePolicyId');
    BadgeAwardRetentionPolicyId = new DwItemAttribute(this.i, 'BadgeAwardRetentionPolicyId');
    AvailableFromDate = new DwItemAttribute(this.i, 'AvailableFromDate');
    AvailableThroughDate = new DwItemAttribute(this.i, 'AvailableThroughDate');
    Enabled = new DwItemAttribute(this.i, 'Enabled');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ChallengeBadgeRuleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Badge Definition */
            BadgeDefinitionByBadgeAwardModeId = new DwItemRelationship('BadgeDefinition|ChallengeBadgeRule|BadgeAwardModeId', 'BadgeDefinitionBadgeAwardModeId', 'BadgeDefinitionBadgeAwardModeId');
            /** Relation: Badge Definition */
            BadgeDefinition = new DwItemRelationship('BadgeDefinition|ChallengeBadgeRule|BadgeDefinitionId', 'BadgeDefinition', 'BadgeDefinition');
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ChallengeBadgeRule|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Fitness Activity Type */
            FitnessActivityType = new DwItemRelationship('FitnessActivityType|ChallengeBadgeRule|FitnessActivityTypeId', 'FitnessActivityType', 'FitnessActivityType');
    };
export class ChallengeDefActivityTypeMetaData implements DwItem2<ChallengeDefActivityTypeEntity, ChallengeDefActivityTypeMetaDataAttributes,ChallengeDefActivityTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=300;
        this.ItemDetail.itemName='ChallengeDefActivityType';
        this.ItemDetail.keyName='ChallengeDefActivityTypeId';
    }

    CreateEntity(): ChallengeDefActivityTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeDefActivityTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeDefActivityTypeEntity, ChallengeDefActivityTypeMetaDataAttributes,ChallengeDefActivityTypeMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeDefActivityTypeMetaDataAttributes();
     Relations = new ChallengeDefActivityTypeMetaDataRelations();

}


export type ChallengeDefActivityTypeQueryBuilder = DwQueryBuilderGen<ChallengeDefActivityTypeEntity, ChallengeDefActivityTypeMetaDataAttributes,ChallengeDefActivityTypeMetaDataRelations>


export class ChallengeDefActivityTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeDefActivityType';
    // Attributes
    ChallengeDefActivityTypeId = new DwItemAttribute(this.i, 'ChallengeDefActivityTypeId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    IsIncluded = new DwItemAttribute(this.i, 'IsIncluded');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IncludeInLeaderboards = new DwItemAttribute(this.i, 'IncludeInLeaderboards');
}

class ChallengeDefActivityTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ChallengeDefActivityType|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Fitness Activity Type */
            FitnessActivityType = new DwItemRelationship('FitnessActivityType|ChallengeDefActivityType|FitnessActivityTypeId', 'FitnessActivityType', 'FitnessActivityType');
    };
export class ChallengeDefinitionMetaData implements DwItem2<ChallengeDefinitionEntity, ChallengeDefinitionMetaDataAttributes,ChallengeDefinitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=172;
        this.ItemDetail.itemName='ChallengeDefinition';
        this.ItemDetail.keyName='ChallengeDefinitionId';
    }

    CreateEntity(): ChallengeDefinitionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeDefinitionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeDefinitionEntity, ChallengeDefinitionMetaDataAttributes,ChallengeDefinitionMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeDefinitionMetaDataAttributes();
     Relations = new ChallengeDefinitionMetaDataRelations();

}


export type ChallengeDefinitionQueryBuilder = DwQueryBuilderGen<ChallengeDefinitionEntity, ChallengeDefinitionMetaDataAttributes,ChallengeDefinitionMetaDataRelations>


export class ChallengeDefinitionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeDefinition';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    Name = new DwItemAttribute(this.i, 'Name');
    Description = new DwItemAttribute(this.i, 'Description');
    ChallengeEndDate = new DwItemAttribute(this.i, 'ChallengeEndDate');
    ChallengeStartDate = new DwItemAttribute(this.i, 'ChallengeStartDate');
    HasShirt = new DwItemAttribute(this.i, 'HasShirt');
    EntryFee = new DwItemAttribute(this.i, 'EntryFee');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    RegistrationStartDate = new DwItemAttribute(this.i, 'RegistrationStartDate');
    MailShirtFee = new DwItemAttribute(this.i, 'MailShirtFee');
    RegistrationEndDate = new DwItemAttribute(this.i, 'RegistrationEndDate');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    StoreStartDate = new DwItemAttribute(this.i, 'StoreStartDate');
    StoreEndDate = new DwItemAttribute(this.i, 'StoreEndDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StoreShippingMessage = new DwItemAttribute(this.i, 'StoreShippingMessage');
    AfterOrderShippingMessage = new DwItemAttribute(this.i, 'AfterOrderShippingMessage');
    GracePeriodHours = new DwItemAttribute(this.i, 'GracePeriodHours');
}

class ChallengeDefinitionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|ChallengeDefinition|ProductId', 'DwProduct', 'DwProduct');
            /** Relation: Appearance Preset */
            AppearancePreset = new DwItemRelationship('ChallengeDefinition|AppearancePreset|ChallengeDefinitionId', 'AppearancePreset', 'AppearancePreset');
            /** Relation: Badge Calculation Run */
            BadgeCalculationRun = new DwItemRelationship('ChallengeDefinition|BadgeCalculationRun|ChallengeDefinitionId', 'BadgeCalculationRun', 'BadgeCalculationRun');
            /** Relation: Badge Subject */
            BadgeSubject = new DwItemRelationship('ChallengeDefinition|BadgeSubject|ChallengeDefinitionId', 'BadgeSubject', 'BadgeSubject');
            /** Relation: Challenge Badge Configuration */
            ChallengeBadgeConfiguration = new DwItemRelationship('ChallengeDefinition|ChallengeBadgeConfiguration|ChallengeDefinitionId', 'ChallengeBadgeConfiguration', 'ChallengeBadgeConfiguration');
            /** Relation: Challenge Badge Rule */
            ChallengeBadgeRule = new DwItemRelationship('ChallengeDefinition|ChallengeBadgeRule|ChallengeDefinitionId', 'ChallengeBadgeRule', 'ChallengeBadgeRule');
            /** Relation: Challenge Def Activity Type */
            ChallengeDefActivityType = new DwItemRelationship('ChallengeDefinition|ChallengeDefActivityType|ChallengeDefinitionId', 'ChallengeDefActivityType', 'ChallengeDefActivityType');
            /** Relation: Challenge Definition Product */
            ChallengeDefinitionProduct = new DwItemRelationship('ChallengeDefinition|ChallengeDefinitionProduct|ChallengeDefinitionId', 'ChallengeDefinitionProduct', 'ChallengeDefinitionProduct');
            /** Relation: Challenge Goal */
            ChallengeGoal = new DwItemRelationship('ChallengeDefinition|ChallengeGoal|ChallengeDefinitionId', 'ChallengeGoal', 'ChallengeGoal');
            /** Relation: Challenge Media */
            ChallengeMedia = new DwItemRelationship('ChallengeDefinition|ChallengeMedia|ChallengeDefinitionId', 'ChallengeMedia', 'ChallengeMedia');
            /** Relation: Challenge Team */
            ChallengeTeam = new DwItemRelationship('ChallengeDefinition|ChallengeTeam|ChallengeDefinitionId', 'ChallengeTeam', 'ChallengeTeam');
            /** Relation: Email Challenge */
            EmailChallenge = new DwItemRelationship('ChallengeDefinition|EmailChallenge|ChallengeDefinitionId', 'EmailChallenge', 'EmailChallenge');
            /** Relation: Recipient */
            Recipient = new DwItemRelationship('ChallengeDefinition|Recipient|ChallengeDefinitionId', 'Recipient', 'Recipient');
            /** Relation: Registration Order Detail */
            RegistrationOrderDetail = new DwItemRelationship('ChallengeDefinition|RegistrationOrderDetail|ChallengeDefinitionId', 'RegistrationOrderDetail', 'RegistrationOrderDetail');
            /** Relation: Shirt Size */
            ShirtSize = new DwItemRelationship('ChallengeDefinition|ShirtSize|ChallengeDefinitionId', 'ShirtSize', 'ShirtSize');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('ChallengeDefinition|UserChallenge|ChallengeDefinitionId', 'UserChallenge', 'UserChallenge');
    };
export class ChallengeDefinitionProductMetaData implements DwItem2<ChallengeDefinitionProductEntity, ChallengeDefinitionProductMetaDataAttributes,ChallengeDefinitionProductMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=175;
        this.ItemDetail.itemName='ChallengeDefinitionProduct';
        this.ItemDetail.keyName='ChallengeDefinitionProductId';
    }

    CreateEntity(): ChallengeDefinitionProductEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeDefinitionProductQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeDefinitionProductEntity, ChallengeDefinitionProductMetaDataAttributes,ChallengeDefinitionProductMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeDefinitionProductMetaDataAttributes();
     Relations = new ChallengeDefinitionProductMetaDataRelations();

}


export type ChallengeDefinitionProductQueryBuilder = DwQueryBuilderGen<ChallengeDefinitionProductEntity, ChallengeDefinitionProductMetaDataAttributes,ChallengeDefinitionProductMetaDataRelations>


export class ChallengeDefinitionProductMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeDefinitionProduct';
    // Attributes
    ChallengeDefinitionProductId = new DwItemAttribute(this.i, 'ChallengeDefinitionProductId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    IncludedInChallenge = new DwItemAttribute(this.i, 'IncludedInChallenge');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ChallengeDefinitionProductMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ChallengeDefinitionProduct|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|ChallengeDefinitionProduct|ProductId', 'DwProduct', 'DwProduct');
    };
export class ChallengeGoalMetaData implements DwItem2<ChallengeGoalEntity, ChallengeGoalMetaDataAttributes,ChallengeGoalMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=268;
        this.ItemDetail.itemName='ChallengeGoal';
        this.ItemDetail.keyName='ChallengeGoalId';
    }

    CreateEntity(): ChallengeGoalEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeGoalQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeGoalEntity, ChallengeGoalMetaDataAttributes,ChallengeGoalMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeGoalMetaDataAttributes();
     Relations = new ChallengeGoalMetaDataRelations();

}


export type ChallengeGoalQueryBuilder = DwQueryBuilderGen<ChallengeGoalEntity, ChallengeGoalMetaDataAttributes,ChallengeGoalMetaDataRelations>


export class ChallengeGoalMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeGoal';
    // Attributes
    ChallengeGoalId = new DwItemAttribute(this.i, 'ChallengeGoalId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    Title = new DwItemAttribute(this.i, 'Title');
    Description = new DwItemAttribute(this.i, 'Description');
    MeasureKey = new DwItemAttribute(this.i, 'MeasureKey');
    TargetValue = new DwItemAttribute(this.i, 'TargetValue');
    CurrencyCode = new DwItemAttribute(this.i, 'CurrencyCode');
    ParentChallengeGoalId = new DwItemAttribute(this.i, 'ParentChallengeGoalId');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsVisible = new DwItemAttribute(this.i, 'IsVisible');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ChallengeGoalMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ChallengeGoal|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
    };
export class ChallengeMediaMetaData implements DwItem2<ChallengeMediaEntity, ChallengeMediaMetaDataAttributes,ChallengeMediaMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=179;
        this.ItemDetail.itemName='ChallengeMedia';
        this.ItemDetail.keyName='ChallengeMediaId';
    }

    CreateEntity(): ChallengeMediaEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeMediaQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeMediaEntity, ChallengeMediaMetaDataAttributes,ChallengeMediaMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeMediaMetaDataAttributes();
     Relations = new ChallengeMediaMetaDataRelations();

}


export type ChallengeMediaQueryBuilder = DwQueryBuilderGen<ChallengeMediaEntity, ChallengeMediaMetaDataAttributes,ChallengeMediaMetaDataRelations>


export class ChallengeMediaMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeMedia';
    // Attributes
    ChallengeMediaId = new DwItemAttribute(this.i, 'ChallengeMediaId');
    MediaKeyName = new DwItemAttribute(this.i, 'MediaKeyName');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
}

class ChallengeMediaMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ChallengeMedia|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
    };
export class ChallengeTeamMetaData implements DwItem2<ChallengeTeamEntity, ChallengeTeamMetaDataAttributes,ChallengeTeamMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=182;
        this.ItemDetail.itemName='ChallengeTeam';
        this.ItemDetail.keyName='ChallengeTeamId';
    }

    CreateEntity(): ChallengeTeamEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeTeamQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeTeamEntity, ChallengeTeamMetaDataAttributes,ChallengeTeamMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeTeamMetaDataAttributes();
     Relations = new ChallengeTeamMetaDataRelations();

}


export type ChallengeTeamQueryBuilder = DwQueryBuilderGen<ChallengeTeamEntity, ChallengeTeamMetaDataAttributes,ChallengeTeamMetaDataRelations>


export class ChallengeTeamMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeTeam';
    // Attributes
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    TeamDescription = new DwItemAttribute(this.i, 'TeamDescription');
    TeamPictureMediaId = new DwItemAttribute(this.i, 'TeamPictureMediaId');
    IsPrivateTeam = new DwItemAttribute(this.i, 'IsPrivateTeam');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    TeamBackgroundMediaId = new DwItemAttribute(this.i, 'TeamBackgroundMediaId');
    RequestApprovalToJoin = new DwItemAttribute(this.i, 'RequestApprovalToJoin');
    TeamLocked = new DwItemAttribute(this.i, 'TeamLocked');
    TeamLocation = new DwItemAttribute(this.i, 'TeamLocation');
    TeamJoinCode = new DwItemAttribute(this.i, 'TeamJoinCode');
    TeamSlug = new DwItemAttribute(this.i, 'TeamSlug');
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    BannerColorStart = new DwItemAttribute(this.i, 'BannerColorStart');
    BannerColorEnd = new DwItemAttribute(this.i, 'BannerColorEnd');
    BannerUseGradient = new DwItemAttribute(this.i, 'BannerUseGradient');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    BannerImageMode = new DwItemAttribute(this.i, 'BannerImageMode');
    AvatarImageMode = new DwItemAttribute(this.i, 'AvatarImageMode');
    BannerAnimationKey = new DwItemAttribute(this.i, 'BannerAnimationKey');
}

class ChallengeTeamMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Banner Animation - Banner Animation Key */
            BannerAnimationByBannerAnimationKey = new DwItemRelationship('BannerAnimation|ChallengeTeam|BannerAnimationKey', 'BannerBannerAnimation', 'BannerBannerAnimation');
            /** Relation: Appearance Preset */
            AppearancePreset = new DwItemRelationship('AppearancePreset|ChallengeTeam|AppearancePresetId', 'AppearancePreset', 'AppearancePreset');
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ChallengeTeam|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Badge Subject */
            BadgeSubject = new DwItemRelationship('ChallengeTeam|BadgeSubject|ChallengeTeamId', 'BadgeSubject', 'BadgeSubject');
            /** Relation: Badge Subject - Challenge Definition - Many */
            BadgeSubjectByChallengeDefinitionId = new DwItemRelationship('ChallengeTeam|BadgeSubject|ChallengeDefinitionId', 'ChallengeDefinitionIdBadgeSubject', 'ChallengeDefinitionIdBadgeSubject');
            /** Relation: Challenge Team Join Request */
            ChallengeTeamJoinRequest = new DwItemRelationship('ChallengeTeam|ChallengeTeamJoinRequest|ChallengeTeamId', 'ChallengeTeamJoinRequest', 'ChallengeTeamJoinRequest');
            /** Relation: Challenge Team Member */
            ChallengeTeamMember = new DwItemRelationship('ChallengeTeam|ChallengeTeamMember|ChallengeTeamId', 'ChallengeTeamMember', 'ChallengeTeamMember');
            /** Relation: Registration Order Detail */
            RegistrationOrderDetail = new DwItemRelationship('ChallengeTeam|RegistrationOrderDetail|ChallengeTeamId', 'RegistrationOrderDetail', 'RegistrationOrderDetail');
    };
export class ChallengeTeamJoinRequestMetaData implements DwItem2<ChallengeTeamJoinRequestEntity, ChallengeTeamJoinRequestMetaDataAttributes,ChallengeTeamJoinRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=186;
        this.ItemDetail.itemName='ChallengeTeamJoinRequest';
        this.ItemDetail.keyName='ChallengeTeamJoinRequestId';
    }

    CreateEntity(): ChallengeTeamJoinRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeTeamJoinRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeTeamJoinRequestEntity, ChallengeTeamJoinRequestMetaDataAttributes,ChallengeTeamJoinRequestMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeTeamJoinRequestMetaDataAttributes();
     Relations = new ChallengeTeamJoinRequestMetaDataRelations();

}


export type ChallengeTeamJoinRequestQueryBuilder = DwQueryBuilderGen<ChallengeTeamJoinRequestEntity, ChallengeTeamJoinRequestMetaDataAttributes,ChallengeTeamJoinRequestMetaDataRelations>


export class ChallengeTeamJoinRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeTeamJoinRequest';
    // Attributes
    ChallengeTeamJoinRequestId = new DwItemAttribute(this.i, 'ChallengeTeamJoinRequestId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    ChallengeTeamJoinRequestStatusId = new DwItemAttribute(this.i, 'ChallengeTeamJoinRequestStatusId');
    RequestNotes = new DwItemAttribute(this.i, 'RequestNotes');
    RejectionNotes = new DwItemAttribute(this.i, 'RejectionNotes');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ChallengeTeamJoinRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Team */
            ChallengeTeam = new DwItemRelationship('ChallengeTeam|ChallengeTeamJoinRequest|ChallengeTeamId', 'ChallengeTeam', 'ChallengeTeam');
            /** Relation: Challenge Team Join Request Status */
            ChallengeTeamJoinRequestStatus = new DwItemRelationship('ChallengeTeamJoinRequestStatus|ChallengeTeamJoinRequest|ChallengeTeamJoinRequestStatusId', 'ChallengeTeamJoinRequestStatus', 'ChallengeTeamJoinRequestStatus');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|ChallengeTeamJoinRequest|UserChallengeId', 'UserChallenge', 'UserChallenge');
    };
export class ChallengeTeamJoinRequestStatusMetaData implements DwItem2<ChallengeTeamJoinRequestStatusEntity, ChallengeTeamJoinRequestStatusMetaDataAttributes,ChallengeTeamJoinRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=188;
        this.ItemDetail.itemName='ChallengeTeamJoinRequestStatus';
        this.ItemDetail.keyName='ChallengeTeamJoinRequestStatusId';
    }

    CreateEntity(): ChallengeTeamJoinRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeTeamJoinRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeTeamJoinRequestStatusEntity, ChallengeTeamJoinRequestStatusMetaDataAttributes,ChallengeTeamJoinRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeTeamJoinRequestStatusMetaDataAttributes();
     Relations = new ChallengeTeamJoinRequestStatusMetaDataRelations();

}


export type ChallengeTeamJoinRequestStatusQueryBuilder = DwQueryBuilderGen<ChallengeTeamJoinRequestStatusEntity, ChallengeTeamJoinRequestStatusMetaDataAttributes,ChallengeTeamJoinRequestStatusMetaDataRelations>


export class ChallengeTeamJoinRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeTeamJoinRequestStatus';
    // Attributes
    ChallengeTeamJoinRequestStatusId = new DwItemAttribute(this.i, 'ChallengeTeamJoinRequestStatusId');
    RequestStatus = new DwItemAttribute(this.i, 'RequestStatus');
}

class ChallengeTeamJoinRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Team Join Request */
            ChallengeTeamJoinRequest = new DwItemRelationship('ChallengeTeamJoinRequestStatus|ChallengeTeamJoinRequest|ChallengeTeamJoinRequestStatusId', 'ChallengeTeamJoinRequest', 'ChallengeTeamJoinRequest');
    };
export class ChallengeTeamMemberMetaData implements DwItem2<ChallengeTeamMemberEntity, ChallengeTeamMemberMetaDataAttributes,ChallengeTeamMemberMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=194;
        this.ItemDetail.itemName='ChallengeTeamMember';
        this.ItemDetail.keyName='ChallengeTeamMemberId';
    }

    CreateEntity(): ChallengeTeamMemberEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChallengeTeamMemberQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChallengeTeamMemberEntity, ChallengeTeamMemberMetaDataAttributes,ChallengeTeamMemberMetaDataRelations>(query, this);
    }
     Attributes = new ChallengeTeamMemberMetaDataAttributes();
     Relations = new ChallengeTeamMemberMetaDataRelations();

}


export type ChallengeTeamMemberQueryBuilder = DwQueryBuilderGen<ChallengeTeamMemberEntity, ChallengeTeamMemberMetaDataAttributes,ChallengeTeamMemberMetaDataRelations>


export class ChallengeTeamMemberMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeTeamMember';
    // Attributes
    ChallengeTeamMemberId = new DwItemAttribute(this.i, 'ChallengeTeamMemberId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    IsTeamAdmin = new DwItemAttribute(this.i, 'IsTeamAdmin');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ChallengeTeamMemberMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Team */
            ChallengeTeam = new DwItemRelationship('ChallengeTeam|ChallengeTeamMember|ChallengeTeamId', 'ChallengeTeam', 'ChallengeTeam');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|ChallengeTeamMember|UserChallengeId', 'UserChallenge', 'UserChallenge');
    };
export class DwCodeSetMetaData implements DwItem2<DwCodeSetEntity, DwCodeSetMetaDataAttributes,DwCodeSetMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=197;
        this.ItemDetail.itemName='dw_CodeSet';
        this.ItemDetail.keyName='CodeSetId';
    }

    CreateEntity(): DwCodeSetEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwCodeSetQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwCodeSetEntity, DwCodeSetMetaDataAttributes,DwCodeSetMetaDataRelations>(query, this);
    }
     Attributes = new DwCodeSetMetaDataAttributes();
     Relations = new DwCodeSetMetaDataRelations();

}


export type DwCodeSetQueryBuilder = DwQueryBuilderGen<DwCodeSetEntity, DwCodeSetMetaDataAttributes,DwCodeSetMetaDataRelations>


export class DwCodeSetMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_CodeSet';
    // Attributes
    CodeSetId = new DwItemAttribute(this.i, 'CodeSetId');
    CodeSetName = new DwItemAttribute(this.i, 'CodeSetName');
    IsActvie = new DwItemAttribute(this.i, 'IsActvie');
    UseTransitions = new DwItemAttribute(this.i, 'UseTransitions');
    TransitionCodeSetId = new DwItemAttribute(this.i, 'TransitionCodeSetId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwCodeSetMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Code Value */
            DwCodeValue = new DwItemRelationship('dw_CodeSet|dw_CodeValue|CodeSetId', 'DwCodeValue', 'DwCodeValue');
            /** Relation: Code Value Relation - Parent - Many */
            DwCodeValueRelationByParentCodeSetId = new DwItemRelationship('dw_CodeSet|dw_CodeValueRelation|ParentCodeSetId', 'ParentDwCodeValueRelation', 'ParentDwCodeValueRelation');
            /** Relation: Code Value Relation - Child - Many */
            DwCodeValueRelationByChildCodeSetId = new DwItemRelationship('dw_CodeSet|dw_CodeValueRelation|ChildCodeSetId', 'ChildDwCodeValueRelation', 'ChildDwCodeValueRelation');
    };
export class DwCodeValueMetaData implements DwItem2<DwCodeValueEntity, DwCodeValueMetaDataAttributes,DwCodeValueMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=165;
        this.ItemDetail.itemName='dw_CodeValue';
        this.ItemDetail.keyName='CodeValueId';
    }

    CreateEntity(): DwCodeValueEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwCodeValueQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwCodeValueEntity, DwCodeValueMetaDataAttributes,DwCodeValueMetaDataRelations>(query, this);
    }
     Attributes = new DwCodeValueMetaDataAttributes();
     Relations = new DwCodeValueMetaDataRelations();

}


export type DwCodeValueQueryBuilder = DwQueryBuilderGen<DwCodeValueEntity, DwCodeValueMetaDataAttributes,DwCodeValueMetaDataRelations>


export class DwCodeValueMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_CodeValue';
    // Attributes
    CodeValueId = new DwItemAttribute(this.i, 'CodeValueId');
    CodeSetId = new DwItemAttribute(this.i, 'CodeSetId');
    Display = new DwItemAttribute(this.i, 'Display');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Description = new DwItemAttribute(this.i, 'Description');
    CodeValueOrder = new DwItemAttribute(this.i, 'CodeValueOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwCodeValueMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Code Set */
            DwCodeSet = new DwItemRelationship('dw_CodeSet|dw_CodeValue|CodeSetId', 'DwCodeSet', 'DwCodeSet');
            /** Relation: Code Value Relation - Parent - Many */
            DwCodeValueRelationByParentCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueRelation|ParentCodeValueId', 'ParentDwCodeValueRelation', 'ParentDwCodeValueRelation');
            /** Relation: Code Value Relation - Child - Many */
            DwCodeValueRelationByChildCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueRelation|ChildCodeValueId', 'ChildDwCodeValueRelation', 'ChildDwCodeValueRelation');
            /** Relation: Code Value Transition - From - Many */
            DwCodeValueTransitionByFromCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueTransition|FromCodeValueId', 'FromDwCodeValueTransition', 'FromDwCodeValueTransition');
            /** Relation: Code Value Transition - To - Many */
            DwCodeValueTransitionByToCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueTransition|ToCodeValueId', 'ToDwCodeValueTransition', 'ToDwCodeValueTransition');
            /** Relation: Code Value Transition - Parent - Many */
            DwCodeValueTransitionByParentCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueTransition|ParentCodeValueId', 'ParentDwCodeValueTransition', 'ParentDwCodeValueTransition');
    };
export class DwCodeValueRelationMetaData implements DwItem2<DwCodeValueRelationEntity, DwCodeValueRelationMetaDataAttributes,DwCodeValueRelationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=200;
        this.ItemDetail.itemName='dw_CodeValueRelation';
        this.ItemDetail.keyName='CodeValueRelationId';
    }

    CreateEntity(): DwCodeValueRelationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwCodeValueRelationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwCodeValueRelationEntity, DwCodeValueRelationMetaDataAttributes,DwCodeValueRelationMetaDataRelations>(query, this);
    }
     Attributes = new DwCodeValueRelationMetaDataAttributes();
     Relations = new DwCodeValueRelationMetaDataRelations();

}


export type DwCodeValueRelationQueryBuilder = DwQueryBuilderGen<DwCodeValueRelationEntity, DwCodeValueRelationMetaDataAttributes,DwCodeValueRelationMetaDataRelations>


export class DwCodeValueRelationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_CodeValueRelation';
    // Attributes
    CodeValueRelationId = new DwItemAttribute(this.i, 'CodeValueRelationId');
    ParentCodeSetId = new DwItemAttribute(this.i, 'ParentCodeSetId');
    ParentCodeValueId = new DwItemAttribute(this.i, 'ParentCodeValueId');
    ChildCodeSetId = new DwItemAttribute(this.i, 'ChildCodeSetId');
    ChildCodeValueId = new DwItemAttribute(this.i, 'ChildCodeValueId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwCodeValueRelationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Code Set - Parent Code Set */
            DwCodeSetByParentCodeSetId = new DwItemRelationship('dw_CodeSet|dw_CodeValueRelation|ParentCodeSetId', 'ParentDwCodeSet', 'ParentDwCodeSet');
            /** Relation: Code Set - Child Code Set */
            DwCodeSetByChildCodeSetId = new DwItemRelationship('dw_CodeSet|dw_CodeValueRelation|ChildCodeSetId', 'ChildDwCodeSet', 'ChildDwCodeSet');
            /** Relation: Code Value - Parent Code Value */
            DwCodeValueByParentCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueRelation|ParentCodeValueId', 'ParentDwCodeValue', 'ParentDwCodeValue');
            /** Relation: Code Value - Child Code Value */
            DwCodeValueByChildCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueRelation|ChildCodeValueId', 'ChildDwCodeValue', 'ChildDwCodeValue');
    };
export class DwCodeValueTransitionMetaData implements DwItem2<DwCodeValueTransitionEntity, DwCodeValueTransitionMetaDataAttributes,DwCodeValueTransitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=203;
        this.ItemDetail.itemName='dw_CodeValueTransition';
        this.ItemDetail.keyName='CodeValueTransitionId';
    }

    CreateEntity(): DwCodeValueTransitionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwCodeValueTransitionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwCodeValueTransitionEntity, DwCodeValueTransitionMetaDataAttributes,DwCodeValueTransitionMetaDataRelations>(query, this);
    }
     Attributes = new DwCodeValueTransitionMetaDataAttributes();
     Relations = new DwCodeValueTransitionMetaDataRelations();

}


export type DwCodeValueTransitionQueryBuilder = DwQueryBuilderGen<DwCodeValueTransitionEntity, DwCodeValueTransitionMetaDataAttributes,DwCodeValueTransitionMetaDataRelations>


export class DwCodeValueTransitionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_CodeValueTransition';
    // Attributes
    CodeValueTransitionId = new DwItemAttribute(this.i, 'CodeValueTransitionId');
    FromCodeValueId = new DwItemAttribute(this.i, 'FromCodeValueId');
    ToCodeValueId = new DwItemAttribute(this.i, 'ToCodeValueId');
    CanTransitionPermission = new DwItemAttribute(this.i, 'CanTransitionPermission');
    ParentCodeValueId = new DwItemAttribute(this.i, 'ParentCodeValueId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwCodeValueTransitionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Code Value - From Code Value */
            DwCodeValueByFromCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueTransition|FromCodeValueId', 'FromDwCodeValue', 'FromDwCodeValue');
            /** Relation: Code Value - To Code Value */
            DwCodeValueByToCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueTransition|ToCodeValueId', 'ToDwCodeValue', 'ToDwCodeValue');
            /** Relation: Code Value - Parent Code Value */
            DwCodeValueByParentCodeValueId = new DwItemRelationship('dw_CodeValue|dw_CodeValueTransition|ParentCodeValueId', 'ParentDwCodeValue', 'ParentDwCodeValue');
    };
export class DwCountryMetaData implements DwItem2<DwCountryEntity, DwCountryMetaDataAttributes,DwCountryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=254;
        this.ItemDetail.itemName='dw_Country';
        this.ItemDetail.keyName='CountryId';
    }

    CreateEntity(): DwCountryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwCountryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwCountryEntity, DwCountryMetaDataAttributes,DwCountryMetaDataRelations>(query, this);
    }
     Attributes = new DwCountryMetaDataAttributes();
     Relations = new DwCountryMetaDataRelations();

}


export type DwCountryQueryBuilder = DwQueryBuilderGen<DwCountryEntity, DwCountryMetaDataAttributes,DwCountryMetaDataRelations>


export class DwCountryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Country';
    // Attributes
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    CountryName = new DwItemAttribute(this.i, 'CountryName');
    CountryShortName = new DwItemAttribute(this.i, 'CountryShortName');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class DwCountryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address */
            DwAddress = new DwItemRelationship('dw_Country|dw_Address|CountryId', 'DwAddress', 'DwAddress');
            /** Relation: Shipping Rate */
            DwShippingRate = new DwItemRelationship('dw_Country|dw_ShippingRate|CountryId', 'DwShippingRate', 'DwShippingRate');
            /** Relation: State Province */
            DwStateProvince = new DwItemRelationship('dw_Country|dw_StateProvince|CountryId', 'DwStateProvince', 'DwStateProvince');
    };
export class EmailChallengeMetaData implements DwItem2<EmailChallengeEntity, EmailChallengeMetaDataAttributes,EmailChallengeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=206;
        this.ItemDetail.itemName='EmailChallenge';
        this.ItemDetail.keyName='EmailChallengeId';
    }

    CreateEntity(): EmailChallengeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EmailChallengeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EmailChallengeEntity, EmailChallengeMetaDataAttributes,EmailChallengeMetaDataRelations>(query, this);
    }
     Attributes = new EmailChallengeMetaDataAttributes();
     Relations = new EmailChallengeMetaDataRelations();

}


export type EmailChallengeQueryBuilder = DwQueryBuilderGen<EmailChallengeEntity, EmailChallengeMetaDataAttributes,EmailChallengeMetaDataRelations>


export class EmailChallengeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'EmailChallenge';
    // Attributes
    EmailChallengeId = new DwItemAttribute(this.i, 'EmailChallengeId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    FriendName = new DwItemAttribute(this.i, 'FriendName');
    FriendEmail = new DwItemAttribute(this.i, 'FriendEmail');
    EmailSent = new DwItemAttribute(this.i, 'EmailSent');
    EmailSentDateTime = new DwItemAttribute(this.i, 'EmailSentDateTime');
    Registered = new DwItemAttribute(this.i, 'Registered');
    RegisteredUserId = new DwItemAttribute(this.i, 'RegisteredUserId');
    RegisteredDateTime = new DwItemAttribute(this.i, 'RegisteredDateTime');
    NameMatch = new DwItemAttribute(this.i, 'NameMatch');
    CodeMatch = new DwItemAttribute(this.i, 'CodeMatch');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ExcludeFromStats = new DwItemAttribute(this.i, 'ExcludeFromStats');
}

class EmailChallengeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|EmailChallenge|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: User - Registered User */
            DwUserByRegisteredUserId = new DwItemRelationship('dw_User|EmailChallenge|RegisteredUserId', 'RegisteredDwUser', 'RegisteredDwUser');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|EmailChallenge|UserId', 'DwUser', 'DwUser');
    };
export class FitnessActivityMetaData implements DwItem2<FitnessActivityEntity, FitnessActivityMetaDataAttributes,FitnessActivityMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=157;
        this.ItemDetail.itemName='FitnessActivity';
        this.ItemDetail.keyName='FitnessActivityId';
    }

    CreateEntity(): FitnessActivityEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FitnessActivityQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FitnessActivityEntity, FitnessActivityMetaDataAttributes,FitnessActivityMetaDataRelations>(query, this);
    }
     Attributes = new FitnessActivityMetaDataAttributes();
     Relations = new FitnessActivityMetaDataRelations();

}


export type FitnessActivityQueryBuilder = DwQueryBuilderGen<FitnessActivityEntity, FitnessActivityMetaDataAttributes,FitnessActivityMetaDataRelations>


export class FitnessActivityMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FitnessActivity';
    // Attributes
    FitnessActivityId = new DwItemAttribute(this.i, 'FitnessActivityId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    Name = new DwItemAttribute(this.i, 'Name');
    ActivityDate = new DwItemAttribute(this.i, 'ActivityDate');
    StartTime = new DwItemAttribute(this.i, 'StartTime');
    DurationSeconds = new DwItemAttribute(this.i, 'DurationSeconds');
    CaloriesKCal = new DwItemAttribute(this.i, 'CaloriesKCal');
    DistanceMeters = new DwItemAttribute(this.i, 'DistanceMeters');
    DistanceUnitOfMeasureId = new DwItemAttribute(this.i, 'DistanceUnitOfMeasureId');
    Laps = new DwItemAttribute(this.i, 'Laps');
    LapLengthMeters = new DwItemAttribute(this.i, 'LapLengthMeters');
    LapUnitOfMeasureId = new DwItemAttribute(this.i, 'LapUnitOfMeasureId');
    AverageHeartRate = new DwItemAttribute(this.i, 'AverageHeartRate');
    AveragePaceMetersPerSecond = new DwItemAttribute(this.i, 'AveragePaceMetersPerSecond');
    Steps = new DwItemAttribute(this.i, 'Steps');
    ElevationGainMeters = new DwItemAttribute(this.i, 'ElevationGainMeters');
    ElevationGainUnitOfMeasureId = new DwItemAttribute(this.i, 'ElevationGainUnitOfMeasureId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ActivityPictureMediaId = new DwItemAttribute(this.i, 'ActivityPictureMediaId');
    Comments = new DwItemAttribute(this.i, 'Comments');
    ActivityCount = new DwItemAttribute(this.i, 'ActivityCount');
}

class FitnessActivityMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Fitness Activity Type */
            FitnessActivityType = new DwItemRelationship('FitnessActivityType|FitnessActivity|FitnessActivityTypeId', 'FitnessActivityType', 'FitnessActivityType');
            /** Relation: Unit Of Measure - Distance Unit Of Measure */
            UnitOfMeasureByDistanceUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivity|DistanceUnitOfMeasureId', 'DistanceUnitOfMeasure', 'DistanceUnitOfMeasure');
            /** Relation: Unit Of Measure - Lap Unit Of Measure */
            UnitOfMeasureByLapUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivity|LapUnitOfMeasureId', 'LapUnitOfMeasure', 'LapUnitOfMeasure');
            /** Relation: Unit Of Measure - Elevation Gain Unit Of Measure */
            UnitOfMeasureByElevationGainUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivity|ElevationGainUnitOfMeasureId', 'ElevationGainUnitOfMeasure', 'ElevationGainUnitOfMeasure');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|FitnessActivity|UserChallengeId', 'UserChallenge', 'UserChallenge');
            /** Relation: User Challenge Comment */
            UserChallengeComment = new DwItemRelationship('FitnessActivity|UserChallengeComment|FitnessActivityId', 'UserChallengeComment', 'UserChallengeComment');
    };
export class FitnessActivityDisplayGroupMetaData implements DwItem2<FitnessActivityDisplayGroupEntity, FitnessActivityDisplayGroupMetaDataAttributes,FitnessActivityDisplayGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=159;
        this.ItemDetail.itemName='FitnessActivityDisplayGroup';
        this.ItemDetail.keyName='FitnessActivityDisplayGroupId';
    }

    CreateEntity(): FitnessActivityDisplayGroupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FitnessActivityDisplayGroupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FitnessActivityDisplayGroupEntity, FitnessActivityDisplayGroupMetaDataAttributes,FitnessActivityDisplayGroupMetaDataRelations>(query, this);
    }
     Attributes = new FitnessActivityDisplayGroupMetaDataAttributes();
     Relations = new FitnessActivityDisplayGroupMetaDataRelations();

}


export type FitnessActivityDisplayGroupQueryBuilder = DwQueryBuilderGen<FitnessActivityDisplayGroupEntity, FitnessActivityDisplayGroupMetaDataAttributes,FitnessActivityDisplayGroupMetaDataRelations>


export class FitnessActivityDisplayGroupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FitnessActivityDisplayGroup';
    // Attributes
    FitnessActivityDisplayGroupId = new DwItemAttribute(this.i, 'FitnessActivityDisplayGroupId');
    ShowDuration = new DwItemAttribute(this.i, 'ShowDuration');
    ShowCalories = new DwItemAttribute(this.i, 'ShowCalories');
    ShowDistance = new DwItemAttribute(this.i, 'ShowDistance');
    ShowLaps = new DwItemAttribute(this.i, 'ShowLaps');
    ShowAverageHeattRate = new DwItemAttribute(this.i, 'ShowAverageHeattRate');
    ShowPace = new DwItemAttribute(this.i, 'ShowPace');
    ShowSteps = new DwItemAttribute(this.i, 'ShowSteps');
    ShowElevationGain = new DwItemAttribute(this.i, 'ShowElevationGain');
    DisplayGroupName = new DwItemAttribute(this.i, 'DisplayGroupName');
    ShowLapLength = new DwItemAttribute(this.i, 'ShowLapLength');
    DefaultUnitOfMeasureId = new DwItemAttribute(this.i, 'DefaultUnitOfMeasureId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ShowCount = new DwItemAttribute(this.i, 'ShowCount');
}

class FitnessActivityDisplayGroupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Unit Of Measure - Default Unit Of Measure */
            UnitOfMeasureByDefaultUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivityDisplayGroup|DefaultUnitOfMeasureId', 'DefaultUnitOfMeasure', 'DefaultUnitOfMeasure');
            /** Relation: Fitness Activity Display Group U O M */
            FitnessActivityDisplayGroupUOM = new DwItemRelationship('FitnessActivityDisplayGroup|FitnessActivityDisplayGroupUOM|FitnessActivityDisplayGroupId', 'FitnessActivityDisplayGroupUOM', 'FitnessActivityDisplayGroupUOM');
            /** Relation: Fitness Activity Type - Fitness Activity Group - Many */
            FitnessActivityTypeByFitnessActivityGroupId = new DwItemRelationship('FitnessActivityDisplayGroup|FitnessActivityType|FitnessActivityGroupId', 'FitnessActivityGroupIdFitnessActivityType', 'FitnessActivityGroupIdFitnessActivityType');
    };
export class FitnessActivityDisplayGroupUOMMetaData implements DwItem2<FitnessActivityDisplayGroupUOMEntity, FitnessActivityDisplayGroupUOMMetaDataAttributes,FitnessActivityDisplayGroupUOMMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=163;
        this.ItemDetail.itemName='FitnessActivityDisplayGroupUOM';
        this.ItemDetail.keyName='FitnessActivityDisplayGroupUOMId';
    }

    CreateEntity(): FitnessActivityDisplayGroupUOMEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FitnessActivityDisplayGroupUOMQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FitnessActivityDisplayGroupUOMEntity, FitnessActivityDisplayGroupUOMMetaDataAttributes,FitnessActivityDisplayGroupUOMMetaDataRelations>(query, this);
    }
     Attributes = new FitnessActivityDisplayGroupUOMMetaDataAttributes();
     Relations = new FitnessActivityDisplayGroupUOMMetaDataRelations();

}


export type FitnessActivityDisplayGroupUOMQueryBuilder = DwQueryBuilderGen<FitnessActivityDisplayGroupUOMEntity, FitnessActivityDisplayGroupUOMMetaDataAttributes,FitnessActivityDisplayGroupUOMMetaDataRelations>


export class FitnessActivityDisplayGroupUOMMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FitnessActivityDisplayGroupUOM';
    // Attributes
    FitnessActivityDisplayGroupUOMId = new DwItemAttribute(this.i, 'FitnessActivityDisplayGroupUOMId');
    FitnessActivityDisplayGroupId = new DwItemAttribute(this.i, 'FitnessActivityDisplayGroupId');
    UnitOfMeasureId = new DwItemAttribute(this.i, 'UnitOfMeasureId');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FitnessActivityDisplayGroupUOMMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Fitness Activity Display Group */
            FitnessActivityDisplayGroup = new DwItemRelationship('FitnessActivityDisplayGroup|FitnessActivityDisplayGroupUOM|FitnessActivityDisplayGroupId', 'FitnessActivityDisplayGroup', 'FitnessActivityDisplayGroup');
            /** Relation: Unit Of Measure */
            UnitOfMeasure = new DwItemRelationship('UnitOfMeasure|FitnessActivityDisplayGroupUOM|UnitOfMeasureId', 'UnitOfMeasure', 'UnitOfMeasure');
    };
export class FitnessActivityTypeMetaData implements DwItem2<FitnessActivityTypeEntity, FitnessActivityTypeMetaDataAttributes,FitnessActivityTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=209;
        this.ItemDetail.itemName='FitnessActivityType';
        this.ItemDetail.keyName='FitnessActivityTypeId';
    }

    CreateEntity(): FitnessActivityTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FitnessActivityTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FitnessActivityTypeEntity, FitnessActivityTypeMetaDataAttributes,FitnessActivityTypeMetaDataRelations>(query, this);
    }
     Attributes = new FitnessActivityTypeMetaDataAttributes();
     Relations = new FitnessActivityTypeMetaDataRelations();

}


export type FitnessActivityTypeQueryBuilder = DwQueryBuilderGen<FitnessActivityTypeEntity, FitnessActivityTypeMetaDataAttributes,FitnessActivityTypeMetaDataRelations>


export class FitnessActivityTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FitnessActivityType';
    // Attributes
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    ActivityTypeName = new DwItemAttribute(this.i, 'ActivityTypeName');
    ActivityTypeDescription = new DwItemAttribute(this.i, 'ActivityTypeDescription');
    IconCss = new DwItemAttribute(this.i, 'IconCss');
    FitnessActivityGroupId = new DwItemAttribute(this.i, 'FitnessActivityGroupId');
    ActivityDisplayPresent = new DwItemAttribute(this.i, 'ActivityDisplayPresent');
    ActivityDisplayPast = new DwItemAttribute(this.i, 'ActivityDisplayPast');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CountDisplay = new DwItemAttribute(this.i, 'CountDisplay');
    IsStandard = new DwItemAttribute(this.i, 'IsStandard');
    IncludeInLeaderboards = new DwItemAttribute(this.i, 'IncludeInLeaderboards');
}

class FitnessActivityTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Fitness Activity Display Group - Fitness Activity Group */
            FitnessActivityDisplayGroupByFitnessActivityGroupId = new DwItemRelationship('FitnessActivityDisplayGroup|FitnessActivityType|FitnessActivityGroupId', 'FitnessActivityGroupIdFitnessActivityDisplayGroup', 'FitnessActivityGroupIdFitnessActivityDisplayGroup');
            /** Relation: Challenge Badge Rule */
            ChallengeBadgeRule = new DwItemRelationship('FitnessActivityType|ChallengeBadgeRule|FitnessActivityTypeId', 'ChallengeBadgeRule', 'ChallengeBadgeRule');
            /** Relation: Challenge Def Activity Type */
            ChallengeDefActivityType = new DwItemRelationship('FitnessActivityType|ChallengeDefActivityType|FitnessActivityTypeId', 'ChallengeDefActivityType', 'ChallengeDefActivityType');
            /** Relation: Fitness Activity */
            FitnessActivity = new DwItemRelationship('FitnessActivityType|FitnessActivity|FitnessActivityTypeId', 'FitnessActivity', 'FitnessActivity');
            /** Relation: User Fitness Summary Rollup */
            UserFitnessSummaryRollup = new DwItemRelationship('FitnessActivityType|UserFitnessSummaryRollup|FitnessActivityTypeId', 'UserFitnessSummaryRollup', 'UserFitnessSummaryRollup');
    };
export class InformationRequestMetaData implements DwItem2<InformationRequestEntity, InformationRequestMetaDataAttributes,InformationRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=204;
        this.ItemDetail.itemName='InformationRequest';
        this.ItemDetail.keyName='InformationRequestId';
    }

    CreateEntity(): InformationRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InformationRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InformationRequestEntity, InformationRequestMetaDataAttributes,InformationRequestMetaDataRelations>(query, this);
    }
     Attributes = new InformationRequestMetaDataAttributes();
     Relations = new InformationRequestMetaDataRelations();

}


export type InformationRequestQueryBuilder = DwQueryBuilderGen<InformationRequestEntity, InformationRequestMetaDataAttributes,InformationRequestMetaDataRelations>


export class InformationRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InformationRequest';
    // Attributes
    InformationRequestId = new DwItemAttribute(this.i, 'InformationRequestId');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    Email = new DwItemAttribute(this.i, 'Email');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    Comments = new DwItemAttribute(this.i, 'Comments');
}

class InformationRequestMetaDataRelations implements DwItemRelationshipCollection {
    };
export class LeaderboardEntryMetaData implements DwItem2<LeaderboardEntryEntity, LeaderboardEntryMetaDataAttributes,LeaderboardEntryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=283;
        this.ItemDetail.itemName='LeaderboardEntry';
        this.ItemDetail.keyName='LeaderboardEntryId';
    }

    CreateEntity(): LeaderboardEntryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): LeaderboardEntryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<LeaderboardEntryEntity, LeaderboardEntryMetaDataAttributes,LeaderboardEntryMetaDataRelations>(query, this);
    }
     Attributes = new LeaderboardEntryMetaDataAttributes();
     Relations = new LeaderboardEntryMetaDataRelations();

}


export type LeaderboardEntryQueryBuilder = DwQueryBuilderGen<LeaderboardEntryEntity, LeaderboardEntryMetaDataAttributes,LeaderboardEntryMetaDataRelations>


export class LeaderboardEntryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'LeaderboardEntry';
    // Attributes
    LeaderboardEntryId = new DwItemAttribute(this.i, 'LeaderboardEntryId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeDefinitionId = new DwItemAttribute(this.i, 'BadgeDefinitionId');
    BadgeRecipientTypeId = new DwItemAttribute(this.i, 'BadgeRecipientTypeId');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    LeaderboardSnapshotId = new DwItemAttribute(this.i, 'LeaderboardSnapshotId');
    BadgeCalculationRunId = new DwItemAttribute(this.i, 'BadgeCalculationRunId');
    ChallengeBadgeRuleId = new DwItemAttribute(this.i, 'ChallengeBadgeRuleId');
    BadgeSubjectId = new DwItemAttribute(this.i, 'BadgeSubjectId');
    MetricTotal = new DwItemAttribute(this.i, 'MetricTotal');
    MemberCount = new DwItemAttribute(this.i, 'MemberCount');
    ContributorCount = new DwItemAttribute(this.i, 'ContributorCount');
    ScoreValue = new DwItemAttribute(this.i, 'ScoreValue');
    RankPosition = new DwItemAttribute(this.i, 'RankPosition');
    BadgeTierId = new DwItemAttribute(this.i, 'BadgeTierId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class LeaderboardEntryMetaDataRelations implements DwItemRelationshipCollection {
    };
export class LeaderboardSnapshotMetaData implements DwItem2<LeaderboardSnapshotEntity, LeaderboardSnapshotMetaDataAttributes,LeaderboardSnapshotMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=296;
        this.ItemDetail.itemName='LeaderboardSnapshot';
        this.ItemDetail.keyName='LeaderboardSnapshotId';
    }

    CreateEntity(): LeaderboardSnapshotEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): LeaderboardSnapshotQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<LeaderboardSnapshotEntity, LeaderboardSnapshotMetaDataAttributes,LeaderboardSnapshotMetaDataRelations>(query, this);
    }
     Attributes = new LeaderboardSnapshotMetaDataAttributes();
     Relations = new LeaderboardSnapshotMetaDataRelations();

}


export type LeaderboardSnapshotQueryBuilder = DwQueryBuilderGen<LeaderboardSnapshotEntity, LeaderboardSnapshotMetaDataAttributes,LeaderboardSnapshotMetaDataRelations>


export class LeaderboardSnapshotMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'LeaderboardSnapshot';
    // Attributes
    LeaderboardSnapshotId = new DwItemAttribute(this.i, 'LeaderboardSnapshotId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeDefinitionId = new DwItemAttribute(this.i, 'BadgeDefinitionId');
    BadgeRecipientTypeId = new DwItemAttribute(this.i, 'BadgeRecipientTypeId');
    BadgeAwardModeId = new DwItemAttribute(this.i, 'BadgeAwardModeId');
    BadgeCalculationRunId = new DwItemAttribute(this.i, 'BadgeCalculationRunId');
    ChallengeBadgeRuleId = new DwItemAttribute(this.i, 'ChallengeBadgeRuleId');
    ScorePeriodStartDate = new DwItemAttribute(this.i, 'ScorePeriodStartDate');
    ScoreThroughDate = new DwItemAttribute(this.i, 'ScoreThroughDate');
    BadgeMetricTypeId = new DwItemAttribute(this.i, 'BadgeMetricTypeId');
    UnitKey = new DwItemAttribute(this.i, 'UnitKey');
    BadgeTeamAggregationTypeId = new DwItemAttribute(this.i, 'BadgeTeamAggregationTypeId');
    BadgeTiePolicyId = new DwItemAttribute(this.i, 'BadgeTiePolicyId');
    EligibleSubjectCount = new DwItemAttribute(this.i, 'EligibleSubjectCount');
    ConfigurationRevision = new DwItemAttribute(this.i, 'ConfigurationRevision');
    CalculationCompletedDateTime = new DwItemAttribute(this.i, 'CalculationCompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class LeaderboardSnapshotMetaDataRelations implements DwItemRelationshipCollection {
    };
export class MarketingSourceMetaData implements DwItem2<MarketingSourceEntity, MarketingSourceMetaDataAttributes,MarketingSourceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=212;
        this.ItemDetail.itemName='MarketingSource';
        this.ItemDetail.keyName='MarketingSourceId';
    }

    CreateEntity(): MarketingSourceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MarketingSourceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MarketingSourceEntity, MarketingSourceMetaDataAttributes,MarketingSourceMetaDataRelations>(query, this);
    }
     Attributes = new MarketingSourceMetaDataAttributes();
     Relations = new MarketingSourceMetaDataRelations();

}


export type MarketingSourceQueryBuilder = DwQueryBuilderGen<MarketingSourceEntity, MarketingSourceMetaDataAttributes,MarketingSourceMetaDataRelations>


export class MarketingSourceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MarketingSource';
    // Attributes
    MarketingSourceId = new DwItemAttribute(this.i, 'MarketingSourceId');
    Display = new DwItemAttribute(this.i, 'Display');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Description = new DwItemAttribute(this.i, 'Description');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class MarketingSourceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Challenge - Cv - Many */
            UserChallengeByMarketingSourceCv = new DwItemRelationship('MarketingSource|UserChallenge|MarketingSourceCv', 'MarketingSourceCvUserChallenge', 'MarketingSourceCvUserChallenge');
    };
export class MediaCommentTypeMetaData implements DwItem2<MediaCommentTypeEntity, MediaCommentTypeMetaDataAttributes,MediaCommentTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=177;
        this.ItemDetail.itemName='MediaCommentType';
        this.ItemDetail.keyName='MediaCommentTypeId';
    }

    CreateEntity(): MediaCommentTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MediaCommentTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MediaCommentTypeEntity, MediaCommentTypeMetaDataAttributes,MediaCommentTypeMetaDataRelations>(query, this);
    }
     Attributes = new MediaCommentTypeMetaDataAttributes();
     Relations = new MediaCommentTypeMetaDataRelations();

}


export type MediaCommentTypeQueryBuilder = DwQueryBuilderGen<MediaCommentTypeEntity, MediaCommentTypeMetaDataAttributes,MediaCommentTypeMetaDataRelations>


export class MediaCommentTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MediaCommentType';
    // Attributes
    MediaCommentTypeId = new DwItemAttribute(this.i, 'MediaCommentTypeId');
    CommentType = new DwItemAttribute(this.i, 'CommentType');
    CommentTypeIconCss = new DwItemAttribute(this.i, 'CommentTypeIconCss');
}

class MediaCommentTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media Post Comment */
            MediaPostComment = new DwItemRelationship('MediaCommentType|MediaPostComment|MediaCommentTypeId', 'MediaPostComment', 'MediaPostComment');
    };
export class MediaPostMetaData implements DwItem2<MediaPostEntity, MediaPostMetaDataAttributes,MediaPostMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=181;
        this.ItemDetail.itemName='MediaPost';
        this.ItemDetail.keyName='MediaPostId';
    }

    CreateEntity(): MediaPostEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MediaPostQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MediaPostEntity, MediaPostMetaDataAttributes,MediaPostMetaDataRelations>(query, this);
    }
     Attributes = new MediaPostMetaDataAttributes();
     Relations = new MediaPostMetaDataRelations();

}


export type MediaPostQueryBuilder = DwQueryBuilderGen<MediaPostEntity, MediaPostMetaDataAttributes,MediaPostMetaDataRelations>


export class MediaPostMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MediaPost';
    // Attributes
    MediaPostId = new DwItemAttribute(this.i, 'MediaPostId');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
    PostTitle = new DwItemAttribute(this.i, 'PostTitle');
    PostBody = new DwItemAttribute(this.i, 'PostBody');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    UserId = new DwItemAttribute(this.i, 'UserId');
}

class MediaPostMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|MediaPost|UserId', 'DwUser', 'DwUser');
            /** Relation: Media Post Comment */
            MediaPostComment = new DwItemRelationship('MediaPost|MediaPostComment|MediaPostId', 'MediaPostComment', 'MediaPostComment');
    };
export class MediaPostCommentMetaData implements DwItem2<MediaPostCommentEntity, MediaPostCommentMetaDataAttributes,MediaPostCommentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=178;
        this.ItemDetail.itemName='MediaPostComment';
        this.ItemDetail.keyName='MediaPostCommentId';
    }

    CreateEntity(): MediaPostCommentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MediaPostCommentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MediaPostCommentEntity, MediaPostCommentMetaDataAttributes,MediaPostCommentMetaDataRelations>(query, this);
    }
     Attributes = new MediaPostCommentMetaDataAttributes();
     Relations = new MediaPostCommentMetaDataRelations();

}


export type MediaPostCommentQueryBuilder = DwQueryBuilderGen<MediaPostCommentEntity, MediaPostCommentMetaDataAttributes,MediaPostCommentMetaDataRelations>


export class MediaPostCommentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MediaPostComment';
    // Attributes
    MediaPostCommentId = new DwItemAttribute(this.i, 'MediaPostCommentId');
    MediaPostId = new DwItemAttribute(this.i, 'MediaPostId');
    MediaCommentTypeId = new DwItemAttribute(this.i, 'MediaCommentTypeId');
    Comment = new DwItemAttribute(this.i, 'Comment');
}

class MediaPostCommentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media Comment Type */
            MediaCommentType = new DwItemRelationship('MediaCommentType|MediaPostComment|MediaCommentTypeId', 'MediaCommentType', 'MediaCommentType');
            /** Relation: Media Post */
            MediaPost = new DwItemRelationship('MediaPost|MediaPostComment|MediaPostId', 'MediaPost', 'MediaPost');
    };
export class DwOrderMetaData implements DwItem2<DwOrderEntity, DwOrderMetaDataAttributes,DwOrderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=185;
        this.ItemDetail.itemName='dw_Order';
        this.ItemDetail.keyName='OrderId';
    }

    CreateEntity(): DwOrderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwOrderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwOrderEntity, DwOrderMetaDataAttributes,DwOrderMetaDataRelations>(query, this);
    }
     Attributes = new DwOrderMetaDataAttributes();
     Relations = new DwOrderMetaDataRelations();

}


export type DwOrderQueryBuilder = DwQueryBuilderGen<DwOrderEntity, DwOrderMetaDataAttributes,DwOrderMetaDataRelations>


export class DwOrderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Order';
    // Attributes
    OrderId = new DwItemAttribute(this.i, 'OrderId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    OrderStatusId = new DwItemAttribute(this.i, 'OrderStatusId');
    BillingAddressId = new DwItemAttribute(this.i, 'BillingAddressId');
    ShippingAddressSameAsBilling = new DwItemAttribute(this.i, 'ShippingAddressSameAsBilling');
    ShippingAddressId = new DwItemAttribute(this.i, 'ShippingAddressId');
    UserPaymentId = new DwItemAttribute(this.i, 'UserPaymentId');
    SubTotalAmount = new DwItemAttribute(this.i, 'SubTotalAmount');
    ShippingAmount = new DwItemAttribute(this.i, 'ShippingAmount');
    TotalAmount = new DwItemAttribute(this.i, 'TotalAmount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OrderBatchId = new DwItemAttribute(this.i, 'OrderBatchId');
    ProcessedDateTime = new DwItemAttribute(this.i, 'ProcessedDateTime');
    ProcessingEmailSent = new DwItemAttribute(this.i, 'ProcessingEmailSent');
    ShippedDateTime = new DwItemAttribute(this.i, 'ShippedDateTime');
    ShippedEmailSent = new DwItemAttribute(this.i, 'ShippedEmailSent');
    DiscountAmount = new DwItemAttribute(this.i, 'DiscountAmount');
    PromotionCode = new DwItemAttribute(this.i, 'PromotionCode');
}

class DwOrderMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Billing Address */
            DwAddressByBillingAddressId = new DwItemRelationship('dw_Address|dw_Order|BillingAddressId', 'BillingDwAddress', 'BillingDwAddress');
            /** Relation: Address - Shipping Address */
            DwAddressByShippingAddressId = new DwItemRelationship('dw_Address|dw_Order|ShippingAddressId', 'ShippingDwAddress', 'ShippingDwAddress');
            /** Relation: Order Batch */
            DwOrderBatch = new DwItemRelationship('dw_OrderBatch|dw_Order|OrderBatchId', 'DwOrderBatch', 'DwOrderBatch');
            /** Relation: Order Status */
            DwOrderStatus = new DwItemRelationship('dw_OrderStatus|dw_Order|OrderStatusId', 'DwOrderStatus', 'DwOrderStatus');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|dw_Order|UserId', 'DwUser', 'DwUser');
            /** Relation: User Payment */
            DwUserPayment = new DwItemRelationship('dw_UserPayment|dw_Order|UserPaymentId', 'DwUserPayment', 'DwUserPayment');
            /** Relation: Order Detail */
            DwOrderDetail = new DwItemRelationship('dw_Order|dw_OrderDetail|OrderId', 'DwOrderDetail', 'DwOrderDetail');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('dw_Order|UserChallenge|OrderId', 'UserChallenge', 'UserChallenge');
    };
export class DwOrderBatchMetaData implements DwItem2<DwOrderBatchEntity, DwOrderBatchMetaDataAttributes,DwOrderBatchMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=183;
        this.ItemDetail.itemName='dw_OrderBatch';
        this.ItemDetail.keyName='OrderBatchId';
    }

    CreateEntity(): DwOrderBatchEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwOrderBatchQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwOrderBatchEntity, DwOrderBatchMetaDataAttributes,DwOrderBatchMetaDataRelations>(query, this);
    }
     Attributes = new DwOrderBatchMetaDataAttributes();
     Relations = new DwOrderBatchMetaDataRelations();

}


export type DwOrderBatchQueryBuilder = DwQueryBuilderGen<DwOrderBatchEntity, DwOrderBatchMetaDataAttributes,DwOrderBatchMetaDataRelations>


export class DwOrderBatchMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_OrderBatch';
    // Attributes
    OrderBatchId = new DwItemAttribute(this.i, 'OrderBatchId');
    BatchName = new DwItemAttribute(this.i, 'BatchName');
    OrderBatchStatusId = new DwItemAttribute(this.i, 'OrderBatchStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwOrderBatchMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Order Batch Status */
            DwOrderBatchStatus = new DwItemRelationship('dw_OrderBatchStatus|dw_OrderBatch|OrderBatchStatusId', 'DwOrderBatchStatus', 'DwOrderBatchStatus');
            /** Relation: Order */
            DwOrder = new DwItemRelationship('dw_OrderBatch|dw_Order|OrderBatchId', 'DwOrder', 'DwOrder');
    };
export class DwOrderBatchStatusMetaData implements DwItem2<DwOrderBatchStatusEntity, DwOrderBatchStatusMetaDataAttributes,DwOrderBatchStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=195;
        this.ItemDetail.itemName='dw_OrderBatchStatus';
        this.ItemDetail.keyName='OrderBatchStatusId';
    }

    CreateEntity(): DwOrderBatchStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwOrderBatchStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwOrderBatchStatusEntity, DwOrderBatchStatusMetaDataAttributes,DwOrderBatchStatusMetaDataRelations>(query, this);
    }
     Attributes = new DwOrderBatchStatusMetaDataAttributes();
     Relations = new DwOrderBatchStatusMetaDataRelations();

}


export type DwOrderBatchStatusQueryBuilder = DwQueryBuilderGen<DwOrderBatchStatusEntity, DwOrderBatchStatusMetaDataAttributes,DwOrderBatchStatusMetaDataRelations>


export class DwOrderBatchStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_OrderBatchStatus';
    // Attributes
    OrderBatchStatusId = new DwItemAttribute(this.i, 'OrderBatchStatusId');
    BatchStatus = new DwItemAttribute(this.i, 'BatchStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwOrderBatchStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Order Batch */
            DwOrderBatch = new DwItemRelationship('dw_OrderBatchStatus|dw_OrderBatch|OrderBatchStatusId', 'DwOrderBatch', 'DwOrderBatch');
    };
export class DwOrderDetailMetaData implements DwItem2<DwOrderDetailEntity, DwOrderDetailMetaDataAttributes,DwOrderDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=198;
        this.ItemDetail.itemName='dw_OrderDetail';
        this.ItemDetail.keyName='OrderDetailId';
    }

    CreateEntity(): DwOrderDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwOrderDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwOrderDetailEntity, DwOrderDetailMetaDataAttributes,DwOrderDetailMetaDataRelations>(query, this);
    }
     Attributes = new DwOrderDetailMetaDataAttributes();
     Relations = new DwOrderDetailMetaDataRelations();

}


export type DwOrderDetailQueryBuilder = DwQueryBuilderGen<DwOrderDetailEntity, DwOrderDetailMetaDataAttributes,DwOrderDetailMetaDataRelations>


export class DwOrderDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_OrderDetail';
    // Attributes
    OrderDetailId = new DwItemAttribute(this.i, 'OrderDetailId');
    OrderId = new DwItemAttribute(this.i, 'OrderId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    ProductSizeId = new DwItemAttribute(this.i, 'ProductSizeId');
    ProductColorId = new DwItemAttribute(this.i, 'ProductColorId');
    Price = new DwItemAttribute(this.i, 'Price');
    Quantity = new DwItemAttribute(this.i, 'Quantity');
    ProductOptionDetail1Id = new DwItemAttribute(this.i, 'ProductOptionDetail1Id');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwOrderDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Order */
            DwOrder = new DwItemRelationship('dw_Order|dw_OrderDetail|OrderId', 'DwOrder', 'DwOrder');
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|dw_OrderDetail|ProductId', 'DwProduct', 'DwProduct');
            /** Relation: Product Option Detail - Product Option Detail1 */
            DwProductOptionDetailByProductOptionDetail1Id = new DwItemRelationship('dw_ProductOptionDetail|dw_OrderDetail|ProductOptionDetail1Id', 'ProductOptionDetail1IdDwProductOptionDetail', 'ProductOptionDetail1IdDwProductOptionDetail');
            /** Relation: Product Size */
            DwProductSize = new DwItemRelationship('dw_ProductSize|dw_OrderDetail|ProductSizeId', 'DwProductSize', 'DwProductSize');
            /** Relation: Registration Order Detail */
            RegistrationOrderDetail = new DwItemRelationship('dw_OrderDetail|RegistrationOrderDetail|OrderDetailId', 'RegistrationOrderDetail', 'RegistrationOrderDetail');
            /** Relation: Registration Order Detail - Swag - Many */
            RegistrationOrderDetailBySwagOrderDetailId = new DwItemRelationship('dw_OrderDetail|RegistrationOrderDetail|SwagOrderDetailId', 'SwagRegistrationOrderDetail', 'SwagRegistrationOrderDetail');
    };
export class DwOrderStatusMetaData implements DwItem2<DwOrderStatusEntity, DwOrderStatusMetaDataAttributes,DwOrderStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=190;
        this.ItemDetail.itemName='dw_OrderStatus';
        this.ItemDetail.keyName='OrderStatusId';
    }

    CreateEntity(): DwOrderStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwOrderStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwOrderStatusEntity, DwOrderStatusMetaDataAttributes,DwOrderStatusMetaDataRelations>(query, this);
    }
     Attributes = new DwOrderStatusMetaDataAttributes();
     Relations = new DwOrderStatusMetaDataRelations();

}


export type DwOrderStatusQueryBuilder = DwQueryBuilderGen<DwOrderStatusEntity, DwOrderStatusMetaDataAttributes,DwOrderStatusMetaDataRelations>


export class DwOrderStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_OrderStatus';
    // Attributes
    OrderStatusId = new DwItemAttribute(this.i, 'OrderStatusId');
    OrderStatus = new DwItemAttribute(this.i, 'OrderStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwOrderStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Order */
            DwOrder = new DwItemRelationship('dw_OrderStatus|dw_Order|OrderStatusId', 'DwOrder', 'DwOrder');
    };
export class DwPostalCodeMetaData implements DwItem2<DwPostalCodeEntity, DwPostalCodeMetaDataAttributes,DwPostalCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=256;
        this.ItemDetail.itemName='dw_PostalCode';
        this.ItemDetail.keyName='PostalCodeId';
    }

    CreateEntity(): DwPostalCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwPostalCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwPostalCodeEntity, DwPostalCodeMetaDataAttributes,DwPostalCodeMetaDataRelations>(query, this);
    }
     Attributes = new DwPostalCodeMetaDataAttributes();
     Relations = new DwPostalCodeMetaDataRelations();

}


export type DwPostalCodeQueryBuilder = DwQueryBuilderGen<DwPostalCodeEntity, DwPostalCodeMetaDataAttributes,DwPostalCodeMetaDataRelations>


export class DwPostalCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_PostalCode';
    // Attributes
    PostalCodeId = new DwItemAttribute(this.i, 'PostalCodeId');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    Plus4 = new DwItemAttribute(this.i, 'Plus4');
    City = new DwItemAttribute(this.i, 'City');
    County = new DwItemAttribute(this.i, 'County');
    AreaCode = new DwItemAttribute(this.i, 'AreaCode');
    Latitude = new DwItemAttribute(this.i, 'Latitude');
    Longitude = new DwItemAttribute(this.i, 'Longitude');
    GmtOffset = new DwItemAttribute(this.i, 'GmtOffset');
    ObservesDst = new DwItemAttribute(this.i, 'ObservesDst');
    IsMetropolitanArea = new DwItemAttribute(this.i, 'IsMetropolitanArea');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class DwPostalCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: State Province */
            DwStateProvince = new DwItemRelationship('dw_StateProvince|dw_PostalCode|StateProvinceId', 'DwStateProvince', 'DwStateProvince');
    };
export class DwProductMetaData implements DwItem2<DwProductEntity, DwProductMetaDataAttributes,DwProductMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=169;
        this.ItemDetail.itemName='dw_Product';
        this.ItemDetail.keyName='ProductId';
    }

    CreateEntity(): DwProductEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductEntity, DwProductMetaDataAttributes,DwProductMetaDataRelations>(query, this);
    }
     Attributes = new DwProductMetaDataAttributes();
     Relations = new DwProductMetaDataRelations();

}


export type DwProductQueryBuilder = DwQueryBuilderGen<DwProductEntity, DwProductMetaDataAttributes,DwProductMetaDataRelations>


export class DwProductMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Product';
    // Attributes
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    ProductName = new DwItemAttribute(this.i, 'ProductName');
    ProductMeaning = new DwItemAttribute(this.i, 'ProductMeaning');
    ProductDescription = new DwItemAttribute(this.i, 'ProductDescription');
    ProductTypeId = new DwItemAttribute(this.i, 'ProductTypeId');
    ProductCategoryId = new DwItemAttribute(this.i, 'ProductCategoryId');
    ProductDefaultPrice = new DwItemAttribute(this.i, 'ProductDefaultPrice');
    ProductCode = new DwItemAttribute(this.i, 'ProductCode');
    HasSizes = new DwItemAttribute(this.i, 'HasSizes');
    RequiresShipping = new DwItemAttribute(this.i, 'RequiresShipping');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    AdditionalShippingAmount = new DwItemAttribute(this.i, 'AdditionalShippingAmount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    SizingChartUrl = new DwItemAttribute(this.i, 'SizingChartUrl');
    ProductCost = new DwItemAttribute(this.i, 'ProductCost');
}

class DwProductMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product Category */
            DwProductCategory = new DwItemRelationship('dw_ProductCategory|dw_Product|ProductCategoryId', 'DwProductCategory', 'DwProductCategory');
            /** Relation: Product Type */
            DwProductType = new DwItemRelationship('dw_ProductType|dw_Product|ProductTypeId', 'DwProductType', 'DwProductType');
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('dw_Product|ChallengeDefinition|ProductId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Challenge Definition Product */
            ChallengeDefinitionProduct = new DwItemRelationship('dw_Product|ChallengeDefinitionProduct|ProductId', 'ChallengeDefinitionProduct', 'ChallengeDefinitionProduct');
            /** Relation: Order Detail */
            DwOrderDetail = new DwItemRelationship('dw_Product|dw_OrderDetail|ProductId', 'DwOrderDetail', 'DwOrderDetail');
            /** Relation: Product Color */
            DwProductColor = new DwItemRelationship('dw_Product|dw_ProductColor|ProductId', 'DwProductColor', 'DwProductColor');
            /** Relation: Product Media */
            DwProductMedia = new DwItemRelationship('dw_Product|dw_ProductMedia|ProductId', 'DwProductMedia', 'DwProductMedia');
            /** Relation: Product Option */
            DwProductOption = new DwItemRelationship('dw_Product|dw_ProductOption|ProductId', 'DwProductOption', 'DwProductOption');
            /** Relation: Product Size */
            DwProductSize = new DwItemRelationship('dw_Product|dw_ProductSize|ProductId', 'DwProductSize', 'DwProductSize');
            /** Relation: Shopping Cart Rule Condition */
            DwShoppingCartRuleCondition = new DwItemRelationship('dw_Product|dw_ShoppingCartRuleCondition|ProductId', 'DwShoppingCartRuleCondition', 'DwShoppingCartRuleCondition');
    };
export class DwProductCategoryMetaData implements DwItem2<DwProductCategoryEntity, DwProductCategoryMetaDataAttributes,DwProductCategoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=205;
        this.ItemDetail.itemName='dw_ProductCategory';
        this.ItemDetail.keyName='ProductCategoryId';
    }

    CreateEntity(): DwProductCategoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductCategoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductCategoryEntity, DwProductCategoryMetaDataAttributes,DwProductCategoryMetaDataRelations>(query, this);
    }
     Attributes = new DwProductCategoryMetaDataAttributes();
     Relations = new DwProductCategoryMetaDataRelations();

}


export type DwProductCategoryQueryBuilder = DwQueryBuilderGen<DwProductCategoryEntity, DwProductCategoryMetaDataAttributes,DwProductCategoryMetaDataRelations>


export class DwProductCategoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProductCategory';
    // Attributes
    ProductCategoryId = new DwItemAttribute(this.i, 'ProductCategoryId');
    CategoryDisplay = new DwItemAttribute(this.i, 'CategoryDisplay');
    CategoryMeaning = new DwItemAttribute(this.i, 'CategoryMeaning');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwProductCategoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_ProductCategory|dw_Product|ProductCategoryId', 'DwProduct', 'DwProduct');
    };
export class DwProductColorMetaData implements DwItem2<DwProductColorEntity, DwProductColorMetaDataAttributes,DwProductColorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=210;
        this.ItemDetail.itemName='dw_ProductColor';
        this.ItemDetail.keyName='ProductColorId';
    }

    CreateEntity(): DwProductColorEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductColorQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductColorEntity, DwProductColorMetaDataAttributes,DwProductColorMetaDataRelations>(query, this);
    }
     Attributes = new DwProductColorMetaDataAttributes();
     Relations = new DwProductColorMetaDataRelations();

}


export type DwProductColorQueryBuilder = DwQueryBuilderGen<DwProductColorEntity, DwProductColorMetaDataAttributes,DwProductColorMetaDataRelations>


export class DwProductColorMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProductColor';
    // Attributes
    ProductColorId = new DwItemAttribute(this.i, 'ProductColorId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    Color = new DwItemAttribute(this.i, 'Color');
    ColorDescription = new DwItemAttribute(this.i, 'ColorDescription');
    ProductMediaId = new DwItemAttribute(this.i, 'ProductMediaId');
    ColorOrder = new DwItemAttribute(this.i, 'ColorOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwProductColorMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|dw_ProductColor|ProductId', 'DwProduct', 'DwProduct');
            /** Relation: Product Media */
            DwProductMedia = new DwItemRelationship('dw_ProductMedia|dw_ProductColor|ProductMediaId', 'DwProductMedia', 'DwProductMedia');
    };
export class DwProductMediaMetaData implements DwItem2<DwProductMediaEntity, DwProductMediaMetaDataAttributes,DwProductMediaMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=158;
        this.ItemDetail.itemName='dw_ProductMedia';
        this.ItemDetail.keyName='ProductMediaId';
    }

    CreateEntity(): DwProductMediaEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductMediaQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductMediaEntity, DwProductMediaMetaDataAttributes,DwProductMediaMetaDataRelations>(query, this);
    }
     Attributes = new DwProductMediaMetaDataAttributes();
     Relations = new DwProductMediaMetaDataRelations();

}


export type DwProductMediaQueryBuilder = DwQueryBuilderGen<DwProductMediaEntity, DwProductMediaMetaDataAttributes,DwProductMediaMetaDataRelations>


export class DwProductMediaMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProductMedia';
    // Attributes
    ProductMediaId = new DwItemAttribute(this.i, 'ProductMediaId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    MediaTypeId = new DwItemAttribute(this.i, 'MediaTypeId');
    MediaName = new DwItemAttribute(this.i, 'MediaName');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    MediaUrl = new DwItemAttribute(this.i, 'MediaUrl');
    MediaOrder = new DwItemAttribute(this.i, 'MediaOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
}

class DwProductMediaMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|dw_ProductMedia|ProductId', 'DwProduct', 'DwProduct');
            /** Relation: Product Color */
            DwProductColor = new DwItemRelationship('dw_ProductMedia|dw_ProductColor|ProductMediaId', 'DwProductColor', 'DwProductColor');
    };
export class DwProductOptionMetaData implements DwItem2<DwProductOptionEntity, DwProductOptionMetaDataAttributes,DwProductOptionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=160;
        this.ItemDetail.itemName='dw_ProductOption';
        this.ItemDetail.keyName='ProductOptionId';
    }

    CreateEntity(): DwProductOptionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductOptionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductOptionEntity, DwProductOptionMetaDataAttributes,DwProductOptionMetaDataRelations>(query, this);
    }
     Attributes = new DwProductOptionMetaDataAttributes();
     Relations = new DwProductOptionMetaDataRelations();

}


export type DwProductOptionQueryBuilder = DwQueryBuilderGen<DwProductOptionEntity, DwProductOptionMetaDataAttributes,DwProductOptionMetaDataRelations>


export class DwProductOptionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProductOption';
    // Attributes
    ProductOptionId = new DwItemAttribute(this.i, 'ProductOptionId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    ProductOptionName = new DwItemAttribute(this.i, 'ProductOptionName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwProductOptionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|dw_ProductOption|ProductId', 'DwProduct', 'DwProduct');
            /** Relation: Product Option Detail */
            DwProductOptionDetail = new DwItemRelationship('dw_ProductOption|dw_ProductOptionDetail|ProductOptionId', 'DwProductOptionDetail', 'DwProductOptionDetail');
    };
export class DwProductOptionDetailMetaData implements DwItem2<DwProductOptionDetailEntity, DwProductOptionDetailMetaDataAttributes,DwProductOptionDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=199;
        this.ItemDetail.itemName='dw_ProductOptionDetail';
        this.ItemDetail.keyName='ProductOptionDetailId';
    }

    CreateEntity(): DwProductOptionDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductOptionDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductOptionDetailEntity, DwProductOptionDetailMetaDataAttributes,DwProductOptionDetailMetaDataRelations>(query, this);
    }
     Attributes = new DwProductOptionDetailMetaDataAttributes();
     Relations = new DwProductOptionDetailMetaDataRelations();

}


export type DwProductOptionDetailQueryBuilder = DwQueryBuilderGen<DwProductOptionDetailEntity, DwProductOptionDetailMetaDataAttributes,DwProductOptionDetailMetaDataRelations>


export class DwProductOptionDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProductOptionDetail';
    // Attributes
    ProductOptionDetailId = new DwItemAttribute(this.i, 'ProductOptionDetailId');
    ProductOptionId = new DwItemAttribute(this.i, 'ProductOptionId');
    DetailName = new DwItemAttribute(this.i, 'DetailName');
    DetailDescription = new DwItemAttribute(this.i, 'DetailDescription');
    ExtraCost = new DwItemAttribute(this.i, 'ExtraCost');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwProductOptionDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product Option */
            DwProductOption = new DwItemRelationship('dw_ProductOption|dw_ProductOptionDetail|ProductOptionId', 'DwProductOption', 'DwProductOption');
            /** Relation: Order Detail - 1 - Many */
            DwOrderDetailByProductOptionDetail1Id = new DwItemRelationship('dw_ProductOptionDetail|dw_OrderDetail|ProductOptionDetail1Id', 'ProductOptionDetail1IdDwOrderDetail', 'ProductOptionDetail1IdDwOrderDetail');
    };
export class DwProductSizeMetaData implements DwItem2<DwProductSizeEntity, DwProductSizeMetaDataAttributes,DwProductSizeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=202;
        this.ItemDetail.itemName='dw_ProductSize';
        this.ItemDetail.keyName='ProductSizeId';
    }

    CreateEntity(): DwProductSizeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductSizeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductSizeEntity, DwProductSizeMetaDataAttributes,DwProductSizeMetaDataRelations>(query, this);
    }
     Attributes = new DwProductSizeMetaDataAttributes();
     Relations = new DwProductSizeMetaDataRelations();

}


export type DwProductSizeQueryBuilder = DwQueryBuilderGen<DwProductSizeEntity, DwProductSizeMetaDataAttributes,DwProductSizeMetaDataRelations>


export class DwProductSizeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProductSize';
    // Attributes
    ProductSizeId = new DwItemAttribute(this.i, 'ProductSizeId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    Size = new DwItemAttribute(this.i, 'Size');
    ExtraCost = new DwItemAttribute(this.i, 'ExtraCost');
    SizeOrder = new DwItemAttribute(this.i, 'SizeOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwProductSizeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|dw_ProductSize|ProductId', 'DwProduct', 'DwProduct');
            /** Relation: Order Detail */
            DwOrderDetail = new DwItemRelationship('dw_ProductSize|dw_OrderDetail|ProductSizeId', 'DwOrderDetail', 'DwOrderDetail');
    };
export class DwProductTypeMetaData implements DwItem2<DwProductTypeEntity, DwProductTypeMetaDataAttributes,DwProductTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=207;
        this.ItemDetail.itemName='dw_ProductType';
        this.ItemDetail.keyName='ProductTypeId';
    }

    CreateEntity(): DwProductTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProductTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProductTypeEntity, DwProductTypeMetaDataAttributes,DwProductTypeMetaDataRelations>(query, this);
    }
     Attributes = new DwProductTypeMetaDataAttributes();
     Relations = new DwProductTypeMetaDataRelations();

}


export type DwProductTypeQueryBuilder = DwQueryBuilderGen<DwProductTypeEntity, DwProductTypeMetaDataAttributes,DwProductTypeMetaDataRelations>


export class DwProductTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProductType';
    // Attributes
    ProductTypeId = new DwItemAttribute(this.i, 'ProductTypeId');
    ProductType = new DwItemAttribute(this.i, 'ProductType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwProductTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_ProductType|dw_Product|ProductTypeId', 'DwProduct', 'DwProduct');
    };
export class RecipientMetaData implements DwItem2<RecipientEntity, RecipientMetaDataAttributes,RecipientMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=319;
        this.ItemDetail.itemName='Recipient';
        this.ItemDetail.keyName='RecipientId';
    }

    CreateEntity(): RecipientEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RecipientQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RecipientEntity, RecipientMetaDataAttributes,RecipientMetaDataRelations>(query, this);
    }
     Attributes = new RecipientMetaDataAttributes();
     Relations = new RecipientMetaDataRelations();

}


export type RecipientQueryBuilder = DwQueryBuilderGen<RecipientEntity, RecipientMetaDataAttributes,RecipientMetaDataRelations>


export class RecipientMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Recipient';
    // Attributes
    RecipientId = new DwItemAttribute(this.i, 'RecipientId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    RecipientName = new DwItemAttribute(this.i, 'RecipientName');
    Slug = new DwItemAttribute(this.i, 'Slug');
    ShortDescription = new DwItemAttribute(this.i, 'ShortDescription');
    FullDescriptionHtml = new DwItemAttribute(this.i, 'FullDescriptionHtml');
    InternalNotes = new DwItemAttribute(this.i, 'InternalNotes');
    RevealAtDateTime = new DwItemAttribute(this.i, 'RevealAtDateTime');
    IsPublished = new DwItemAttribute(this.i, 'IsPublished');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    SourceUrl = new DwItemAttribute(this.i, 'SourceUrl');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class RecipientMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|Recipient|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Recipient Photo */
            RecipientPhoto = new DwItemRelationship('Recipient|RecipientPhoto|RecipientId', 'RecipientPhoto', 'RecipientPhoto');
            /** Relation: Recipient Update */
            RecipientUpdate = new DwItemRelationship('Recipient|RecipientUpdate|RecipientId', 'RecipientUpdate', 'RecipientUpdate');
    };
export class RecipientPhotoMetaData implements DwItem2<RecipientPhotoEntity, RecipientPhotoMetaDataAttributes,RecipientPhotoMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=320;
        this.ItemDetail.itemName='RecipientPhoto';
        this.ItemDetail.keyName='RecipientPhotoId';
    }

    CreateEntity(): RecipientPhotoEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RecipientPhotoQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RecipientPhotoEntity, RecipientPhotoMetaDataAttributes,RecipientPhotoMetaDataRelations>(query, this);
    }
     Attributes = new RecipientPhotoMetaDataAttributes();
     Relations = new RecipientPhotoMetaDataRelations();

}


export type RecipientPhotoQueryBuilder = DwQueryBuilderGen<RecipientPhotoEntity, RecipientPhotoMetaDataAttributes,RecipientPhotoMetaDataRelations>


export class RecipientPhotoMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'RecipientPhoto';
    // Attributes
    RecipientPhotoId = new DwItemAttribute(this.i, 'RecipientPhotoId');
    RecipientId = new DwItemAttribute(this.i, 'RecipientId');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    Caption = new DwItemAttribute(this.i, 'Caption');
    AltText = new DwItemAttribute(this.i, 'AltText');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CardFitWholePhoto = new DwItemAttribute(this.i, 'CardFitWholePhoto');
    CardPositionXPercent = new DwItemAttribute(this.i, 'CardPositionXPercent');
    CardPositionYPercent = new DwItemAttribute(this.i, 'CardPositionYPercent');
}

class RecipientPhotoMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Recipient */
            Recipient = new DwItemRelationship('Recipient|RecipientPhoto|RecipientId', 'Recipient', 'Recipient');
    };
export class RecipientUpdateMetaData implements DwItem2<RecipientUpdateEntity, RecipientUpdateMetaDataAttributes,RecipientUpdateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=317;
        this.ItemDetail.itemName='RecipientUpdate';
        this.ItemDetail.keyName='RecipientUpdateId';
    }

    CreateEntity(): RecipientUpdateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RecipientUpdateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RecipientUpdateEntity, RecipientUpdateMetaDataAttributes,RecipientUpdateMetaDataRelations>(query, this);
    }
     Attributes = new RecipientUpdateMetaDataAttributes();
     Relations = new RecipientUpdateMetaDataRelations();

}


export type RecipientUpdateQueryBuilder = DwQueryBuilderGen<RecipientUpdateEntity, RecipientUpdateMetaDataAttributes,RecipientUpdateMetaDataRelations>


export class RecipientUpdateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'RecipientUpdate';
    // Attributes
    RecipientUpdateId = new DwItemAttribute(this.i, 'RecipientUpdateId');
    RecipientId = new DwItemAttribute(this.i, 'RecipientId');
    Title = new DwItemAttribute(this.i, 'Title');
    BodyHtml = new DwItemAttribute(this.i, 'BodyHtml');
    PublishAtDateTime = new DwItemAttribute(this.i, 'PublishAtDateTime');
    IsPublished = new DwItemAttribute(this.i, 'IsPublished');
    SourceUrl = new DwItemAttribute(this.i, 'SourceUrl');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class RecipientUpdateMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Recipient */
            Recipient = new DwItemRelationship('Recipient|RecipientUpdate|RecipientId', 'Recipient', 'Recipient');
            /** Relation: Recipient Update Photo */
            RecipientUpdatePhoto = new DwItemRelationship('RecipientUpdate|RecipientUpdatePhoto|RecipientUpdateId', 'RecipientUpdatePhoto', 'RecipientUpdatePhoto');
    };
export class RecipientUpdatePhotoMetaData implements DwItem2<RecipientUpdatePhotoEntity, RecipientUpdatePhotoMetaDataAttributes,RecipientUpdatePhotoMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=318;
        this.ItemDetail.itemName='RecipientUpdatePhoto';
        this.ItemDetail.keyName='RecipientUpdatePhotoId';
    }

    CreateEntity(): RecipientUpdatePhotoEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RecipientUpdatePhotoQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RecipientUpdatePhotoEntity, RecipientUpdatePhotoMetaDataAttributes,RecipientUpdatePhotoMetaDataRelations>(query, this);
    }
     Attributes = new RecipientUpdatePhotoMetaDataAttributes();
     Relations = new RecipientUpdatePhotoMetaDataRelations();

}


export type RecipientUpdatePhotoQueryBuilder = DwQueryBuilderGen<RecipientUpdatePhotoEntity, RecipientUpdatePhotoMetaDataAttributes,RecipientUpdatePhotoMetaDataRelations>


export class RecipientUpdatePhotoMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'RecipientUpdatePhoto';
    // Attributes
    RecipientUpdatePhotoId = new DwItemAttribute(this.i, 'RecipientUpdatePhotoId');
    RecipientUpdateId = new DwItemAttribute(this.i, 'RecipientUpdateId');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    Caption = new DwItemAttribute(this.i, 'Caption');
    AltText = new DwItemAttribute(this.i, 'AltText');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class RecipientUpdatePhotoMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Recipient Update */
            RecipientUpdate = new DwItemRelationship('RecipientUpdate|RecipientUpdatePhoto|RecipientUpdateId', 'RecipientUpdate', 'RecipientUpdate');
    };
export class RegistrationOrderDetailMetaData implements DwItem2<RegistrationOrderDetailEntity, RegistrationOrderDetailMetaDataAttributes,RegistrationOrderDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=267;
        this.ItemDetail.itemName='RegistrationOrderDetail';
        this.ItemDetail.keyName='RegistrationOrderDetailId';
    }

    CreateEntity(): RegistrationOrderDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RegistrationOrderDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RegistrationOrderDetailEntity, RegistrationOrderDetailMetaDataAttributes,RegistrationOrderDetailMetaDataRelations>(query, this);
    }
     Attributes = new RegistrationOrderDetailMetaDataAttributes();
     Relations = new RegistrationOrderDetailMetaDataRelations();

}


export type RegistrationOrderDetailQueryBuilder = DwQueryBuilderGen<RegistrationOrderDetailEntity, RegistrationOrderDetailMetaDataAttributes,RegistrationOrderDetailMetaDataRelations>


export class RegistrationOrderDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'RegistrationOrderDetail';
    // Attributes
    RegistrationOrderDetailId = new DwItemAttribute(this.i, 'RegistrationOrderDetailId');
    OrderDetailId = new DwItemAttribute(this.i, 'OrderDetailId');
    SwagOrderDetailId = new DwItemAttribute(this.i, 'SwagOrderDetailId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ParticipantEmail = new DwItemAttribute(this.i, 'ParticipantEmail');
    ParticipantFirstName = new DwItemAttribute(this.i, 'ParticipantFirstName');
    ParticipantLastName = new DwItemAttribute(this.i, 'ParticipantLastName');
    YearsStreaking = new DwItemAttribute(this.i, 'YearsStreaking');
    MarketingSourceCv = new DwItemAttribute(this.i, 'MarketingSourceCv');
    MarketingSourceOther = new DwItemAttribute(this.i, 'MarketingSourceOther');
    ChallengedByUserId = new DwItemAttribute(this.i, 'ChallengedByUserId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    FulfilledDateTime = new DwItemAttribute(this.i, 'FulfilledDateTime');
    FulfillmentError = new DwItemAttribute(this.i, 'FulfillmentError');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    TeamJoinCodeUsed = new DwItemAttribute(this.i, 'TeamJoinCodeUsed');
}

class RegistrationOrderDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|RegistrationOrderDetail|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Challenge Team */
            ChallengeTeam = new DwItemRelationship('ChallengeTeam|RegistrationOrderDetail|ChallengeTeamId', 'ChallengeTeam', 'ChallengeTeam');
            /** Relation: Order Detail */
            DwOrderDetail = new DwItemRelationship('dw_OrderDetail|RegistrationOrderDetail|OrderDetailId', 'DwOrderDetail', 'DwOrderDetail');
            /** Relation: Order Detail - Swag Order Detail */
            DwOrderDetailBySwagOrderDetailId = new DwItemRelationship('dw_OrderDetail|RegistrationOrderDetail|SwagOrderDetailId', 'SwagDwOrderDetail', 'SwagDwOrderDetail');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|RegistrationOrderDetail|UserChallengeId', 'UserChallenge', 'UserChallenge');
    };
export class RoActivityDisplayMetaData implements DwItem2<RoActivityDisplayEntity, RoActivityDisplayMetaDataAttributes,RoActivityDisplayMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=301;
        this.ItemDetail.itemName='roActivityDisplay';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoActivityDisplayEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoActivityDisplayQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoActivityDisplayEntity, RoActivityDisplayMetaDataAttributes,RoActivityDisplayMetaDataRelations>(query, this);
    }
     Attributes = new RoActivityDisplayMetaDataAttributes();
     Relations = new RoActivityDisplayMetaDataRelations();

}


export type RoActivityDisplayQueryBuilder = DwQueryBuilderGen<RoActivityDisplayEntity, RoActivityDisplayMetaDataAttributes,RoActivityDisplayMetaDataRelations>


export class RoActivityDisplayMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roActivityDisplay';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    FitnessActivityId = new DwItemAttribute(this.i, 'FitnessActivityId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    IsRegistrationComplete = new DwItemAttribute(this.i, 'IsRegistrationComplete');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    Name = new DwItemAttribute(this.i, 'Name');
    Comments = new DwItemAttribute(this.i, 'Comments');
    ActivityDate = new DwItemAttribute(this.i, 'ActivityDate');
    StartTime = new DwItemAttribute(this.i, 'StartTime');
    DurationSeconds = new DwItemAttribute(this.i, 'DurationSeconds');
    DistanceMeters = new DwItemAttribute(this.i, 'DistanceMeters');
    ActivityCount = new DwItemAttribute(this.i, 'ActivityCount');
    Steps = new DwItemAttribute(this.i, 'Steps');
    CaloriesKCal = new DwItemAttribute(this.i, 'CaloriesKCal');
    Laps = new DwItemAttribute(this.i, 'Laps');
    LapLengthMeters = new DwItemAttribute(this.i, 'LapLengthMeters');
    AverageHeartRate = new DwItemAttribute(this.i, 'AverageHeartRate');
    AveragePaceMetersPerSecond = new DwItemAttribute(this.i, 'AveragePaceMetersPerSecond');
    ElevationGainMeters = new DwItemAttribute(this.i, 'ElevationGainMeters');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    DistanceUnitOfMeasureId = new DwItemAttribute(this.i, 'DistanceUnitOfMeasureId');
    DistanceUOMName = new DwItemAttribute(this.i, 'DistanceUOMName');
    DistanceUOMShortName = new DwItemAttribute(this.i, 'DistanceUOMShortName');
    DistanceMultiplierToBase = new DwItemAttribute(this.i, 'DistanceMultiplierToBase');
    LapUnitOfMeasureId = new DwItemAttribute(this.i, 'LapUnitOfMeasureId');
    LapUOMName = new DwItemAttribute(this.i, 'LapUOMName');
    LapUOMShortName = new DwItemAttribute(this.i, 'LapUOMShortName');
    ElevationGainUnitOfMeasureId = new DwItemAttribute(this.i, 'ElevationGainUnitOfMeasureId');
    ElevationUOMName = new DwItemAttribute(this.i, 'ElevationUOMName');
    ElevationUOMShortName = new DwItemAttribute(this.i, 'ElevationUOMShortName');
    ActivityTypeName = new DwItemAttribute(this.i, 'ActivityTypeName');
    IconCss = new DwItemAttribute(this.i, 'IconCss');
    CountDisplay = new DwItemAttribute(this.i, 'CountDisplay');
    FitnessActivityGroupId = new DwItemAttribute(this.i, 'FitnessActivityGroupId');
    ShowCount = new DwItemAttribute(this.i, 'ShowCount');
    ShowDuration = new DwItemAttribute(this.i, 'ShowDuration');
    ShowDistance = new DwItemAttribute(this.i, 'ShowDistance');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    AuthorDisplayName = new DwItemAttribute(this.i, 'AuthorDisplayName');
    ProfileSlug = new DwItemAttribute(this.i, 'ProfileSlug');
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    BannerColorStart = new DwItemAttribute(this.i, 'BannerColorStart');
    BannerColorEnd = new DwItemAttribute(this.i, 'BannerColorEnd');
    BannerUseGradient = new DwItemAttribute(this.i, 'BannerUseGradient');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    BannerAnimationKey = new DwItemAttribute(this.i, 'BannerAnimationKey');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    BannerMediaId = new DwItemAttribute(this.i, 'BannerMediaId');
    BannerMediaPath = new DwItemAttribute(this.i, 'BannerMediaPath');
    BannerWidth = new DwItemAttribute(this.i, 'BannerWidth');
    BannerHeight = new DwItemAttribute(this.i, 'BannerHeight');
    ActivityPictureMediaId = new DwItemAttribute(this.i, 'ActivityPictureMediaId');
    ActivityMediaId = new DwItemAttribute(this.i, 'ActivityMediaId');
    ActivityMediaPath = new DwItemAttribute(this.i, 'ActivityMediaPath');
    ActivityWidth = new DwItemAttribute(this.i, 'ActivityWidth');
    ActivityHeight = new DwItemAttribute(this.i, 'ActivityHeight');
    LikeCount = new DwItemAttribute(this.i, 'LikeCount');
    CommentCount = new DwItemAttribute(this.i, 'CommentCount');
}

class RoActivityDisplayMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoChallengeAdminSummaryMetaData implements DwItem2<RoChallengeAdminSummaryEntity, RoChallengeAdminSummaryMetaDataAttributes,RoChallengeAdminSummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=316;
        this.ItemDetail.itemName='roChallengeAdminSummary';
        this.ItemDetail.keyName='ChallengeDefinitionId';
    }

    CreateEntity(): RoChallengeAdminSummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoChallengeAdminSummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoChallengeAdminSummaryEntity, RoChallengeAdminSummaryMetaDataAttributes,RoChallengeAdminSummaryMetaDataRelations>(query, this);
    }
     Attributes = new RoChallengeAdminSummaryMetaDataAttributes();
     Relations = new RoChallengeAdminSummaryMetaDataRelations();

}


export type RoChallengeAdminSummaryQueryBuilder = DwQueryBuilderGen<RoChallengeAdminSummaryEntity, RoChallengeAdminSummaryMetaDataAttributes,RoChallengeAdminSummaryMetaDataRelations>


export class RoChallengeAdminSummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roChallengeAdminSummary';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeName = new DwItemAttribute(this.i, 'ChallengeName');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    ChallengeStartDate = new DwItemAttribute(this.i, 'ChallengeStartDate');
    ChallengeEndDate = new DwItemAttribute(this.i, 'ChallengeEndDate');
    StreakerCount = new DwItemAttribute(this.i, 'StreakerCount');
    TeamCount = new DwItemAttribute(this.i, 'TeamCount');
    DonationCount = new DwItemAttribute(this.i, 'DonationCount');
    RecordedDonationAmount = new DwItemAttribute(this.i, 'RecordedDonationAmount');
    PaidDonationAmount = new DwItemAttribute(this.i, 'PaidDonationAmount');
}

class RoChallengeAdminSummaryMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoChallengeCollectionSummaryMetaData implements DwItem2<RoChallengeCollectionSummaryEntity, RoChallengeCollectionSummaryMetaDataAttributes,RoChallengeCollectionSummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=323;
        this.ItemDetail.itemName='roChallengeCollectionSummary';
        this.ItemDetail.keyName='ChallengeDefinitionId';
    }

    CreateEntity(): RoChallengeCollectionSummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoChallengeCollectionSummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoChallengeCollectionSummaryEntity, RoChallengeCollectionSummaryMetaDataAttributes,RoChallengeCollectionSummaryMetaDataRelations>(query, this);
    }
     Attributes = new RoChallengeCollectionSummaryMetaDataAttributes();
     Relations = new RoChallengeCollectionSummaryMetaDataRelations();

}


export type RoChallengeCollectionSummaryQueryBuilder = DwQueryBuilderGen<RoChallengeCollectionSummaryEntity, RoChallengeCollectionSummaryMetaDataAttributes,RoChallengeCollectionSummaryMetaDataRelations>


export class RoChallengeCollectionSummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roChallengeCollectionSummary';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    RegistrationAmount = new DwItemAttribute(this.i, 'RegistrationAmount');
    ExtraShirtAmount = new DwItemAttribute(this.i, 'ExtraShirtAmount');
    DonationAmount = new DwItemAttribute(this.i, 'DonationAmount');
    ShippingAmount = new DwItemAttribute(this.i, 'ShippingAmount');
    DiscountAmount = new DwItemAttribute(this.i, 'DiscountAmount');
    TotalAmount = new DwItemAttribute(this.i, 'TotalAmount');
    TotalExcludingShipping = new DwItemAttribute(this.i, 'TotalExcludingShipping');
    OrdersNeedingReview = new DwItemAttribute(this.i, 'OrdersNeedingReview');
}

class RoChallengeCollectionSummaryMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoChallengeDonationAdminMetaData implements DwItem2<RoChallengeDonationAdminEntity, RoChallengeDonationAdminMetaDataAttributes,RoChallengeDonationAdminMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=314;
        this.ItemDetail.itemName='roChallengeDonationAdmin';
        this.ItemDetail.keyName='OrderDetailId';
    }

    CreateEntity(): RoChallengeDonationAdminEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoChallengeDonationAdminQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoChallengeDonationAdminEntity, RoChallengeDonationAdminMetaDataAttributes,RoChallengeDonationAdminMetaDataRelations>(query, this);
    }
     Attributes = new RoChallengeDonationAdminMetaDataAttributes();
     Relations = new RoChallengeDonationAdminMetaDataRelations();

}


export type RoChallengeDonationAdminQueryBuilder = DwQueryBuilderGen<RoChallengeDonationAdminEntity, RoChallengeDonationAdminMetaDataAttributes,RoChallengeDonationAdminMetaDataRelations>


export class RoChallengeDonationAdminMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roChallengeDonationAdmin';
    // Attributes
    OrderDetailId = new DwItemAttribute(this.i, 'OrderDetailId');
    OrderId = new DwItemAttribute(this.i, 'OrderId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    DonorName = new DwItemAttribute(this.i, 'DonorName');
    OrderDateTime = new DwItemAttribute(this.i, 'OrderDateTime');
    OrderStatus = new DwItemAttribute(this.i, 'OrderStatus');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    ProductName = new DwItemAttribute(this.i, 'ProductName');
    DonationAmount = new DwItemAttribute(this.i, 'DonationAmount');
    PaidDonationAmount = new DwItemAttribute(this.i, 'PaidDonationAmount');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    AttributionStatus = new DwItemAttribute(this.i, 'AttributionStatus');
    ChallengeName = new DwItemAttribute(this.i, 'ChallengeName');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    NeedsAttributionReview = new DwItemAttribute(this.i, 'NeedsAttributionReview');
}

class RoChallengeDonationAdminMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoChallengeRegistrationDailyMetaData implements DwItem2<RoChallengeRegistrationDailyEntity, RoChallengeRegistrationDailyMetaDataAttributes,RoChallengeRegistrationDailyMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=322;
        this.ItemDetail.itemName='roChallengeRegistrationDaily';
        this.ItemDetail.keyName='RegistrationDailyKey';
    }

    CreateEntity(): RoChallengeRegistrationDailyEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoChallengeRegistrationDailyQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoChallengeRegistrationDailyEntity, RoChallengeRegistrationDailyMetaDataAttributes,RoChallengeRegistrationDailyMetaDataRelations>(query, this);
    }
     Attributes = new RoChallengeRegistrationDailyMetaDataAttributes();
     Relations = new RoChallengeRegistrationDailyMetaDataRelations();

}


export type RoChallengeRegistrationDailyQueryBuilder = DwQueryBuilderGen<RoChallengeRegistrationDailyEntity, RoChallengeRegistrationDailyMetaDataAttributes,RoChallengeRegistrationDailyMetaDataRelations>


export class RoChallengeRegistrationDailyMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roChallengeRegistrationDaily';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    RegistrationDate = new DwItemAttribute(this.i, 'RegistrationDate');
    DailyRegistrations = new DwItemAttribute(this.i, 'DailyRegistrations');
    DailyOrderValue = new DwItemAttribute(this.i, 'DailyOrderValue');
    OrdersNeedingReview = new DwItemAttribute(this.i, 'OrdersNeedingReview');
    ChallengeName = new DwItemAttribute(this.i, 'ChallengeName');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    TotalRegistered = new DwItemAttribute(this.i, 'TotalRegistered');
    TotalOrderValue = new DwItemAttribute(this.i, 'TotalOrderValue');
    RegistrationDailyKey = new DwItemAttribute(this.i, 'RegistrationDailyKey');
}

class RoChallengeRegistrationDailyMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoChallengeStreakerAdminMetaData implements DwItem2<RoChallengeStreakerAdminEntity, RoChallengeStreakerAdminMetaDataAttributes,RoChallengeStreakerAdminMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=313;
        this.ItemDetail.itemName='roChallengeStreakerAdmin';
        this.ItemDetail.keyName='UserChallengeId';
    }

    CreateEntity(): RoChallengeStreakerAdminEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoChallengeStreakerAdminQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoChallengeStreakerAdminEntity, RoChallengeStreakerAdminMetaDataAttributes,RoChallengeStreakerAdminMetaDataRelations>(query, this);
    }
     Attributes = new RoChallengeStreakerAdminMetaDataAttributes();
     Relations = new RoChallengeStreakerAdminMetaDataRelations();

}


export type RoChallengeStreakerAdminQueryBuilder = DwQueryBuilderGen<RoChallengeStreakerAdminEntity, RoChallengeStreakerAdminMetaDataAttributes,RoChallengeStreakerAdminMetaDataRelations>


export class RoChallengeStreakerAdminMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roChallengeStreakerAdmin';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    ChallengeName = new DwItemAttribute(this.i, 'ChallengeName');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    Email = new DwItemAttribute(this.i, 'Email');
    ProfileSlug = new DwItemAttribute(this.i, 'ProfileSlug');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    RegistrationDateTime = new DwItemAttribute(this.i, 'RegistrationDateTime');
    RowNumber = new DwItemAttribute(this.i, 'RowNumber');
    IsMilestone = new DwItemAttribute(this.i, 'IsMilestone');
}

class RoChallengeStreakerAdminMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoChallengeTeamDonationAdminMetaData implements DwItem2<RoChallengeTeamDonationAdminEntity, RoChallengeTeamDonationAdminMetaDataAttributes,RoChallengeTeamDonationAdminMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=315;
        this.ItemDetail.itemName='roChallengeTeamDonationAdmin';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoChallengeTeamDonationAdminEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoChallengeTeamDonationAdminQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoChallengeTeamDonationAdminEntity, RoChallengeTeamDonationAdminMetaDataAttributes,RoChallengeTeamDonationAdminMetaDataRelations>(query, this);
    }
     Attributes = new RoChallengeTeamDonationAdminMetaDataAttributes();
     Relations = new RoChallengeTeamDonationAdminMetaDataRelations();

}


export type RoChallengeTeamDonationAdminQueryBuilder = DwQueryBuilderGen<RoChallengeTeamDonationAdminEntity, RoChallengeTeamDonationAdminMetaDataAttributes,RoChallengeTeamDonationAdminMetaDataRelations>


export class RoChallengeTeamDonationAdminMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roChallengeTeamDonationAdmin';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    TeamMemberCount = new DwItemAttribute(this.i, 'TeamMemberCount');
    RecordedDonationAmount = new DwItemAttribute(this.i, 'RecordedDonationAmount');
    PaidDonationAmount = new DwItemAttribute(this.i, 'PaidDonationAmount');
}

class RoChallengeTeamDonationAdminMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoDonationsByTeamMetaData implements DwItem2<RoDonationsByTeamEntity, RoDonationsByTeamMetaDataAttributes,RoDonationsByTeamMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=269;
        this.ItemDetail.itemName='roDonationsByTeam';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoDonationsByTeamEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoDonationsByTeamQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoDonationsByTeamEntity, RoDonationsByTeamMetaDataAttributes,RoDonationsByTeamMetaDataRelations>(query, this);
    }
     Attributes = new RoDonationsByTeamMetaDataAttributes();
     Relations = new RoDonationsByTeamMetaDataRelations();

}


export type RoDonationsByTeamQueryBuilder = DwQueryBuilderGen<RoDonationsByTeamEntity, RoDonationsByTeamMetaDataAttributes,RoDonationsByTeamMetaDataRelations>


export class RoDonationsByTeamMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roDonationsByTeam';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeDefinitionName = new DwItemAttribute(this.i, 'ChallengeDefinitionName');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    TeamMemberCount = new DwItemAttribute(this.i, 'TeamMemberCount');
    DonationAmount = new DwItemAttribute(this.i, 'DonationAmount');
    DonationAmountPerMember = new DwItemAttribute(this.i, 'DonationAmountPerMember');
}

class RoDonationsByTeamMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoPublicDisplayImageMetaData implements DwItem2<RoPublicDisplayImageEntity, RoPublicDisplayImageMetaDataAttributes,RoPublicDisplayImageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=303;
        this.ItemDetail.itemName='roPublicDisplayImage';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoPublicDisplayImageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPublicDisplayImageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPublicDisplayImageEntity, RoPublicDisplayImageMetaDataAttributes,RoPublicDisplayImageMetaDataRelations>(query, this);
    }
     Attributes = new RoPublicDisplayImageMetaDataAttributes();
     Relations = new RoPublicDisplayImageMetaDataRelations();

}


export type RoPublicDisplayImageQueryBuilder = DwQueryBuilderGen<RoPublicDisplayImageEntity, RoPublicDisplayImageMetaDataAttributes,RoPublicDisplayImageMetaDataRelations>


export class RoPublicDisplayImageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPublicDisplayImage';
    // Attributes
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    MediaPath = new DwItemAttribute(this.i, 'MediaPath');
    Width = new DwItemAttribute(this.i, 'Width');
    Height = new DwItemAttribute(this.i, 'Height');
}

class RoPublicDisplayImageMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoStreakerDisplayMetaData implements DwItem2<RoStreakerDisplayEntity, RoStreakerDisplayMetaDataAttributes,RoStreakerDisplayMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=305;
        this.ItemDetail.itemName='roStreakerDisplay';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoStreakerDisplayEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStreakerDisplayQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStreakerDisplayEntity, RoStreakerDisplayMetaDataAttributes,RoStreakerDisplayMetaDataRelations>(query, this);
    }
     Attributes = new RoStreakerDisplayMetaDataAttributes();
     Relations = new RoStreakerDisplayMetaDataRelations();

}


export type RoStreakerDisplayQueryBuilder = DwQueryBuilderGen<RoStreakerDisplayEntity, RoStreakerDisplayMetaDataAttributes,RoStreakerDisplayMetaDataRelations>


export class RoStreakerDisplayMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStreakerDisplay';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    ProfileSlug = new DwItemAttribute(this.i, 'ProfileSlug');
    UserDescription = new DwItemAttribute(this.i, 'UserDescription');
    IsRegistrationComplete = new DwItemAttribute(this.i, 'IsRegistrationComplete');
    UploadedAvatarMediaId = new DwItemAttribute(this.i, 'UploadedAvatarMediaId');
    UploadedBannerMediaId = new DwItemAttribute(this.i, 'UploadedBannerMediaId');
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    BannerColorStart = new DwItemAttribute(this.i, 'BannerColorStart');
    BannerColorEnd = new DwItemAttribute(this.i, 'BannerColorEnd');
    BannerUseGradient = new DwItemAttribute(this.i, 'BannerUseGradient');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    BannerAnimationKey = new DwItemAttribute(this.i, 'BannerAnimationKey');
    AvatarImageMode = new DwItemAttribute(this.i, 'AvatarImageMode');
    BannerImageMode = new DwItemAttribute(this.i, 'BannerImageMode');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    BannerMediaId = new DwItemAttribute(this.i, 'BannerMediaId');
    BannerMediaPath = new DwItemAttribute(this.i, 'BannerMediaPath');
    BannerWidth = new DwItemAttribute(this.i, 'BannerWidth');
    BannerHeight = new DwItemAttribute(this.i, 'BannerHeight');
}

class RoStreakerDisplayMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoTeamDisplayMetaData implements DwItem2<RoTeamDisplayEntity, RoTeamDisplayMetaDataAttributes,RoTeamDisplayMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=306;
        this.ItemDetail.itemName='roTeamDisplay';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoTeamDisplayEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoTeamDisplayQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoTeamDisplayEntity, RoTeamDisplayMetaDataAttributes,RoTeamDisplayMetaDataRelations>(query, this);
    }
     Attributes = new RoTeamDisplayMetaDataAttributes();
     Relations = new RoTeamDisplayMetaDataRelations();

}


export type RoTeamDisplayQueryBuilder = DwQueryBuilderGen<RoTeamDisplayEntity, RoTeamDisplayMetaDataAttributes,RoTeamDisplayMetaDataRelations>


export class RoTeamDisplayMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roTeamDisplay';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    TeamSlug = new DwItemAttribute(this.i, 'TeamSlug');
    TeamDescription = new DwItemAttribute(this.i, 'TeamDescription');
    TeamLocation = new DwItemAttribute(this.i, 'TeamLocation');
    IsPrivateTeam = new DwItemAttribute(this.i, 'IsPrivateTeam');
    RequestApprovalToJoin = new DwItemAttribute(this.i, 'RequestApprovalToJoin');
    TeamLocked = new DwItemAttribute(this.i, 'TeamLocked');
    UploadedAvatarMediaId = new DwItemAttribute(this.i, 'UploadedAvatarMediaId');
    UploadedBannerMediaId = new DwItemAttribute(this.i, 'UploadedBannerMediaId');
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    BannerColorStart = new DwItemAttribute(this.i, 'BannerColorStart');
    BannerColorEnd = new DwItemAttribute(this.i, 'BannerColorEnd');
    BannerUseGradient = new DwItemAttribute(this.i, 'BannerUseGradient');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    BannerAnimationKey = new DwItemAttribute(this.i, 'BannerAnimationKey');
    AvatarImageMode = new DwItemAttribute(this.i, 'AvatarImageMode');
    BannerImageMode = new DwItemAttribute(this.i, 'BannerImageMode');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    BannerMediaId = new DwItemAttribute(this.i, 'BannerMediaId');
    BannerMediaPath = new DwItemAttribute(this.i, 'BannerMediaPath');
    BannerWidth = new DwItemAttribute(this.i, 'BannerWidth');
    BannerHeight = new DwItemAttribute(this.i, 'BannerHeight');
}

class RoTeamDisplayMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoTeamFitnessActivityStatsMetaData implements DwItem2<RoTeamFitnessActivityStatsEntity, RoTeamFitnessActivityStatsMetaDataAttributes,RoTeamFitnessActivityStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=308;
        this.ItemDetail.itemName='roTeamFitnessActivityStats';
        this.ItemDetail.keyName='TeamActivityKey';
    }

    CreateEntity(): RoTeamFitnessActivityStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoTeamFitnessActivityStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoTeamFitnessActivityStatsEntity, RoTeamFitnessActivityStatsMetaDataAttributes,RoTeamFitnessActivityStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoTeamFitnessActivityStatsMetaDataAttributes();
     Relations = new RoTeamFitnessActivityStatsMetaDataRelations();

}


export type RoTeamFitnessActivityStatsQueryBuilder = DwQueryBuilderGen<RoTeamFitnessActivityStatsEntity, RoTeamFitnessActivityStatsMetaDataAttributes,RoTeamFitnessActivityStatsMetaDataRelations>


export class RoTeamFitnessActivityStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roTeamFitnessActivityStats';
    // Attributes
    TeamActivityKey = new DwItemAttribute(this.i, 'TeamActivityKey');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    TeamSlug = new DwItemAttribute(this.i, 'TeamSlug');
    IsPrivateTeam = new DwItemAttribute(this.i, 'IsPrivateTeam');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    MemberCount = new DwItemAttribute(this.i, 'MemberCount');
    SummarizedMemberCount = new DwItemAttribute(this.i, 'SummarizedMemberCount');
    ContributorCount = new DwItemAttribute(this.i, 'ContributorCount');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    ActivityTypeName = new DwItemAttribute(this.i, 'ActivityTypeName');
    IconCss = new DwItemAttribute(this.i, 'IconCss');
    CountDisplay = new DwItemAttribute(this.i, 'CountDisplay');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDistanceMeters = new DwItemAttribute(this.i, 'TotalDistanceMeters');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    TotalRepCount = new DwItemAttribute(this.i, 'TotalRepCount');
    TotalElevationGainMeters = new DwItemAttribute(this.i, 'TotalElevationGainMeters');
    DistanceMetersPerMember = new DwItemAttribute(this.i, 'DistanceMetersPerMember');
    DurationSecondsPerMember = new DwItemAttribute(this.i, 'DurationSecondsPerMember');
    RepCountPerMember = new DwItemAttribute(this.i, 'RepCountPerMember');
    StatsUpdatedDateTime = new DwItemAttribute(this.i, 'StatsUpdatedDateTime');
}

class RoTeamFitnessActivityStatsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoTeamFitnessStatsMetaData implements DwItem2<RoTeamFitnessStatsEntity, RoTeamFitnessStatsMetaDataAttributes,RoTeamFitnessStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=307;
        this.ItemDetail.itemName='roTeamFitnessStats';
        this.ItemDetail.keyName='ChallengeTeamId';
    }

    CreateEntity(): RoTeamFitnessStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoTeamFitnessStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoTeamFitnessStatsEntity, RoTeamFitnessStatsMetaDataAttributes,RoTeamFitnessStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoTeamFitnessStatsMetaDataAttributes();
     Relations = new RoTeamFitnessStatsMetaDataRelations();

}


export type RoTeamFitnessStatsQueryBuilder = DwQueryBuilderGen<RoTeamFitnessStatsEntity, RoTeamFitnessStatsMetaDataAttributes,RoTeamFitnessStatsMetaDataRelations>


export class RoTeamFitnessStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roTeamFitnessStats';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    TeamSlug = new DwItemAttribute(this.i, 'TeamSlug');
    IsPrivateTeam = new DwItemAttribute(this.i, 'IsPrivateTeam');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    MemberCount = new DwItemAttribute(this.i, 'MemberCount');
    SummarizedMemberCount = new DwItemAttribute(this.i, 'SummarizedMemberCount');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    StatsUpdatedDateTime = new DwItemAttribute(this.i, 'StatsUpdatedDateTime');
}

class RoTeamFitnessStatsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoUserDonationsMetaData implements DwItem2<RoUserDonationsEntity, RoUserDonationsMetaDataAttributes,RoUserDonationsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=270;
        this.ItemDetail.itemName='roUserDonations';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoUserDonationsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoUserDonationsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoUserDonationsEntity, RoUserDonationsMetaDataAttributes,RoUserDonationsMetaDataRelations>(query, this);
    }
     Attributes = new RoUserDonationsMetaDataAttributes();
     Relations = new RoUserDonationsMetaDataRelations();

}


export type RoUserDonationsQueryBuilder = DwQueryBuilderGen<RoUserDonationsEntity, RoUserDonationsMetaDataAttributes,RoUserDonationsMetaDataRelations>


export class RoUserDonationsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roUserDonations';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserFullName = new DwItemAttribute(this.i, 'UserFullName');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    ChallengeDefinitionName = new DwItemAttribute(this.i, 'ChallengeDefinitionName');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    TeamMemberCount = new DwItemAttribute(this.i, 'TeamMemberCount');
    OrderDetailId = new DwItemAttribute(this.i, 'OrderDetailId');
    DonationAmount = new DwItemAttribute(this.i, 'DonationAmount');
}

class RoUserDonationsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoUserFitnessActivityStatsMetaData implements DwItem2<RoUserFitnessActivityStatsEntity, RoUserFitnessActivityStatsMetaDataAttributes,RoUserFitnessActivityStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=311;
        this.ItemDetail.itemName='roUserFitnessActivityStats';
        this.ItemDetail.keyName='UserFitnessSummaryRollupId';
    }

    CreateEntity(): RoUserFitnessActivityStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoUserFitnessActivityStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoUserFitnessActivityStatsEntity, RoUserFitnessActivityStatsMetaDataAttributes,RoUserFitnessActivityStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoUserFitnessActivityStatsMetaDataAttributes();
     Relations = new RoUserFitnessActivityStatsMetaDataRelations();

}


export type RoUserFitnessActivityStatsQueryBuilder = DwQueryBuilderGen<RoUserFitnessActivityStatsEntity, RoUserFitnessActivityStatsMetaDataAttributes,RoUserFitnessActivityStatsMetaDataRelations>


export class RoUserFitnessActivityStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roUserFitnessActivityStats';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    ProfileSlug = new DwItemAttribute(this.i, 'ProfileSlug');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    UserFitnessSummaryId = new DwItemAttribute(this.i, 'UserFitnessSummaryId');
    UserFitnessSummaryRollupId = new DwItemAttribute(this.i, 'UserFitnessSummaryRollupId');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    ActivityTypeName = new DwItemAttribute(this.i, 'ActivityTypeName');
    IconCss = new DwItemAttribute(this.i, 'IconCss');
    CountDisplay = new DwItemAttribute(this.i, 'CountDisplay');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDistanceMeters = new DwItemAttribute(this.i, 'TotalDistanceMeters');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    TotalRepCount = new DwItemAttribute(this.i, 'TotalRepCount');
    TotalElevationGainMeters = new DwItemAttribute(this.i, 'TotalElevationGainMeters');
    AveragePaceMetersPerSecond = new DwItemAttribute(this.i, 'AveragePaceMetersPerSecond');
    FastestPaceMetersPerSecond = new DwItemAttribute(this.i, 'FastestPaceMetersPerSecond');
    SlowestPaceMetersPerSecond = new DwItemAttribute(this.i, 'SlowestPaceMetersPerSecond');
    AverageDistanceMeters = new DwItemAttribute(this.i, 'AverageDistanceMeters');
    LongestDistanceMeters = new DwItemAttribute(this.i, 'LongestDistanceMeters');
    ShortestDistanceMeters = new DwItemAttribute(this.i, 'ShortestDistanceMeters');
    StatsUpdatedDateTime = new DwItemAttribute(this.i, 'StatsUpdatedDateTime');
}

class RoUserFitnessActivityStatsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoUserFitnessStatsMetaData implements DwItem2<RoUserFitnessStatsEntity, RoUserFitnessStatsMetaDataAttributes,RoUserFitnessStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=312;
        this.ItemDetail.itemName='roUserFitnessStats';
        this.ItemDetail.keyName='UserFitnessSummaryId';
    }

    CreateEntity(): RoUserFitnessStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoUserFitnessStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoUserFitnessStatsEntity, RoUserFitnessStatsMetaDataAttributes,RoUserFitnessStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoUserFitnessStatsMetaDataAttributes();
     Relations = new RoUserFitnessStatsMetaDataRelations();

}


export type RoUserFitnessStatsQueryBuilder = DwQueryBuilderGen<RoUserFitnessStatsEntity, RoUserFitnessStatsMetaDataAttributes,RoUserFitnessStatsMetaDataRelations>


export class RoUserFitnessStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roUserFitnessStats';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    ProfileSlug = new DwItemAttribute(this.i, 'ProfileSlug');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    UserFitnessSummaryId = new DwItemAttribute(this.i, 'UserFitnessSummaryId');
    UserChallengeStatusId = new DwItemAttribute(this.i, 'UserChallengeStatusId');
    TotalExerciseDays = new DwItemAttribute(this.i, 'TotalExerciseDays');
    TotalMissedDays = new DwItemAttribute(this.i, 'TotalMissedDays');
    TotalPenaltyDays = new DwItemAttribute(this.i, 'TotalPenaltyDays');
    LongestStreakDays = new DwItemAttribute(this.i, 'LongestStreakDays');
    CurrentStreakDays = new DwItemAttribute(this.i, 'CurrentStreakDays');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    AverageDurationSeconds = new DwItemAttribute(this.i, 'AverageDurationSeconds');
    LastActivityDate = new DwItemAttribute(this.i, 'LastActivityDate');
    StatsUpdatedDateTime = new DwItemAttribute(this.i, 'StatsUpdatedDateTime');
}

class RoUserFitnessStatsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoUserProfileDisplayMetaData implements DwItem2<RoUserProfileDisplayEntity, RoUserProfileDisplayMetaDataAttributes,RoUserProfileDisplayMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=302;
        this.ItemDetail.itemName='roUserProfileDisplay';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoUserProfileDisplayEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoUserProfileDisplayQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoUserProfileDisplayEntity, RoUserProfileDisplayMetaDataAttributes,RoUserProfileDisplayMetaDataRelations>(query, this);
    }
     Attributes = new RoUserProfileDisplayMetaDataAttributes();
     Relations = new RoUserProfileDisplayMetaDataRelations();

}


export type RoUserProfileDisplayQueryBuilder = DwQueryBuilderGen<RoUserProfileDisplayEntity, RoUserProfileDisplayMetaDataAttributes,RoUserProfileDisplayMetaDataRelations>


export class RoUserProfileDisplayMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roUserProfileDisplay';
    // Attributes
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    ProfileSlug = new DwItemAttribute(this.i, 'ProfileSlug');
    UserDescription = new DwItemAttribute(this.i, 'UserDescription');
    UploadedAvatarMediaId = new DwItemAttribute(this.i, 'UploadedAvatarMediaId');
    UploadedBannerMediaId = new DwItemAttribute(this.i, 'UploadedBannerMediaId');
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    BannerColorStart = new DwItemAttribute(this.i, 'BannerColorStart');
    BannerColorEnd = new DwItemAttribute(this.i, 'BannerColorEnd');
    BannerUseGradient = new DwItemAttribute(this.i, 'BannerUseGradient');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    BannerAnimationKey = new DwItemAttribute(this.i, 'BannerAnimationKey');
    AvatarImageMode = new DwItemAttribute(this.i, 'AvatarImageMode');
    BannerImageMode = new DwItemAttribute(this.i, 'BannerImageMode');
    AvatarMediaId = new DwItemAttribute(this.i, 'AvatarMediaId');
    AvatarMediaPath = new DwItemAttribute(this.i, 'AvatarMediaPath');
    AvatarWidth = new DwItemAttribute(this.i, 'AvatarWidth');
    AvatarHeight = new DwItemAttribute(this.i, 'AvatarHeight');
    BannerMediaId = new DwItemAttribute(this.i, 'BannerMediaId');
    BannerMediaPath = new DwItemAttribute(this.i, 'BannerMediaPath');
    BannerWidth = new DwItemAttribute(this.i, 'BannerWidth');
    BannerHeight = new DwItemAttribute(this.i, 'BannerHeight');
}

class RoUserProfileDisplayMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Challenge */
            UserChallengeByUserProfileId = new DwItemRelationship('roUserProfileDisplay|UserChallenge|UserProfileId', 'UserChallenge', 'UserChallenge');
    };
export class DwShippingRateMetaData implements DwItem2<DwShippingRateEntity, DwShippingRateMetaDataAttributes,DwShippingRateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=266;
        this.ItemDetail.itemName='dw_ShippingRate';
        this.ItemDetail.keyName='ShippingRateId';
    }

    CreateEntity(): DwShippingRateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwShippingRateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwShippingRateEntity, DwShippingRateMetaDataAttributes,DwShippingRateMetaDataRelations>(query, this);
    }
     Attributes = new DwShippingRateMetaDataAttributes();
     Relations = new DwShippingRateMetaDataRelations();

}


export type DwShippingRateQueryBuilder = DwQueryBuilderGen<DwShippingRateEntity, DwShippingRateMetaDataAttributes,DwShippingRateMetaDataRelations>


export class DwShippingRateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ShippingRate';
    // Attributes
    ShippingRateId = new DwItemAttribute(this.i, 'ShippingRateId');
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PostalPrefix = new DwItemAttribute(this.i, 'PostalPrefix');
    BaseAmount = new DwItemAttribute(this.i, 'BaseAmount');
    AdditionalUnitAmount = new DwItemAttribute(this.i, 'AdditionalUnitAmount');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwShippingRateMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Country */
            DwCountry = new DwItemRelationship('dw_Country|dw_ShippingRate|CountryId', 'DwCountry', 'DwCountry');
            /** Relation: State Province */
            DwStateProvince = new DwItemRelationship('dw_StateProvince|dw_ShippingRate|StateProvinceId', 'DwStateProvince', 'DwStateProvince');
    };
export class ShirtSizeMetaData implements DwItem2<ShirtSizeEntity, ShirtSizeMetaDataAttributes,ShirtSizeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=161;
        this.ItemDetail.itemName='ShirtSize';
        this.ItemDetail.keyName='ShirtSizeId';
    }

    CreateEntity(): ShirtSizeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ShirtSizeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ShirtSizeEntity, ShirtSizeMetaDataAttributes,ShirtSizeMetaDataRelations>(query, this);
    }
     Attributes = new ShirtSizeMetaDataAttributes();
     Relations = new ShirtSizeMetaDataRelations();

}


export type ShirtSizeQueryBuilder = DwQueryBuilderGen<ShirtSizeEntity, ShirtSizeMetaDataAttributes,ShirtSizeMetaDataRelations>


export class ShirtSizeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ShirtSize';
    // Attributes
    ShirtSizeId = new DwItemAttribute(this.i, 'ShirtSizeId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ShirtSize = new DwItemAttribute(this.i, 'ShirtSize');
    Cost = new DwItemAttribute(this.i, 'Cost');
    ShippingCost = new DwItemAttribute(this.i, 'ShippingCost');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ShirtSizeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|ShirtSize|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('ShirtSize|UserChallenge|ShirtSizeId', 'UserChallenge', 'UserChallenge');
    };
export class DwShoppingCartRuleMetaData implements DwItem2<DwShoppingCartRuleEntity, DwShoppingCartRuleMetaDataAttributes,DwShoppingCartRuleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=162;
        this.ItemDetail.itemName='dw_ShoppingCartRule';
        this.ItemDetail.keyName='ShoppingCartRuleId';
    }

    CreateEntity(): DwShoppingCartRuleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwShoppingCartRuleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwShoppingCartRuleEntity, DwShoppingCartRuleMetaDataAttributes,DwShoppingCartRuleMetaDataRelations>(query, this);
    }
     Attributes = new DwShoppingCartRuleMetaDataAttributes();
     Relations = new DwShoppingCartRuleMetaDataRelations();

}


export type DwShoppingCartRuleQueryBuilder = DwQueryBuilderGen<DwShoppingCartRuleEntity, DwShoppingCartRuleMetaDataAttributes,DwShoppingCartRuleMetaDataRelations>


export class DwShoppingCartRuleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ShoppingCartRule';
    // Attributes
    ShoppingCartRuleId = new DwItemAttribute(this.i, 'ShoppingCartRuleId');
    PromotionCode = new DwItemAttribute(this.i, 'PromotionCode');
    RuleName = new DwItemAttribute(this.i, 'RuleName');
    RuleDescription = new DwItemAttribute(this.i, 'RuleDescription');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    AllowedUses = new DwItemAttribute(this.i, 'AllowedUses');
    UsesPerCustomer = new DwItemAttribute(this.i, 'UsesPerCustomer');
    CurrentUses = new DwItemAttribute(this.i, 'CurrentUses');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwShoppingCartRuleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Shopping Cart Rule Action */
            DwShoppingCartRuleAction = new DwItemRelationship('dw_ShoppingCartRule|dw_ShoppingCartRuleAction|ShoppingCartRuleId', 'DwShoppingCartRuleAction', 'DwShoppingCartRuleAction');
            /** Relation: Shopping Cart Rule Condition */
            DwShoppingCartRuleCondition = new DwItemRelationship('dw_ShoppingCartRule|dw_ShoppingCartRuleCondition|ShoppingCartRuleId', 'DwShoppingCartRuleCondition', 'DwShoppingCartRuleCondition');
    };
export class DwShoppingCartRuleActionMetaData implements DwItem2<DwShoppingCartRuleActionEntity, DwShoppingCartRuleActionMetaDataAttributes,DwShoppingCartRuleActionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=166;
        this.ItemDetail.itemName='dw_ShoppingCartRuleAction';
        this.ItemDetail.keyName='ShoppingCartRuleActionId';
    }

    CreateEntity(): DwShoppingCartRuleActionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwShoppingCartRuleActionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwShoppingCartRuleActionEntity, DwShoppingCartRuleActionMetaDataAttributes,DwShoppingCartRuleActionMetaDataRelations>(query, this);
    }
     Attributes = new DwShoppingCartRuleActionMetaDataAttributes();
     Relations = new DwShoppingCartRuleActionMetaDataRelations();

}


export type DwShoppingCartRuleActionQueryBuilder = DwQueryBuilderGen<DwShoppingCartRuleActionEntity, DwShoppingCartRuleActionMetaDataAttributes,DwShoppingCartRuleActionMetaDataRelations>


export class DwShoppingCartRuleActionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ShoppingCartRuleAction';
    // Attributes
    ShoppingCartRuleActionId = new DwItemAttribute(this.i, 'ShoppingCartRuleActionId');
    ShoppingCartRuleId = new DwItemAttribute(this.i, 'ShoppingCartRuleId');
    ShoppingCartRuleActionTypeId = new DwItemAttribute(this.i, 'ShoppingCartRuleActionTypeId');
    DiscountAmount = new DwItemAttribute(this.i, 'DiscountAmount');
    MaximumDiscountAmount = new DwItemAttribute(this.i, 'MaximumDiscountAmount');
    PercentDiscount = new DwItemAttribute(this.i, 'PercentDiscount');
    ApplyToShippingAmount = new DwItemAttribute(this.i, 'ApplyToShippingAmount');
    FreeShipping = new DwItemAttribute(this.i, 'FreeShipping');
    MaximumProductUses = new DwItemAttribute(this.i, 'MaximumProductUses');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwShoppingCartRuleActionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Shopping Cart Rule */
            DwShoppingCartRule = new DwItemRelationship('dw_ShoppingCartRule|dw_ShoppingCartRuleAction|ShoppingCartRuleId', 'DwShoppingCartRule', 'DwShoppingCartRule');
            /** Relation: Shopping Cart Rule Action Type */
            DwShoppingCartRuleActionType = new DwItemRelationship('dw_ShoppingCartRuleActionType|dw_ShoppingCartRuleAction|ShoppingCartRuleActionTypeId', 'DwShoppingCartRuleActionType', 'DwShoppingCartRuleActionType');
    };
export class DwShoppingCartRuleActionTypeMetaData implements DwItem2<DwShoppingCartRuleActionTypeEntity, DwShoppingCartRuleActionTypeMetaDataAttributes,DwShoppingCartRuleActionTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=168;
        this.ItemDetail.itemName='dw_ShoppingCartRuleActionType';
        this.ItemDetail.keyName='ShoppingCartRuleActionTypeId';
    }

    CreateEntity(): DwShoppingCartRuleActionTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwShoppingCartRuleActionTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwShoppingCartRuleActionTypeEntity, DwShoppingCartRuleActionTypeMetaDataAttributes,DwShoppingCartRuleActionTypeMetaDataRelations>(query, this);
    }
     Attributes = new DwShoppingCartRuleActionTypeMetaDataAttributes();
     Relations = new DwShoppingCartRuleActionTypeMetaDataRelations();

}


export type DwShoppingCartRuleActionTypeQueryBuilder = DwQueryBuilderGen<DwShoppingCartRuleActionTypeEntity, DwShoppingCartRuleActionTypeMetaDataAttributes,DwShoppingCartRuleActionTypeMetaDataRelations>


export class DwShoppingCartRuleActionTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ShoppingCartRuleActionType';
    // Attributes
    ShoppingCartRuleActionTypeId = new DwItemAttribute(this.i, 'ShoppingCartRuleActionTypeId');
    ActionType = new DwItemAttribute(this.i, 'ActionType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwShoppingCartRuleActionTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Shopping Cart Rule Action */
            DwShoppingCartRuleAction = new DwItemRelationship('dw_ShoppingCartRuleActionType|dw_ShoppingCartRuleAction|ShoppingCartRuleActionTypeId', 'DwShoppingCartRuleAction', 'DwShoppingCartRuleAction');
    };
export class DwShoppingCartRuleConditionMetaData implements DwItem2<DwShoppingCartRuleConditionEntity, DwShoppingCartRuleConditionMetaDataAttributes,DwShoppingCartRuleConditionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=170;
        this.ItemDetail.itemName='dw_ShoppingCartRuleCondition';
        this.ItemDetail.keyName='ShoppingCartRuleConditionId';
    }

    CreateEntity(): DwShoppingCartRuleConditionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwShoppingCartRuleConditionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwShoppingCartRuleConditionEntity, DwShoppingCartRuleConditionMetaDataAttributes,DwShoppingCartRuleConditionMetaDataRelations>(query, this);
    }
     Attributes = new DwShoppingCartRuleConditionMetaDataAttributes();
     Relations = new DwShoppingCartRuleConditionMetaDataRelations();

}


export type DwShoppingCartRuleConditionQueryBuilder = DwQueryBuilderGen<DwShoppingCartRuleConditionEntity, DwShoppingCartRuleConditionMetaDataAttributes,DwShoppingCartRuleConditionMetaDataRelations>


export class DwShoppingCartRuleConditionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ShoppingCartRuleCondition';
    // Attributes
    ShoppingCartRuleConditionId = new DwItemAttribute(this.i, 'ShoppingCartRuleConditionId');
    ShoppingCartRuleId = new DwItemAttribute(this.i, 'ShoppingCartRuleId');
    ShoppingCartRuleConditionTypeId = new DwItemAttribute(this.i, 'ShoppingCartRuleConditionTypeId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    Amount = new DwItemAttribute(this.i, 'Amount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwShoppingCartRuleConditionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            DwProduct = new DwItemRelationship('dw_Product|dw_ShoppingCartRuleCondition|ProductId', 'DwProduct', 'DwProduct');
            /** Relation: Shopping Cart Rule */
            DwShoppingCartRule = new DwItemRelationship('dw_ShoppingCartRule|dw_ShoppingCartRuleCondition|ShoppingCartRuleId', 'DwShoppingCartRule', 'DwShoppingCartRule');
            /** Relation: Shopping Cart Rule Condition Type */
            DwShoppingCartRuleConditionType = new DwItemRelationship('dw_ShoppingCartRuleConditionType|dw_ShoppingCartRuleCondition|ShoppingCartRuleConditionTypeId', 'DwShoppingCartRuleConditionType', 'DwShoppingCartRuleConditionType');
    };
export class DwShoppingCartRuleConditionTypeMetaData implements DwItem2<DwShoppingCartRuleConditionTypeEntity, DwShoppingCartRuleConditionTypeMetaDataAttributes,DwShoppingCartRuleConditionTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=173;
        this.ItemDetail.itemName='dw_ShoppingCartRuleConditionType';
        this.ItemDetail.keyName='ShoppingCartRuleConditionTypeId';
    }

    CreateEntity(): DwShoppingCartRuleConditionTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwShoppingCartRuleConditionTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwShoppingCartRuleConditionTypeEntity, DwShoppingCartRuleConditionTypeMetaDataAttributes,DwShoppingCartRuleConditionTypeMetaDataRelations>(query, this);
    }
     Attributes = new DwShoppingCartRuleConditionTypeMetaDataAttributes();
     Relations = new DwShoppingCartRuleConditionTypeMetaDataRelations();

}


export type DwShoppingCartRuleConditionTypeQueryBuilder = DwQueryBuilderGen<DwShoppingCartRuleConditionTypeEntity, DwShoppingCartRuleConditionTypeMetaDataAttributes,DwShoppingCartRuleConditionTypeMetaDataRelations>


export class DwShoppingCartRuleConditionTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ShoppingCartRuleConditionType';
    // Attributes
    ShoppingCartRuleConditionTypeId = new DwItemAttribute(this.i, 'ShoppingCartRuleConditionTypeId');
    ConditionType = new DwItemAttribute(this.i, 'ConditionType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwShoppingCartRuleConditionTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Shopping Cart Rule Condition */
            DwShoppingCartRuleCondition = new DwItemRelationship('dw_ShoppingCartRuleConditionType|dw_ShoppingCartRuleCondition|ShoppingCartRuleConditionTypeId', 'DwShoppingCartRuleCondition', 'DwShoppingCartRuleCondition');
    };
export class DwStateProvinceMetaData implements DwItem2<DwStateProvinceEntity, DwStateProvinceMetaDataAttributes,DwStateProvinceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=257;
        this.ItemDetail.itemName='dw_StateProvince';
        this.ItemDetail.keyName='StateProvinceId';
    }

    CreateEntity(): DwStateProvinceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwStateProvinceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwStateProvinceEntity, DwStateProvinceMetaDataAttributes,DwStateProvinceMetaDataRelations>(query, this);
    }
     Attributes = new DwStateProvinceMetaDataAttributes();
     Relations = new DwStateProvinceMetaDataRelations();

}


export type DwStateProvinceQueryBuilder = DwQueryBuilderGen<DwStateProvinceEntity, DwStateProvinceMetaDataAttributes,DwStateProvinceMetaDataRelations>


export class DwStateProvinceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_StateProvince';
    // Attributes
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    StateProvinceName = new DwItemAttribute(this.i, 'StateProvinceName');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    StateCode = new DwItemAttribute(this.i, 'StateCode');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class DwStateProvinceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Country */
            DwCountry = new DwItemRelationship('dw_Country|dw_StateProvince|CountryId', 'DwCountry', 'DwCountry');
            /** Relation: Address */
            DwAddress = new DwItemRelationship('dw_StateProvince|dw_Address|StateProvinceId', 'DwAddress', 'DwAddress');
            /** Relation: Postal Code */
            DwPostalCode = new DwItemRelationship('dw_StateProvince|dw_PostalCode|StateProvinceId', 'DwPostalCode', 'DwPostalCode');
            /** Relation: Shipping Rate */
            DwShippingRate = new DwItemRelationship('dw_StateProvince|dw_ShippingRate|StateProvinceId', 'DwShippingRate', 'DwShippingRate');
    };
export class StatsDedup20261015RollupBackupMetaData implements DwItem2<StatsDedup20261015RollupBackupEntity, StatsDedup20261015RollupBackupMetaDataAttributes,StatsDedup20261015RollupBackupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=309;
        this.ItemDetail.itemName='StatsDedup20261015RollupBackup';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): StatsDedup20261015RollupBackupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StatsDedup20261015RollupBackupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StatsDedup20261015RollupBackupEntity, StatsDedup20261015RollupBackupMetaDataAttributes,StatsDedup20261015RollupBackupMetaDataRelations>(query, this);
    }
     Attributes = new StatsDedup20261015RollupBackupMetaDataAttributes();
     Relations = new StatsDedup20261015RollupBackupMetaDataRelations();

}


export type StatsDedup20261015RollupBackupQueryBuilder = DwQueryBuilderGen<StatsDedup20261015RollupBackupEntity, StatsDedup20261015RollupBackupMetaDataAttributes,StatsDedup20261015RollupBackupMetaDataRelations>


export class StatsDedup20261015RollupBackupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StatsDedup20261015RollupBackup';
    // Attributes
    UserFitnessSummaryRollupId = new DwItemAttribute(this.i, 'UserFitnessSummaryRollupId');
    UserFitnessSummaryId = new DwItemAttribute(this.i, 'UserFitnessSummaryId');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDistanceMeters = new DwItemAttribute(this.i, 'TotalDistanceMeters');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    TotalElevationGainMeters = new DwItemAttribute(this.i, 'TotalElevationGainMeters');
    AveragePaceMetersPerSecond = new DwItemAttribute(this.i, 'AveragePaceMetersPerSecond');
    FastestPaceMetersPerSecond = new DwItemAttribute(this.i, 'FastestPaceMetersPerSecond');
    SlowestPaceMetersPerSecond = new DwItemAttribute(this.i, 'SlowestPaceMetersPerSecond');
    AverageDistanceMeters = new DwItemAttribute(this.i, 'AverageDistanceMeters');
    LongestDistanceMeters = new DwItemAttribute(this.i, 'LongestDistanceMeters');
    ShortestDistanceMeters = new DwItemAttribute(this.i, 'ShortestDistanceMeters');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    TotalRepCount = new DwItemAttribute(this.i, 'TotalRepCount');
    DeletedByStatsCleanup = new DwItemAttribute(this.i, 'DeletedByStatsCleanup');
    StatsCleanupSurvivorSummaryId = new DwItemAttribute(this.i, 'StatsCleanupSurvivorSummaryId');
    StatsCleanupSurvivorRollupId = new DwItemAttribute(this.i, 'StatsCleanupSurvivorRollupId');
    StatsCleanupOperationId = new DwItemAttribute(this.i, 'StatsCleanupOperationId');
    StatsCleanupBackupDateTime = new DwItemAttribute(this.i, 'StatsCleanupBackupDateTime');
}

class StatsDedup20261015RollupBackupMetaDataRelations implements DwItemRelationshipCollection {
    };
export class StatsDedup20261015SummaryBackupMetaData implements DwItem2<StatsDedup20261015SummaryBackupEntity, StatsDedup20261015SummaryBackupMetaDataAttributes,StatsDedup20261015SummaryBackupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=310;
        this.ItemDetail.itemName='StatsDedup20261015SummaryBackup';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): StatsDedup20261015SummaryBackupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StatsDedup20261015SummaryBackupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StatsDedup20261015SummaryBackupEntity, StatsDedup20261015SummaryBackupMetaDataAttributes,StatsDedup20261015SummaryBackupMetaDataRelations>(query, this);
    }
     Attributes = new StatsDedup20261015SummaryBackupMetaDataAttributes();
     Relations = new StatsDedup20261015SummaryBackupMetaDataRelations();

}


export type StatsDedup20261015SummaryBackupQueryBuilder = DwQueryBuilderGen<StatsDedup20261015SummaryBackupEntity, StatsDedup20261015SummaryBackupMetaDataAttributes,StatsDedup20261015SummaryBackupMetaDataRelations>


export class StatsDedup20261015SummaryBackupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StatsDedup20261015SummaryBackup';
    // Attributes
    UserFitnessSummaryId = new DwItemAttribute(this.i, 'UserFitnessSummaryId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserChallengeStatusId = new DwItemAttribute(this.i, 'UserChallengeStatusId');
    TotalExerciseDays = new DwItemAttribute(this.i, 'TotalExerciseDays');
    TotalMissedDays = new DwItemAttribute(this.i, 'TotalMissedDays');
    TotalPenaltyDays = new DwItemAttribute(this.i, 'TotalPenaltyDays');
    LongestStreakDays = new DwItemAttribute(this.i, 'LongestStreakDays');
    CurrentStreakDays = new DwItemAttribute(this.i, 'CurrentStreakDays');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    AverageDurationSeconds = new DwItemAttribute(this.i, 'AverageDurationSeconds');
    LastActivityDate = new DwItemAttribute(this.i, 'LastActivityDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    DeletedByStatsCleanup = new DwItemAttribute(this.i, 'DeletedByStatsCleanup');
    StatsCleanupSurvivorSummaryId = new DwItemAttribute(this.i, 'StatsCleanupSurvivorSummaryId');
    StatsCleanupOperationId = new DwItemAttribute(this.i, 'StatsCleanupOperationId');
    StatsCleanupBackupDateTime = new DwItemAttribute(this.i, 'StatsCleanupBackupDateTime');
}

class StatsDedup20261015SummaryBackupMetaDataRelations implements DwItemRelationshipCollection {
    };
export class DwTimeZoneMetaData implements DwItem2<DwTimeZoneEntity, DwTimeZoneMetaDataAttributes,DwTimeZoneMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=258;
        this.ItemDetail.itemName='dw_TimeZone';
        this.ItemDetail.keyName='TimeZoneId';
    }

    CreateEntity(): DwTimeZoneEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwTimeZoneQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwTimeZoneEntity, DwTimeZoneMetaDataAttributes,DwTimeZoneMetaDataRelations>(query, this);
    }
     Attributes = new DwTimeZoneMetaDataAttributes();
     Relations = new DwTimeZoneMetaDataRelations();

}


export type DwTimeZoneQueryBuilder = DwQueryBuilderGen<DwTimeZoneEntity, DwTimeZoneMetaDataAttributes,DwTimeZoneMetaDataRelations>


export class DwTimeZoneMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_TimeZone';
    // Attributes
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
    TimeZoneName = new DwItemAttribute(this.i, 'TimeZoneName');
    TimeZoneShortName = new DwItemAttribute(this.i, 'TimeZoneShortName');
    GmtOffSet = new DwItemAttribute(this.i, 'GmtOffSet');
    TimeZoneDescription = new DwItemAttribute(this.i, 'TimeZoneDescription');
    IANAIdentifier = new DwItemAttribute(this.i, 'IANAIdentifier');
    DotNetBCLIdentifier = new DwItemAttribute(this.i, 'DotNetBCLIdentifier');
}

class DwTimeZoneMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Timezone - Many */
            DwAddressByTimezoneId = new DwItemRelationship('dw_TimeZone|dw_Address|TimezoneId', 'TimezoneIdDwAddress', 'TimezoneIdDwAddress');
    };
export class UnitOfMeasureMetaData implements DwItem2<UnitOfMeasureEntity, UnitOfMeasureMetaDataAttributes,UnitOfMeasureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=164;
        this.ItemDetail.itemName='UnitOfMeasure';
        this.ItemDetail.keyName='UnitOfMeasureId';
    }

    CreateEntity(): UnitOfMeasureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitOfMeasureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitOfMeasureEntity, UnitOfMeasureMetaDataAttributes,UnitOfMeasureMetaDataRelations>(query, this);
    }
     Attributes = new UnitOfMeasureMetaDataAttributes();
     Relations = new UnitOfMeasureMetaDataRelations();

}


export type UnitOfMeasureQueryBuilder = DwQueryBuilderGen<UnitOfMeasureEntity, UnitOfMeasureMetaDataAttributes,UnitOfMeasureMetaDataRelations>


export class UnitOfMeasureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitOfMeasure';
    // Attributes
    UnitOfMeasureId = new DwItemAttribute(this.i, 'UnitOfMeasureId');
    UOMName = new DwItemAttribute(this.i, 'UOMName');
    MultiplierToBase = new DwItemAttribute(this.i, 'MultiplierToBase');
    UnitOfMeasureTypeId = new DwItemAttribute(this.i, 'UnitOfMeasureTypeId');
    UOMShortName = new DwItemAttribute(this.i, 'UOMShortName');
    UOMNameSingular = new DwItemAttribute(this.i, 'UOMNameSingular');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitOfMeasureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Unit Of Measure Type */
            UnitOfMeasureType = new DwItemRelationship('UnitOfMeasureType|UnitOfMeasure|UnitOfMeasureTypeId', 'UnitOfMeasureType', 'UnitOfMeasureType');
            /** Relation: Fitness Activity - Distance - Many */
            FitnessActivityByDistanceUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivity|DistanceUnitOfMeasureId', 'DistanceFitnessActivity', 'DistanceFitnessActivity');
            /** Relation: Fitness Activity - Lap - Many */
            FitnessActivityByLapUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivity|LapUnitOfMeasureId', 'LapFitnessActivity', 'LapFitnessActivity');
            /** Relation: Fitness Activity - Elevation Gain - Many */
            FitnessActivityByElevationGainUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivity|ElevationGainUnitOfMeasureId', 'ElevationGainFitnessActivity', 'ElevationGainFitnessActivity');
            /** Relation: Fitness Activity Display Group - Default - Many */
            FitnessActivityDisplayGroupByDefaultUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|FitnessActivityDisplayGroup|DefaultUnitOfMeasureId', 'DefaultFitnessActivityDisplayGroup', 'DefaultFitnessActivityDisplayGroup');
            /** Relation: Fitness Activity Display Group U O M */
            FitnessActivityDisplayGroupUOM = new DwItemRelationship('UnitOfMeasure|FitnessActivityDisplayGroupUOM|UnitOfMeasureId', 'FitnessActivityDisplayGroupUOM', 'FitnessActivityDisplayGroupUOM');
            /** Relation: Unit Of Measure Type - Base - Many */
            UnitOfMeasureTypeByBaseUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|UnitOfMeasureType|BaseUnitOfMeasureId', 'BaseUnitOfMeasureType', 'BaseUnitOfMeasureType');
    };
export class UnitOfMeasureTypeMetaData implements DwItem2<UnitOfMeasureTypeEntity, UnitOfMeasureTypeMetaDataAttributes,UnitOfMeasureTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=176;
        this.ItemDetail.itemName='UnitOfMeasureType';
        this.ItemDetail.keyName='UnitOfMeasureTypeId';
    }

    CreateEntity(): UnitOfMeasureTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UnitOfMeasureTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UnitOfMeasureTypeEntity, UnitOfMeasureTypeMetaDataAttributes,UnitOfMeasureTypeMetaDataRelations>(query, this);
    }
     Attributes = new UnitOfMeasureTypeMetaDataAttributes();
     Relations = new UnitOfMeasureTypeMetaDataRelations();

}


export type UnitOfMeasureTypeQueryBuilder = DwQueryBuilderGen<UnitOfMeasureTypeEntity, UnitOfMeasureTypeMetaDataAttributes,UnitOfMeasureTypeMetaDataRelations>


export class UnitOfMeasureTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UnitOfMeasureType';
    // Attributes
    UnitOfMeasureTypeId = new DwItemAttribute(this.i, 'UnitOfMeasureTypeId');
    TypeName = new DwItemAttribute(this.i, 'TypeName');
    BaseUnitOfMeasureId = new DwItemAttribute(this.i, 'BaseUnitOfMeasureId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UnitOfMeasureTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Unit Of Measure - Base Unit Of Measure */
            UnitOfMeasureByBaseUnitOfMeasureId = new DwItemRelationship('UnitOfMeasure|UnitOfMeasureType|BaseUnitOfMeasureId', 'BaseUnitOfMeasure', 'BaseUnitOfMeasure');
            /** Relation: Unit Of Measure */
            UnitOfMeasure = new DwItemRelationship('UnitOfMeasureType|UnitOfMeasure|UnitOfMeasureTypeId', 'UnitOfMeasure', 'UnitOfMeasure');
    };
export class DwUserMetaData implements DwItem2<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=46;
        this.ItemDetail.itemName='dw_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): DwUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations>(query, this);
    }
     Attributes = new DwUserMetaDataAttributes();
     Relations = new DwUserMetaDataRelations();

}


export type DwUserQueryBuilder = DwQueryBuilderGen<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations>


export class DwUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_User';
    // Attributes
    AlternateName = new DwItemAttribute(this.i, 'AlternateName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    Email = new DwItemAttribute(this.i, 'Email');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    ForcePasswordChange = new DwItemAttribute(this.i, 'ForcePasswordChange');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsEmailVerified = new DwItemAttribute(this.i, 'IsEmailVerified');
    IsTwoFactorAuthenticationEnabled = new DwItemAttribute(this.i, 'IsTwoFactorAuthenticationEnabled');
    LastLoginDateTime = new DwItemAttribute(this.i, 'LastLoginDateTime');
    LastName = new DwItemAttribute(this.i, 'LastName');
    LastPasswordChangeDateTime = new DwItemAttribute(this.i, 'LastPasswordChangeDateTime');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OrganizationId = new DwItemAttribute(this.i, 'OrganizationId');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
    Password = new DwItemAttribute(this.i, 'Password');
    TwoFactorAuthenticationTypeId = new DwItemAttribute(this.i, 'TwoFactorAuthenticationTypeId');
    UserBackgroundMediaId = new DwItemAttribute(this.i, 'UserBackgroundMediaId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserKey = new DwItemAttribute(this.i, 'UserKey');
    UserName = new DwItemAttribute(this.i, 'UserName');
    UserPictureMediaId = new DwItemAttribute(this.i, 'UserPictureMediaId');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
}

class DwUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Email Challenge - Registered - Many */
            EmailChallengeByRegisteredUserId = new DwItemRelationship('dw_User|EmailChallenge|RegisteredUserId', 'RegisteredEmailChallenge', 'RegisteredEmailChallenge');
            /** Relation: Email Challenge */
            EmailChallenge = new DwItemRelationship('dw_User|EmailChallenge|UserId', 'EmailChallenge', 'EmailChallenge');
            /** Relation: Media Post */
            MediaPost = new DwItemRelationship('dw_User|MediaPost|UserId', 'MediaPost', 'MediaPost');
            /** Relation: Order */
            DwOrder = new DwItemRelationship('dw_User|dw_Order|UserId', 'DwOrder', 'DwOrder');
            /** Relation: User Challenge - Challenged By - Many */
            UserChallengeByChallengedByUserId = new DwItemRelationship('dw_User|UserChallenge|ChallengedByUserId', 'ChallengedByUserChallenge', 'ChallengedByUserChallenge');
            /** Relation: User Challenge Email */
            UserChallengeEmail = new DwItemRelationship('dw_User|UserChallengeEmail|UserId', 'UserChallengeEmail', 'UserChallengeEmail');
            /** Relation: User Payment */
            DwUserPayment = new DwItemRelationship('dw_User|dw_UserPayment|UserId', 'DwUserPayment', 'DwUserPayment');
            /** Relation: User Profile */
            UserProfile = new DwItemRelationship('dw_User|UserProfile|UserId', 'UserProfile', 'UserProfile');
    };
export class UserChallengeMetaData implements DwItem2<UserChallengeEntity, UserChallengeMetaDataAttributes,UserChallengeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=191;
        this.ItemDetail.itemName='UserChallenge';
        this.ItemDetail.keyName='UserChallengeId';
    }

    CreateEntity(): UserChallengeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeEntity, UserChallengeMetaDataAttributes,UserChallengeMetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeMetaDataAttributes();
     Relations = new UserChallengeMetaDataRelations();

}


export type UserChallengeQueryBuilder = DwQueryBuilderGen<UserChallengeEntity, UserChallengeMetaDataAttributes,UserChallengeMetaDataRelations>


export class UserChallengeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallenge';
    // Attributes
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    IncludeShirt = new DwItemAttribute(this.i, 'IncludeShirt');
    MailShirt = new DwItemAttribute(this.i, 'MailShirt');
    ShirtSizeId = new DwItemAttribute(this.i, 'ShirtSizeId');
    ShirtDeliveryCv = new DwItemAttribute(this.i, 'ShirtDeliveryCv');
    ShirtDeliveryInstructions = new DwItemAttribute(this.i, 'ShirtDeliveryInstructions');
    IsRegistrationComplete = new DwItemAttribute(this.i, 'IsRegistrationComplete');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    YearsStreakingCv = new DwItemAttribute(this.i, 'YearsStreakingCv');
    OrderId = new DwItemAttribute(this.i, 'OrderId');
    MarketingSourceCv = new DwItemAttribute(this.i, 'MarketingSourceCv');
    MarketingSourceOther = new DwItemAttribute(this.i, 'MarketingSourceOther');
    ChallengeCodeUsed = new DwItemAttribute(this.i, 'ChallengeCodeUsed');
    ChallengedByUserId = new DwItemAttribute(this.i, 'ChallengedByUserId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class UserChallengeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Challenge Definition */
            ChallengeDefinition = new DwItemRelationship('ChallengeDefinition|UserChallenge|ChallengeDefinitionId', 'ChallengeDefinition', 'ChallengeDefinition');
            /** Relation: Marketing Source - Marketing Source */
            MarketingSourceByMarketingSourceCv = new DwItemRelationship('MarketingSource|UserChallenge|MarketingSourceCv', 'MarketingSourceCvMarketingSource', 'MarketingSourceCvMarketingSource');
            /** Relation: Order */
            DwOrder = new DwItemRelationship('dw_Order|UserChallenge|OrderId', 'DwOrder', 'DwOrder');
            /** Relation: Ro User Profile Display */
            RoUserProfileDisplayByUserProfileId = new DwItemRelationship('roUserProfileDisplay|UserChallenge|UserProfileId', 'RoUserProfileDisplay', 'RoUserProfileDisplay');
            /** Relation: Shirt Size */
            ShirtSize = new DwItemRelationship('ShirtSize|UserChallenge|ShirtSizeId', 'ShirtSize', 'ShirtSize');
            /** Relation: User - Challenged By User */
            DwUserByChallengedByUserId = new DwItemRelationship('dw_User|UserChallenge|ChallengedByUserId', 'ChallengedByDwUser', 'ChallengedByDwUser');
            /** Relation: User Profile */
            UserProfile = new DwItemRelationship('UserProfile|UserChallenge|UserProfileId', 'UserProfile', 'UserProfile');
            /** Relation: Years Streaking - Years Streaking */
            YearsStreakingByYearsStreakingCv = new DwItemRelationship('YearsStreaking|UserChallenge|YearsStreakingCv', 'YearsStreakingCvYearsStreaking', 'YearsStreakingCvYearsStreaking');
            /** Relation: Badge Subject */
            BadgeSubject = new DwItemRelationship('UserChallenge|BadgeSubject|UserChallengeId', 'BadgeSubject', 'BadgeSubject');
            /** Relation: Badge Subject - Challenge Definition - Many */
            BadgeSubjectByChallengeDefinitionId = new DwItemRelationship('UserChallenge|BadgeSubject|ChallengeDefinitionId', 'ChallengeDefinitionIdBadgeSubject', 'ChallengeDefinitionIdBadgeSubject');
            /** Relation: Challenge Team Join Request */
            ChallengeTeamJoinRequest = new DwItemRelationship('UserChallenge|ChallengeTeamJoinRequest|UserChallengeId', 'ChallengeTeamJoinRequest', 'ChallengeTeamJoinRequest');
            /** Relation: Challenge Team Member */
            ChallengeTeamMember = new DwItemRelationship('UserChallenge|ChallengeTeamMember|UserChallengeId', 'ChallengeTeamMember', 'ChallengeTeamMember');
            /** Relation: Fitness Activity */
            FitnessActivity = new DwItemRelationship('UserChallenge|FitnessActivity|UserChallengeId', 'FitnessActivity', 'FitnessActivity');
            /** Relation: Registration Order Detail */
            RegistrationOrderDetail = new DwItemRelationship('UserChallenge|RegistrationOrderDetail|UserChallengeId', 'RegistrationOrderDetail', 'RegistrationOrderDetail');
            /** Relation: User Challenge Comment - From - Many */
            UserChallengeCommentByFromUserChallengeId = new DwItemRelationship('UserChallenge|UserChallengeComment|FromUserChallengeId', 'FromUserChallengeComment', 'FromUserChallengeComment');
            /** Relation: User Challenge Comment */
            UserChallengeComment = new DwItemRelationship('UserChallenge|UserChallengeComment|UserChallengeId', 'UserChallengeComment', 'UserChallengeComment');
            /** Relation: User Challenge Comment Recipient - Recipient - Many */
            UserChallengeCommentRecipientByRecipientUserChallengeId = new DwItemRelationship('UserChallenge|UserChallengeCommentRecipient|RecipientUserChallengeId', 'RecipientUserChallengeCommentRecipient', 'RecipientUserChallengeCommentRecipient');
            /** Relation: User Challenge Email */
            UserChallengeEmail = new DwItemRelationship('UserChallenge|UserChallengeEmail|UserChallengeId', 'UserChallengeEmail', 'UserChallengeEmail');
            /** Relation: User Challenge Friend - Friend - Many */
            UserChallengeFriendByFriendUserChallengeId = new DwItemRelationship('UserChallenge|UserChallengeFriend|FriendUserChallengeId', 'FriendUserChallengeFriend', 'FriendUserChallengeFriend');
            /** Relation: User Challenge Friend */
            UserChallengeFriend = new DwItemRelationship('UserChallenge|UserChallengeFriend|UserChallengeId', 'UserChallengeFriend', 'UserChallengeFriend');
            /** Relation: User Fitness Summary */
            UserFitnessSummary = new DwItemRelationship('UserChallenge|UserFitnessSummary|UserChallengeId', 'UserFitnessSummary', 'UserFitnessSummary');
    };
export class UserChallengeCommentMetaData implements DwItem2<UserChallengeCommentEntity, UserChallengeCommentMetaDataAttributes,UserChallengeCommentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=184;
        this.ItemDetail.itemName='UserChallengeComment';
        this.ItemDetail.keyName='UserChallengeCommentId';
    }

    CreateEntity(): UserChallengeCommentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeCommentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeCommentEntity, UserChallengeCommentMetaDataAttributes,UserChallengeCommentMetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeCommentMetaDataAttributes();
     Relations = new UserChallengeCommentMetaDataRelations();

}


export type UserChallengeCommentQueryBuilder = DwQueryBuilderGen<UserChallengeCommentEntity, UserChallengeCommentMetaDataAttributes,UserChallengeCommentMetaDataRelations>


export class UserChallengeCommentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeComment';
    // Attributes
    UserChallengeCommentId = new DwItemAttribute(this.i, 'UserChallengeCommentId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    FitnessActivityId = new DwItemAttribute(this.i, 'FitnessActivityId');
    UserChallengeCommentTypeId = new DwItemAttribute(this.i, 'UserChallengeCommentTypeId');
    FromUserChallengeId = new DwItemAttribute(this.i, 'FromUserChallengeId');
    Comment = new DwItemAttribute(this.i, 'Comment');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ParentUserChallengeCommentId = new DwItemAttribute(this.i, 'ParentUserChallengeCommentId');
    ReplyToEveryone = new DwItemAttribute(this.i, 'ReplyToEveryone');
    ClientRequestId = new DwItemAttribute(this.i, 'ClientRequestId');
}

class UserChallengeCommentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Fitness Activity */
            FitnessActivity = new DwItemRelationship('FitnessActivity|UserChallengeComment|FitnessActivityId', 'FitnessActivity', 'FitnessActivity');
            /** Relation: User Challenge - From User Challenge */
            UserChallengeByFromUserChallengeId = new DwItemRelationship('UserChallenge|UserChallengeComment|FromUserChallengeId', 'FromUserChallenge', 'FromUserChallenge');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|UserChallengeComment|UserChallengeId', 'UserChallenge', 'UserChallenge');
            /** Relation: User Challenge Comment Type */
            UserChallengeCommentType = new DwItemRelationship('UserChallengeCommentType|UserChallengeComment|UserChallengeCommentTypeId', 'UserChallengeCommentType', 'UserChallengeCommentType');
            /** Relation: User Challenge Comment Recipient */
            UserChallengeCommentRecipient = new DwItemRelationship('UserChallengeComment|UserChallengeCommentRecipient|UserChallengeCommentId', 'UserChallengeCommentRecipient', 'UserChallengeCommentRecipient');
    };
export class UserChallengeCommentLegacyLikeBackup20261013MetaData implements DwItem2<UserChallengeCommentLegacyLikeBackup20261013Entity, UserChallengeCommentLegacyLikeBackup20261013MetaDataAttributes,UserChallengeCommentLegacyLikeBackup20261013MetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=298;
        this.ItemDetail.itemName='UserChallengeComment_LegacyLikeBackup_20261013';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): UserChallengeCommentLegacyLikeBackup20261013Entity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeCommentLegacyLikeBackup20261013QueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeCommentLegacyLikeBackup20261013Entity, UserChallengeCommentLegacyLikeBackup20261013MetaDataAttributes,UserChallengeCommentLegacyLikeBackup20261013MetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeCommentLegacyLikeBackup20261013MetaDataAttributes();
     Relations = new UserChallengeCommentLegacyLikeBackup20261013MetaDataRelations();

}


export type UserChallengeCommentLegacyLikeBackup20261013QueryBuilder = DwQueryBuilderGen<UserChallengeCommentLegacyLikeBackup20261013Entity, UserChallengeCommentLegacyLikeBackup20261013MetaDataAttributes,UserChallengeCommentLegacyLikeBackup20261013MetaDataRelations>


export class UserChallengeCommentLegacyLikeBackup20261013MetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeComment_LegacyLikeBackup_20261013';
    // Attributes
    UserChallengeCommentId = new DwItemAttribute(this.i, 'UserChallengeCommentId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    FitnessActivityId = new DwItemAttribute(this.i, 'FitnessActivityId');
    UserChallengeCommentTypeId = new DwItemAttribute(this.i, 'UserChallengeCommentTypeId');
    FromUserChallengeId = new DwItemAttribute(this.i, 'FromUserChallengeId');
    Comment = new DwItemAttribute(this.i, 'Comment');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class UserChallengeCommentLegacyLikeBackup20261013MetaDataRelations implements DwItemRelationshipCollection {
    };
export class UserChallengeCommentRecipientMetaData implements DwItem2<UserChallengeCommentRecipientEntity, UserChallengeCommentRecipientMetaDataAttributes,UserChallengeCommentRecipientMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=299;
        this.ItemDetail.itemName='UserChallengeCommentRecipient';
        this.ItemDetail.keyName='UserChallengeCommentRecipientId';
    }

    CreateEntity(): UserChallengeCommentRecipientEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeCommentRecipientQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeCommentRecipientEntity, UserChallengeCommentRecipientMetaDataAttributes,UserChallengeCommentRecipientMetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeCommentRecipientMetaDataAttributes();
     Relations = new UserChallengeCommentRecipientMetaDataRelations();

}


export type UserChallengeCommentRecipientQueryBuilder = DwQueryBuilderGen<UserChallengeCommentRecipientEntity, UserChallengeCommentRecipientMetaDataAttributes,UserChallengeCommentRecipientMetaDataRelations>


export class UserChallengeCommentRecipientMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeCommentRecipient';
    // Attributes
    UserChallengeCommentRecipientId = new DwItemAttribute(this.i, 'UserChallengeCommentRecipientId');
    UserChallengeCommentId = new DwItemAttribute(this.i, 'UserChallengeCommentId');
    RecipientUserChallengeId = new DwItemAttribute(this.i, 'RecipientUserChallengeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UserChallengeCommentRecipientMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Challenge - Recipient User Challenge */
            UserChallengeByRecipientUserChallengeId = new DwItemRelationship('UserChallenge|UserChallengeCommentRecipient|RecipientUserChallengeId', 'RecipientUserChallenge', 'RecipientUserChallenge');
            /** Relation: User Challenge Comment */
            UserChallengeComment = new DwItemRelationship('UserChallengeComment|UserChallengeCommentRecipient|UserChallengeCommentId', 'UserChallengeComment', 'UserChallengeComment');
    };
export class UserChallengeCommentTypeMetaData implements DwItem2<UserChallengeCommentTypeEntity, UserChallengeCommentTypeMetaDataAttributes,UserChallengeCommentTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=187;
        this.ItemDetail.itemName='UserChallengeCommentType';
        this.ItemDetail.keyName='UserChallengeCommentTypeId';
    }

    CreateEntity(): UserChallengeCommentTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeCommentTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeCommentTypeEntity, UserChallengeCommentTypeMetaDataAttributes,UserChallengeCommentTypeMetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeCommentTypeMetaDataAttributes();
     Relations = new UserChallengeCommentTypeMetaDataRelations();

}


export type UserChallengeCommentTypeQueryBuilder = DwQueryBuilderGen<UserChallengeCommentTypeEntity, UserChallengeCommentTypeMetaDataAttributes,UserChallengeCommentTypeMetaDataRelations>


export class UserChallengeCommentTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeCommentType';
    // Attributes
    UserChallengeCommentTypeId = new DwItemAttribute(this.i, 'UserChallengeCommentTypeId');
    CommntType = new DwItemAttribute(this.i, 'CommntType');
    CommentTypeIconCss = new DwItemAttribute(this.i, 'CommentTypeIconCss');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UserChallengeCommentTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Challenge Comment */
            UserChallengeComment = new DwItemRelationship('UserChallengeCommentType|UserChallengeComment|UserChallengeCommentTypeId', 'UserChallengeComment', 'UserChallengeComment');
    };
export class UserChallengeEmailMetaData implements DwItem2<UserChallengeEmailEntity, UserChallengeEmailMetaDataAttributes,UserChallengeEmailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=189;
        this.ItemDetail.itemName='UserChallengeEmail';
        this.ItemDetail.keyName='UserChallengeEmailId';
    }

    CreateEntity(): UserChallengeEmailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeEmailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeEmailEntity, UserChallengeEmailMetaDataAttributes,UserChallengeEmailMetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeEmailMetaDataAttributes();
     Relations = new UserChallengeEmailMetaDataRelations();

}


export type UserChallengeEmailQueryBuilder = DwQueryBuilderGen<UserChallengeEmailEntity, UserChallengeEmailMetaDataAttributes,UserChallengeEmailMetaDataRelations>


export class UserChallengeEmailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeEmail';
    // Attributes
    UserChallengeEmailId = new DwItemAttribute(this.i, 'UserChallengeEmailId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    FriendName = new DwItemAttribute(this.i, 'FriendName');
    FriendEmail = new DwItemAttribute(this.i, 'FriendEmail');
    EmailSent = new DwItemAttribute(this.i, 'EmailSent');
    EmailSentDateTime = new DwItemAttribute(this.i, 'EmailSentDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    UserId = new DwItemAttribute(this.i, 'UserId');
}

class UserChallengeEmailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|UserChallengeEmail|UserId', 'DwUser', 'DwUser');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|UserChallengeEmail|UserChallengeId', 'UserChallenge', 'UserChallenge');
    };
export class UserChallengeFriendMetaData implements DwItem2<UserChallengeFriendEntity, UserChallengeFriendMetaDataAttributes,UserChallengeFriendMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=193;
        this.ItemDetail.itemName='UserChallengeFriend';
        this.ItemDetail.keyName='UserChallengeFriendId';
    }

    CreateEntity(): UserChallengeFriendEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeFriendQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeFriendEntity, UserChallengeFriendMetaDataAttributes,UserChallengeFriendMetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeFriendMetaDataAttributes();
     Relations = new UserChallengeFriendMetaDataRelations();

}


export type UserChallengeFriendQueryBuilder = DwQueryBuilderGen<UserChallengeFriendEntity, UserChallengeFriendMetaDataAttributes,UserChallengeFriendMetaDataRelations>


export class UserChallengeFriendMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeFriend';
    // Attributes
    UserChallengeFriendId = new DwItemAttribute(this.i, 'UserChallengeFriendId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    FriendUserChallengeId = new DwItemAttribute(this.i, 'FriendUserChallengeId');
    CanEnterActivities = new DwItemAttribute(this.i, 'CanEnterActivities');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UserChallengeFriendMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Challenge - Friend User Challenge */
            UserChallengeByFriendUserChallengeId = new DwItemRelationship('UserChallenge|UserChallengeFriend|FriendUserChallengeId', 'FriendUserChallenge', 'FriendUserChallenge');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|UserChallengeFriend|UserChallengeId', 'UserChallenge', 'UserChallenge');
    };
export class UserChallengeStatusMetaData implements DwItem2<UserChallengeStatusEntity, UserChallengeStatusMetaDataAttributes,UserChallengeStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=201;
        this.ItemDetail.itemName='UserChallengeStatus';
        this.ItemDetail.keyName='UserChallengeStatusId';
    }

    CreateEntity(): UserChallengeStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserChallengeStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserChallengeStatusEntity, UserChallengeStatusMetaDataAttributes,UserChallengeStatusMetaDataRelations>(query, this);
    }
     Attributes = new UserChallengeStatusMetaDataAttributes();
     Relations = new UserChallengeStatusMetaDataRelations();

}


export type UserChallengeStatusQueryBuilder = DwQueryBuilderGen<UserChallengeStatusEntity, UserChallengeStatusMetaDataAttributes,UserChallengeStatusMetaDataRelations>


export class UserChallengeStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeStatus';
    // Attributes
    UserChallengeStatusId = new DwItemAttribute(this.i, 'UserChallengeStatusId');
    UserChallengeStatus = new DwItemAttribute(this.i, 'UserChallengeStatus');
    MinDaysMissed = new DwItemAttribute(this.i, 'MinDaysMissed');
    MaxDaysMissed = new DwItemAttribute(this.i, 'MaxDaysMissed');
    Description = new DwItemAttribute(this.i, 'Description');
    IconCss = new DwItemAttribute(this.i, 'IconCss');
    LeewayDays = new DwItemAttribute(this.i, 'LeewayDays');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    BadgeOrder = new DwItemAttribute(this.i, 'BadgeOrder');
    BadgeColor = new DwItemAttribute(this.i, 'BadgeColor');
}

class UserChallengeStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Fitness Summary */
            UserFitnessSummary = new DwItemRelationship('UserChallengeStatus|UserFitnessSummary|UserChallengeStatusId', 'UserFitnessSummary', 'UserFitnessSummary');
    };
export class UserFitnessSummaryMetaData implements DwItem2<UserFitnessSummaryEntity, UserFitnessSummaryMetaDataAttributes,UserFitnessSummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=196;
        this.ItemDetail.itemName='UserFitnessSummary';
        this.ItemDetail.keyName='UserFitnessSummaryId';
    }

    CreateEntity(): UserFitnessSummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserFitnessSummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserFitnessSummaryEntity, UserFitnessSummaryMetaDataAttributes,UserFitnessSummaryMetaDataRelations>(query, this);
    }
     Attributes = new UserFitnessSummaryMetaDataAttributes();
     Relations = new UserFitnessSummaryMetaDataRelations();

}


export type UserFitnessSummaryQueryBuilder = DwQueryBuilderGen<UserFitnessSummaryEntity, UserFitnessSummaryMetaDataAttributes,UserFitnessSummaryMetaDataRelations>


export class UserFitnessSummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserFitnessSummary';
    // Attributes
    UserFitnessSummaryId = new DwItemAttribute(this.i, 'UserFitnessSummaryId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserChallengeStatusId = new DwItemAttribute(this.i, 'UserChallengeStatusId');
    TotalExerciseDays = new DwItemAttribute(this.i, 'TotalExerciseDays');
    TotalMissedDays = new DwItemAttribute(this.i, 'TotalMissedDays');
    TotalPenaltyDays = new DwItemAttribute(this.i, 'TotalPenaltyDays');
    LongestStreakDays = new DwItemAttribute(this.i, 'LongestStreakDays');
    CurrentStreakDays = new DwItemAttribute(this.i, 'CurrentStreakDays');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    AverageDurationSeconds = new DwItemAttribute(this.i, 'AverageDurationSeconds');
    LastActivityDate = new DwItemAttribute(this.i, 'LastActivityDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UserFitnessSummaryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserChallenge|UserFitnessSummary|UserChallengeId', 'UserChallenge', 'UserChallenge');
            /** Relation: User Challenge Status */
            UserChallengeStatus = new DwItemRelationship('UserChallengeStatus|UserFitnessSummary|UserChallengeStatusId', 'UserChallengeStatus', 'UserChallengeStatus');
            /** Relation: User Fitness Summary Rollup */
            UserFitnessSummaryRollup = new DwItemRelationship('UserFitnessSummary|UserFitnessSummaryRollup|UserFitnessSummaryId', 'UserFitnessSummaryRollup', 'UserFitnessSummaryRollup');
    };
export class UserFitnessSummaryRollupMetaData implements DwItem2<UserFitnessSummaryRollupEntity, UserFitnessSummaryRollupMetaDataAttributes,UserFitnessSummaryRollupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=167;
        this.ItemDetail.itemName='UserFitnessSummaryRollup';
        this.ItemDetail.keyName='UserFitnessSummaryRollupId';
    }

    CreateEntity(): UserFitnessSummaryRollupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserFitnessSummaryRollupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserFitnessSummaryRollupEntity, UserFitnessSummaryRollupMetaDataAttributes,UserFitnessSummaryRollupMetaDataRelations>(query, this);
    }
     Attributes = new UserFitnessSummaryRollupMetaDataAttributes();
     Relations = new UserFitnessSummaryRollupMetaDataRelations();

}


export type UserFitnessSummaryRollupQueryBuilder = DwQueryBuilderGen<UserFitnessSummaryRollupEntity, UserFitnessSummaryRollupMetaDataAttributes,UserFitnessSummaryRollupMetaDataRelations>


export class UserFitnessSummaryRollupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserFitnessSummaryRollup';
    // Attributes
    UserFitnessSummaryRollupId = new DwItemAttribute(this.i, 'UserFitnessSummaryRollupId');
    UserFitnessSummaryId = new DwItemAttribute(this.i, 'UserFitnessSummaryId');
    FitnessActivityTypeId = new DwItemAttribute(this.i, 'FitnessActivityTypeId');
    TotalActivities = new DwItemAttribute(this.i, 'TotalActivities');
    TotalDistanceMeters = new DwItemAttribute(this.i, 'TotalDistanceMeters');
    TotalDurationSeconds = new DwItemAttribute(this.i, 'TotalDurationSeconds');
    TotalElevationGainMeters = new DwItemAttribute(this.i, 'TotalElevationGainMeters');
    AveragePaceMetersPerSecond = new DwItemAttribute(this.i, 'AveragePaceMetersPerSecond');
    FastestPaceMetersPerSecond = new DwItemAttribute(this.i, 'FastestPaceMetersPerSecond');
    SlowestPaceMetersPerSecond = new DwItemAttribute(this.i, 'SlowestPaceMetersPerSecond');
    AverageDistanceMeters = new DwItemAttribute(this.i, 'AverageDistanceMeters');
    LongestDistanceMeters = new DwItemAttribute(this.i, 'LongestDistanceMeters');
    ShortestDistanceMeters = new DwItemAttribute(this.i, 'ShortestDistanceMeters');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    TotalRepCount = new DwItemAttribute(this.i, 'TotalRepCount');
}

class UserFitnessSummaryRollupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Fitness Activity Type */
            FitnessActivityType = new DwItemRelationship('FitnessActivityType|UserFitnessSummaryRollup|FitnessActivityTypeId', 'FitnessActivityType', 'FitnessActivityType');
            /** Relation: User Fitness Summary */
            UserFitnessSummary = new DwItemRelationship('UserFitnessSummary|UserFitnessSummaryRollup|UserFitnessSummaryId', 'UserFitnessSummary', 'UserFitnessSummary');
    };
export class DwUserPaymentMetaData implements DwItem2<DwUserPaymentEntity, DwUserPaymentMetaDataAttributes,DwUserPaymentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=192;
        this.ItemDetail.itemName='dw_UserPayment';
        this.ItemDetail.keyName='UserPaymentId';
    }

    CreateEntity(): DwUserPaymentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserPaymentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserPaymentEntity, DwUserPaymentMetaDataAttributes,DwUserPaymentMetaDataRelations>(query, this);
    }
     Attributes = new DwUserPaymentMetaDataAttributes();
     Relations = new DwUserPaymentMetaDataRelations();

}


export type DwUserPaymentQueryBuilder = DwQueryBuilderGen<DwUserPaymentEntity, DwUserPaymentMetaDataAttributes,DwUserPaymentMetaDataRelations>


export class DwUserPaymentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserPayment';
    // Attributes
    UserPaymentId = new DwItemAttribute(this.i, 'UserPaymentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    PaymentDescription = new DwItemAttribute(this.i, 'PaymentDescription');
    TotalPaymentAmount = new DwItemAttribute(this.i, 'TotalPaymentAmount');
    CreditCardLast4 = new DwItemAttribute(this.i, 'CreditCardLast4');
    Success = new DwItemAttribute(this.i, 'Success');
    Issues = new DwItemAttribute(this.i, 'Issues');
    PaymentReferenceId = new DwItemAttribute(this.i, 'PaymentReferenceId');
    PaymentStartDatTime = new DwItemAttribute(this.i, 'PaymentStartDatTime');
    PaymentCompleteDateTime = new DwItemAttribute(this.i, 'PaymentCompleteDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PaymentMode = new DwItemAttribute(this.i, 'PaymentMode');
    PaymentAccount = new DwItemAttribute(this.i, 'PaymentAccount');
}

class DwUserPaymentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|dw_UserPayment|UserId', 'DwUser', 'DwUser');
            /** Relation: Order */
            DwOrder = new DwItemRelationship('dw_UserPayment|dw_Order|UserPaymentId', 'DwOrder', 'DwOrder');
    };
export class UserProfileMetaData implements DwItem2<UserProfileEntity, UserProfileMetaDataAttributes,UserProfileMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=180;
        this.ItemDetail.itemName='UserProfile';
        this.ItemDetail.keyName='UserProfileId';
    }

    CreateEntity(): UserProfileEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserProfileQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserProfileEntity, UserProfileMetaDataAttributes,UserProfileMetaDataRelations>(query, this);
    }
     Attributes = new UserProfileMetaDataAttributes();
     Relations = new UserProfileMetaDataRelations();

}


export type UserProfileQueryBuilder = DwQueryBuilderGen<UserProfileEntity, UserProfileMetaDataAttributes,UserProfileMetaDataRelations>


export class UserProfileMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserProfile';
    // Attributes
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    MyChallengeCode = new DwItemAttribute(this.i, 'MyChallengeCode');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    UserDescription = new DwItemAttribute(this.i, 'UserDescription');
    ProfileSlug = new DwItemAttribute(this.i, 'ProfileSlug');
    AppearancePresetId = new DwItemAttribute(this.i, 'AppearancePresetId');
    BannerColorStart = new DwItemAttribute(this.i, 'BannerColorStart');
    BannerColorEnd = new DwItemAttribute(this.i, 'BannerColorEnd');
    BannerUseGradient = new DwItemAttribute(this.i, 'BannerUseGradient');
    AvatarBackgroundColor = new DwItemAttribute(this.i, 'AvatarBackgroundColor');
    AvatarTextColor = new DwItemAttribute(this.i, 'AvatarTextColor');
    BannerImageMode = new DwItemAttribute(this.i, 'BannerImageMode');
    AvatarImageMode = new DwItemAttribute(this.i, 'AvatarImageMode');
    BannerAnimationKey = new DwItemAttribute(this.i, 'BannerAnimationKey');
    DonationsAnonymous = new DwItemAttribute(this.i, 'DonationsAnonymous');
    IncludeDonationsInTeamTotals = new DwItemAttribute(this.i, 'IncludeDonationsInTeamTotals');
}

class UserProfileMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address */
            DwAddress = new DwItemRelationship('dw_Address|UserProfile|AddressId', 'DwAddress', 'DwAddress');
            /** Relation: Banner Animation - Banner Animation Key */
            BannerAnimationByBannerAnimationKey = new DwItemRelationship('BannerAnimation|UserProfile|BannerAnimationKey', 'BannerBannerAnimation', 'BannerBannerAnimation');
            /** Relation: Appearance Preset */
            AppearancePreset = new DwItemRelationship('AppearancePreset|UserProfile|AppearancePresetId', 'AppearancePreset', 'AppearancePreset');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|UserProfile|UserId', 'DwUser', 'DwUser');
            /** Relation: User Challenge */
            UserChallenge = new DwItemRelationship('UserProfile|UserChallenge|UserProfileId', 'UserChallenge', 'UserChallenge');
    };
export class YearsStreakingMetaData implements DwItem2<YearsStreakingEntity, YearsStreakingMetaDataAttributes,YearsStreakingMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=211;
        this.ItemDetail.itemName='YearsStreaking';
        this.ItemDetail.keyName='YearsStreakingId';
    }

    CreateEntity(): YearsStreakingEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): YearsStreakingQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<YearsStreakingEntity, YearsStreakingMetaDataAttributes,YearsStreakingMetaDataRelations>(query, this);
    }
     Attributes = new YearsStreakingMetaDataAttributes();
     Relations = new YearsStreakingMetaDataRelations();

}


export type YearsStreakingQueryBuilder = DwQueryBuilderGen<YearsStreakingEntity, YearsStreakingMetaDataAttributes,YearsStreakingMetaDataRelations>


export class YearsStreakingMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'YearsStreaking';
    // Attributes
    YearsStreakingId = new DwItemAttribute(this.i, 'YearsStreakingId');
    Display = new DwItemAttribute(this.i, 'Display');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Description = new DwItemAttribute(this.i, 'Description');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class YearsStreakingMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Challenge - Cv - Many */
            UserChallengeByYearsStreakingCv = new DwItemRelationship('YearsStreaking|UserChallenge|YearsStreakingCv', 'YearsStreakingCvUserChallenge', 'YearsStreakingCvUserChallenge');
    };
// Generated Query Classes for MetaData Service
export class FitnessEmailEnrollmentQueryMetaData implements DwItem2<FitnessEmailEnrollmentQueryEntity, FitnessEmailEnrollmentQueryMetaDataAttributes,UserChallengeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailEnrollment';

    constructor() {
        this.ItemDetail.itemId=191;
        this.ItemDetail.itemName='UserChallenge';
        this.ItemDetail.keyName='UserChallengeId';
    }

    CreateEntity(): FitnessEmailEnrollmentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailEnrollmentQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailEnrollmentQueryEntity, FitnessEmailEnrollmentQueryMetaDataAttributes,UserChallengeMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailEnrollmentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailEnrollmentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailEnrollmentQueryEntity, FitnessEmailEnrollmentQueryMetaDataAttributes,UserChallengeMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailEnrollmentQueryMetaDataAttributes();
     Relations = new UserChallengeMetaDataRelations();

}


export type FitnessEmailEnrollmentQueryBuilder = DwQueryBuilderGen<FitnessEmailEnrollmentQueryEntity, FitnessEmailEnrollmentQueryMetaDataAttributes,UserChallengeMetaDataRelations>


export class FitnessEmailEnrollmentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallenge';
    // Attributes
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserProfileId = new DwItemAttribute(this.i, 'UserProfileId');
    UserProfileIdDisplay = new DwItemAttribute(this.i, 'UserProfileIdDisplay');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeDefinitionIdDisplay = new DwItemAttribute(this.i, 'ChallengeDefinitionIdDisplay');
    IsRegistrationComplete = new DwItemAttribute(this.i, 'IsRegistrationComplete');
    ProfileUserId = new DwItemAttribute('UserProfile', 'ProfileUserId');
    ProfileUserIdDisplay = new DwItemAttribute('UserProfile', 'ProfileUserIdDisplay');
    RecipientUserId = new DwItemAttribute('dw_User', 'RecipientUserId');
    RecipientFirstName = new DwItemAttribute('dw_User', 'RecipientFirstName');
    RecipientLastName = new DwItemAttribute('dw_User', 'RecipientLastName');
    RecipientEmail = new DwItemAttribute('dw_User', 'RecipientEmail');
    RecipientIsActive = new DwItemAttribute('dw_User', 'RecipientIsActive');
    StreakName = new DwItemAttribute('ChallengeDefinition', 'StreakName');
    StreakChallengeStartDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeStartDate');
    StreakChallengeEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeEndDate');
    StreakRegistrationEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakRegistrationEndDate');
}
export class FitnessEmailInvitationQueryMetaData implements DwItem2<FitnessEmailInvitationQueryEntity, FitnessEmailInvitationQueryMetaDataAttributes,EmailChallengeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailInvitation';

    constructor() {
        this.ItemDetail.itemId=206;
        this.ItemDetail.itemName='EmailChallenge';
        this.ItemDetail.keyName='EmailChallengeId';
    }

    CreateEntity(): FitnessEmailInvitationQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailInvitationQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailInvitationQueryEntity, FitnessEmailInvitationQueryMetaDataAttributes,EmailChallengeMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailInvitationQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailInvitationQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailInvitationQueryEntity, FitnessEmailInvitationQueryMetaDataAttributes,EmailChallengeMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailInvitationQueryMetaDataAttributes();
     Relations = new EmailChallengeMetaDataRelations();

}


export type FitnessEmailInvitationQueryBuilder = DwQueryBuilderGen<FitnessEmailInvitationQueryEntity, FitnessEmailInvitationQueryMetaDataAttributes,EmailChallengeMetaDataRelations>


export class FitnessEmailInvitationQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'EmailChallenge';
    // Attributes
    EmailChallengeId = new DwItemAttribute(this.i, 'EmailChallengeId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserIdDisplay = new DwItemAttribute(this.i, 'UserIdDisplay');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    ChallengeDefinitionIdDisplay = new DwItemAttribute(this.i, 'ChallengeDefinitionIdDisplay');
    FriendName = new DwItemAttribute(this.i, 'FriendName');
    FriendEmail = new DwItemAttribute(this.i, 'FriendEmail');
    EmailSent = new DwItemAttribute(this.i, 'EmailSent');
    EmailSentDateTime = new DwItemAttribute(this.i, 'EmailSentDateTime');
    Registered = new DwItemAttribute(this.i, 'Registered');
    RegisteredUserId = new DwItemAttribute(this.i, 'RegisteredUserId');
    RegisteredUserIdDisplay = new DwItemAttribute(this.i, 'RegisteredUserIdDisplay');
    RegisteredDateTime = new DwItemAttribute(this.i, 'RegisteredDateTime');
    NameMatch = new DwItemAttribute(this.i, 'NameMatch');
    CodeMatch = new DwItemAttribute(this.i, 'CodeMatch');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ExcludeFromStats = new DwItemAttribute(this.i, 'ExcludeFromStats');
    InviterFirstName = new DwItemAttribute('dw_User', 'InviterFirstName');
    InviterLastName = new DwItemAttribute('dw_User', 'InviterLastName');
    InviterEmail = new DwItemAttribute('dw_User', 'InviterEmail');
    StreakName = new DwItemAttribute('ChallengeDefinition', 'StreakName');
    StreakChallengeStartDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeStartDate');
    StreakChallengeEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeEndDate');
    StreakRegistrationEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakRegistrationEndDate');
}
export class FitnessEmailTeamRequestQueryMetaData implements DwItem2<FitnessEmailTeamRequestQueryEntity, FitnessEmailTeamRequestQueryMetaDataAttributes,ChallengeTeamJoinRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailTeamRequest';

    constructor() {
        this.ItemDetail.itemId=186;
        this.ItemDetail.itemName='ChallengeTeamJoinRequest';
        this.ItemDetail.keyName='ChallengeTeamJoinRequestId';
    }

    CreateEntity(): FitnessEmailTeamRequestQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailTeamRequestQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailTeamRequestQueryEntity, FitnessEmailTeamRequestQueryMetaDataAttributes,ChallengeTeamJoinRequestMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailTeamRequestQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailTeamRequestQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailTeamRequestQueryEntity, FitnessEmailTeamRequestQueryMetaDataAttributes,ChallengeTeamJoinRequestMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailTeamRequestQueryMetaDataAttributes();
     Relations = new ChallengeTeamJoinRequestMetaDataRelations();

}


export type FitnessEmailTeamRequestQueryBuilder = DwQueryBuilderGen<FitnessEmailTeamRequestQueryEntity, FitnessEmailTeamRequestQueryMetaDataAttributes,ChallengeTeamJoinRequestMetaDataRelations>


export class FitnessEmailTeamRequestQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeTeamJoinRequest';
    // Attributes
    ChallengeTeamJoinRequestId = new DwItemAttribute(this.i, 'ChallengeTeamJoinRequestId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    ChallengeTeamIdDisplay = new DwItemAttribute(this.i, 'ChallengeTeamIdDisplay');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserChallengeIdDisplay = new DwItemAttribute(this.i, 'UserChallengeIdDisplay');
    ChallengeTeamJoinRequestStatusId = new DwItemAttribute(this.i, 'ChallengeTeamJoinRequestStatusId');
    ChallengeTeamJoinRequestStatusIdDisplay = new DwItemAttribute(this.i, 'ChallengeTeamJoinRequestStatusIdDisplay');
    RequestNotes = new DwItemAttribute(this.i, 'RequestNotes');
    RejectionNotes = new DwItemAttribute(this.i, 'RejectionNotes');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    EnrollmentChallengeDefinitionId = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionId');
    EnrollmentChallengeDefinitionIdDisplay = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionIdDisplay');
    EnrollmentIsRegistrationComplete = new DwItemAttribute('UserChallenge', 'EnrollmentIsRegistrationComplete');
    ProfileUserId = new DwItemAttribute('UserProfile', 'ProfileUserId');
    ProfileUserIdDisplay = new DwItemAttribute('UserProfile', 'ProfileUserIdDisplay');
    RecipientUserId = new DwItemAttribute('dw_User', 'RecipientUserId');
    RecipientFirstName = new DwItemAttribute('dw_User', 'RecipientFirstName');
    RecipientLastName = new DwItemAttribute('dw_User', 'RecipientLastName');
    RecipientEmail = new DwItemAttribute('dw_User', 'RecipientEmail');
    RecipientIsActive = new DwItemAttribute('dw_User', 'RecipientIsActive');
    TeamTeamName = new DwItemAttribute('ChallengeTeam', 'TeamTeamName');
    TeamChallengeDefinitionId = new DwItemAttribute('ChallengeTeam', 'TeamChallengeDefinitionId');
    TeamChallengeDefinitionIdDisplay = new DwItemAttribute('ChallengeTeam', 'TeamChallengeDefinitionIdDisplay');
    StreakName = new DwItemAttribute('ChallengeDefinition', 'StreakName');
    StreakChallengeStartDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeStartDate');
    StreakChallengeEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeEndDate');
    StreakRegistrationEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakRegistrationEndDate');
}
export class FitnessEmailTeamMemberQueryMetaData implements DwItem2<FitnessEmailTeamMemberQueryEntity, FitnessEmailTeamMemberQueryMetaDataAttributes,ChallengeTeamMemberMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailTeamMember';

    constructor() {
        this.ItemDetail.itemId=194;
        this.ItemDetail.itemName='ChallengeTeamMember';
        this.ItemDetail.keyName='ChallengeTeamMemberId';
    }

    CreateEntity(): FitnessEmailTeamMemberQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailTeamMemberQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailTeamMemberQueryEntity, FitnessEmailTeamMemberQueryMetaDataAttributes,ChallengeTeamMemberMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailTeamMemberQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailTeamMemberQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailTeamMemberQueryEntity, FitnessEmailTeamMemberQueryMetaDataAttributes,ChallengeTeamMemberMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailTeamMemberQueryMetaDataAttributes();
     Relations = new ChallengeTeamMemberMetaDataRelations();

}


export type FitnessEmailTeamMemberQueryBuilder = DwQueryBuilderGen<FitnessEmailTeamMemberQueryEntity, FitnessEmailTeamMemberQueryMetaDataAttributes,ChallengeTeamMemberMetaDataRelations>


export class FitnessEmailTeamMemberQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeTeamMember';
    // Attributes
    ChallengeTeamMemberId = new DwItemAttribute(this.i, 'ChallengeTeamMemberId');
    ChallengeTeamId = new DwItemAttribute(this.i, 'ChallengeTeamId');
    ChallengeTeamIdDisplay = new DwItemAttribute(this.i, 'ChallengeTeamIdDisplay');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserChallengeIdDisplay = new DwItemAttribute(this.i, 'UserChallengeIdDisplay');
    IsTeamAdmin = new DwItemAttribute(this.i, 'IsTeamAdmin');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    EnrollmentChallengeDefinitionId = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionId');
    EnrollmentChallengeDefinitionIdDisplay = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionIdDisplay');
    EnrollmentIsRegistrationComplete = new DwItemAttribute('UserChallenge', 'EnrollmentIsRegistrationComplete');
    ProfileUserId = new DwItemAttribute('UserProfile', 'ProfileUserId');
    ProfileUserIdDisplay = new DwItemAttribute('UserProfile', 'ProfileUserIdDisplay');
    RecipientUserId = new DwItemAttribute('dw_User', 'RecipientUserId');
    RecipientFirstName = new DwItemAttribute('dw_User', 'RecipientFirstName');
    RecipientLastName = new DwItemAttribute('dw_User', 'RecipientLastName');
    RecipientEmail = new DwItemAttribute('dw_User', 'RecipientEmail');
    RecipientIsActive = new DwItemAttribute('dw_User', 'RecipientIsActive');
    TeamTeamName = new DwItemAttribute('ChallengeTeam', 'TeamTeamName');
    TeamChallengeDefinitionId = new DwItemAttribute('ChallengeTeam', 'TeamChallengeDefinitionId');
    TeamChallengeDefinitionIdDisplay = new DwItemAttribute('ChallengeTeam', 'TeamChallengeDefinitionIdDisplay');
    StreakName = new DwItemAttribute('ChallengeDefinition', 'StreakName');
    StreakChallengeStartDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeStartDate');
    StreakChallengeEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakChallengeEndDate');
    StreakRegistrationEndDate = new DwItemAttribute('ChallengeDefinition', 'StreakRegistrationEndDate');
}
export class FitnessEmailOrderQueryMetaData implements DwItem2<FitnessEmailOrderQueryEntity, FitnessEmailOrderQueryMetaDataAttributes,DwOrderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailOrder';

    constructor() {
        this.ItemDetail.itemId=185;
        this.ItemDetail.itemName='dw_Order';
        this.ItemDetail.keyName='OrderId';
    }

    CreateEntity(): FitnessEmailOrderQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailOrderQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailOrderQueryEntity, FitnessEmailOrderQueryMetaDataAttributes,DwOrderMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailOrderQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailOrderQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailOrderQueryEntity, FitnessEmailOrderQueryMetaDataAttributes,DwOrderMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailOrderQueryMetaDataAttributes();
     Relations = new DwOrderMetaDataRelations();

}


export type FitnessEmailOrderQueryBuilder = DwQueryBuilderGen<FitnessEmailOrderQueryEntity, FitnessEmailOrderQueryMetaDataAttributes,DwOrderMetaDataRelations>


export class FitnessEmailOrderQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Order';
    // Attributes
    OrderId = new DwItemAttribute(this.i, 'OrderId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserIdDisplay = new DwItemAttribute(this.i, 'UserIdDisplay');
    OrderStatusId = new DwItemAttribute(this.i, 'OrderStatusId');
    OrderStatusIdDisplay = new DwItemAttribute(this.i, 'OrderStatusIdDisplay');
    BillingAddressId = new DwItemAttribute(this.i, 'BillingAddressId');
    BillingAddressIdDisplay = new DwItemAttribute(this.i, 'BillingAddressIdDisplay');
    ShippingAddressSameAsBilling = new DwItemAttribute(this.i, 'ShippingAddressSameAsBilling');
    ShippingAddressId = new DwItemAttribute(this.i, 'ShippingAddressId');
    ShippingAddressIdDisplay = new DwItemAttribute(this.i, 'ShippingAddressIdDisplay');
    UserPaymentId = new DwItemAttribute(this.i, 'UserPaymentId');
    UserPaymentIdDisplay = new DwItemAttribute(this.i, 'UserPaymentIdDisplay');
    SubTotalAmount = new DwItemAttribute(this.i, 'SubTotalAmount');
    ShippingAmount = new DwItemAttribute(this.i, 'ShippingAmount');
    TotalAmount = new DwItemAttribute(this.i, 'TotalAmount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OrderBatchId = new DwItemAttribute(this.i, 'OrderBatchId');
    OrderBatchIdDisplay = new DwItemAttribute(this.i, 'OrderBatchIdDisplay');
    ProcessedDateTime = new DwItemAttribute(this.i, 'ProcessedDateTime');
    ProcessingEmailSent = new DwItemAttribute(this.i, 'ProcessingEmailSent');
    ShippedDateTime = new DwItemAttribute(this.i, 'ShippedDateTime');
    ShippedEmailSent = new DwItemAttribute(this.i, 'ShippedEmailSent');
    DiscountAmount = new DwItemAttribute(this.i, 'DiscountAmount');
    PromotionCode = new DwItemAttribute(this.i, 'PromotionCode');
    RecipientUserId = new DwItemAttribute('dw_User', 'RecipientUserId');
    RecipientFirstName = new DwItemAttribute('dw_User', 'RecipientFirstName');
    RecipientLastName = new DwItemAttribute('dw_User', 'RecipientLastName');
    RecipientEmail = new DwItemAttribute('dw_User', 'RecipientEmail');
    RecipientIsActive = new DwItemAttribute('dw_User', 'RecipientIsActive');
}
export class FitnessEmailChallengeQueryMetaData implements DwItem2<FitnessEmailChallengeQueryEntity, FitnessEmailChallengeQueryMetaDataAttributes,ChallengeDefinitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailChallenge';

    constructor() {
        this.ItemDetail.itemId=172;
        this.ItemDetail.itemName='ChallengeDefinition';
        this.ItemDetail.keyName='ChallengeDefinitionId';
    }

    CreateEntity(): FitnessEmailChallengeQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailChallengeQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailChallengeQueryEntity, FitnessEmailChallengeQueryMetaDataAttributes,ChallengeDefinitionMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailChallengeQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailChallengeQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailChallengeQueryEntity, FitnessEmailChallengeQueryMetaDataAttributes,ChallengeDefinitionMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailChallengeQueryMetaDataAttributes();
     Relations = new ChallengeDefinitionMetaDataRelations();

}


export type FitnessEmailChallengeQueryBuilder = DwQueryBuilderGen<FitnessEmailChallengeQueryEntity, FitnessEmailChallengeQueryMetaDataAttributes,ChallengeDefinitionMetaDataRelations>


export class FitnessEmailChallengeQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ChallengeDefinition';
    // Attributes
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    Name = new DwItemAttribute(this.i, 'Name');
    Description = new DwItemAttribute(this.i, 'Description');
    ChallengeEndDate = new DwItemAttribute(this.i, 'ChallengeEndDate');
    ChallengeStartDate = new DwItemAttribute(this.i, 'ChallengeStartDate');
    HasShirt = new DwItemAttribute(this.i, 'HasShirt');
    EntryFee = new DwItemAttribute(this.i, 'EntryFee');
    IsCurrent = new DwItemAttribute(this.i, 'IsCurrent');
    RegistrationStartDate = new DwItemAttribute(this.i, 'RegistrationStartDate');
    MailShirtFee = new DwItemAttribute(this.i, 'MailShirtFee');
    RegistrationEndDate = new DwItemAttribute(this.i, 'RegistrationEndDate');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    ProductIdDisplay = new DwItemAttribute(this.i, 'ProductIdDisplay');
    StoreStartDate = new DwItemAttribute(this.i, 'StoreStartDate');
    StoreEndDate = new DwItemAttribute(this.i, 'StoreEndDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StoreShippingMessage = new DwItemAttribute(this.i, 'StoreShippingMessage');
    AfterOrderShippingMessage = new DwItemAttribute(this.i, 'AfterOrderShippingMessage');
    GracePeriodHours = new DwItemAttribute(this.i, 'GracePeriodHours');
}
export class FitnessEmailCommentQueryMetaData implements DwItem2<FitnessEmailCommentQueryEntity, FitnessEmailCommentQueryMetaDataAttributes,UserChallengeCommentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailComment';

    constructor() {
        this.ItemDetail.itemId=184;
        this.ItemDetail.itemName='UserChallengeComment';
        this.ItemDetail.keyName='UserChallengeCommentId';
    }

    CreateEntity(): FitnessEmailCommentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailCommentQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailCommentQueryEntity, FitnessEmailCommentQueryMetaDataAttributes,UserChallengeCommentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailCommentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailCommentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailCommentQueryEntity, FitnessEmailCommentQueryMetaDataAttributes,UserChallengeCommentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailCommentQueryMetaDataAttributes();
     Relations = new UserChallengeCommentMetaDataRelations();

}


export type FitnessEmailCommentQueryBuilder = DwQueryBuilderGen<FitnessEmailCommentQueryEntity, FitnessEmailCommentQueryMetaDataAttributes,UserChallengeCommentMetaDataRelations>


export class FitnessEmailCommentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeComment';
    // Attributes
    UserChallengeCommentId = new DwItemAttribute(this.i, 'UserChallengeCommentId');
    UserChallengeId = new DwItemAttribute(this.i, 'UserChallengeId');
    UserChallengeIdDisplay = new DwItemAttribute(this.i, 'UserChallengeIdDisplay');
    FitnessActivityId = new DwItemAttribute(this.i, 'FitnessActivityId');
    FitnessActivityIdDisplay = new DwItemAttribute(this.i, 'FitnessActivityIdDisplay');
    UserChallengeCommentTypeId = new DwItemAttribute(this.i, 'UserChallengeCommentTypeId');
    UserChallengeCommentTypeIdDisplay = new DwItemAttribute(this.i, 'UserChallengeCommentTypeIdDisplay');
    FromUserChallengeId = new DwItemAttribute(this.i, 'FromUserChallengeId');
    FromUserChallengeIdDisplay = new DwItemAttribute(this.i, 'FromUserChallengeIdDisplay');
    Comment = new DwItemAttribute(this.i, 'Comment');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ParentUserChallengeCommentId = new DwItemAttribute(this.i, 'ParentUserChallengeCommentId');
    ReplyToEveryone = new DwItemAttribute(this.i, 'ReplyToEveryone');
    ClientRequestId = new DwItemAttribute(this.i, 'ClientRequestId');
    ActivityUserChallengeId = new DwItemAttribute('FitnessActivity', 'ActivityUserChallengeId');
    ActivityUserChallengeIdDisplay = new DwItemAttribute('FitnessActivity', 'ActivityUserChallengeIdDisplay');
    EnrollmentChallengeDefinitionId = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionId');
    EnrollmentChallengeDefinitionIdDisplay = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionIdDisplay');
    EnrollmentIsRegistrationComplete = new DwItemAttribute('UserChallenge', 'EnrollmentIsRegistrationComplete');
    ProfileUserId = new DwItemAttribute('UserProfile', 'ProfileUserId');
    ProfileUserIdDisplay = new DwItemAttribute('UserProfile', 'ProfileUserIdDisplay');
    RecipientUserId = new DwItemAttribute('dw_User', 'RecipientUserId');
    RecipientFirstName = new DwItemAttribute('dw_User', 'RecipientFirstName');
    RecipientLastName = new DwItemAttribute('dw_User', 'RecipientLastName');
    RecipientEmail = new DwItemAttribute('dw_User', 'RecipientEmail');
    RecipientIsActive = new DwItemAttribute('dw_User', 'RecipientIsActive');
}
export class FitnessEmailAwardEventQueryMetaData implements DwItem2<FitnessEmailAwardEventQueryEntity, FitnessEmailAwardEventQueryMetaDataAttributes,BadgeAwardEventMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailAwardEvent';

    constructor() {
        this.ItemDetail.itemId=278;
        this.ItemDetail.itemName='BadgeAwardEvent';
        this.ItemDetail.keyName='BadgeAwardEventId';
    }

    CreateEntity(): FitnessEmailAwardEventQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailAwardEventQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailAwardEventQueryEntity, FitnessEmailAwardEventQueryMetaDataAttributes,BadgeAwardEventMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailAwardEventQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailAwardEventQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailAwardEventQueryEntity, FitnessEmailAwardEventQueryMetaDataAttributes,BadgeAwardEventMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailAwardEventQueryMetaDataAttributes();
     Relations = new BadgeAwardEventMetaDataRelations();

}


export type FitnessEmailAwardEventQueryBuilder = DwQueryBuilderGen<FitnessEmailAwardEventQueryEntity, FitnessEmailAwardEventQueryMetaDataAttributes,BadgeAwardEventMetaDataRelations>


export class FitnessEmailAwardEventQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BadgeAwardEvent';
    // Attributes
    BadgeAwardEventId = new DwItemAttribute(this.i, 'BadgeAwardEventId');
    BadgeAwardId = new DwItemAttribute(this.i, 'BadgeAwardId');
    ChallengeDefinitionId = new DwItemAttribute(this.i, 'ChallengeDefinitionId');
    BadgeAwardEventTypeId = new DwItemAttribute(this.i, 'BadgeAwardEventTypeId');
    EffectiveDateTime = new DwItemAttribute(this.i, 'EffectiveDateTime');
    RecordedDateTime = new DwItemAttribute(this.i, 'RecordedDateTime');
    Reason = new DwItemAttribute(this.i, 'Reason');
    BadgeCalculationRunId = new DwItemAttribute(this.i, 'BadgeCalculationRunId');
    MetricValue = new DwItemAttribute(this.i, 'MetricValue');
    RankPosition = new DwItemAttribute(this.i, 'RankPosition');
    OperationKey = new DwItemAttribute(this.i, 'OperationKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}
export class FitnessEmailAccountQueryMetaData implements DwItem2<FitnessEmailAccountQueryEntity, FitnessEmailAccountQueryMetaDataAttributes,DwUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailAccount';

    constructor() {
        this.ItemDetail.itemId=46;
        this.ItemDetail.itemName='dw_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): FitnessEmailAccountQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailAccountQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailAccountQueryEntity, FitnessEmailAccountQueryMetaDataAttributes,DwUserMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailAccountQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailAccountQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailAccountQueryEntity, FitnessEmailAccountQueryMetaDataAttributes,DwUserMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailAccountQueryMetaDataAttributes();
     Relations = new DwUserMetaDataRelations();

}


export type FitnessEmailAccountQueryBuilder = DwQueryBuilderGen<FitnessEmailAccountQueryEntity, FitnessEmailAccountQueryMetaDataAttributes,DwUserMetaDataRelations>


export class FitnessEmailAccountQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_User';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    Email = new DwItemAttribute(this.i, 'Email');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
}
export class FitnessEmailCommentRecipientsQueryMetaData implements DwItem2<FitnessEmailCommentRecipientsQueryEntity, FitnessEmailCommentRecipientsQueryMetaDataAttributes,UserChallengeCommentRecipientMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'FitnessEmailCommentRecipients';

    constructor() {
        this.ItemDetail.itemId=299;
        this.ItemDetail.itemName='UserChallengeCommentRecipient';
        this.ItemDetail.keyName='UserChallengeCommentRecipientId';
    }

    CreateEntity(): FitnessEmailCommentRecipientsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FitnessEmailCommentRecipientsQueryBuilder {
        return new DwQueryBuilderGen<FitnessEmailCommentRecipientsQueryEntity, FitnessEmailCommentRecipientsQueryMetaDataAttributes,UserChallengeCommentRecipientMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FitnessEmailCommentRecipientsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FitnessEmailCommentRecipientsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FitnessEmailCommentRecipientsQueryEntity, FitnessEmailCommentRecipientsQueryMetaDataAttributes,UserChallengeCommentRecipientMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FitnessEmailCommentRecipientsQueryMetaDataAttributes();
     Relations = new UserChallengeCommentRecipientMetaDataRelations();

}


export type FitnessEmailCommentRecipientsQueryBuilder = DwQueryBuilderGen<FitnessEmailCommentRecipientsQueryEntity, FitnessEmailCommentRecipientsQueryMetaDataAttributes,UserChallengeCommentRecipientMetaDataRelations>


export class FitnessEmailCommentRecipientsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserChallengeCommentRecipient';
    // Attributes
    UserChallengeCommentRecipientId = new DwItemAttribute(this.i, 'UserChallengeCommentRecipientId');
    UserChallengeCommentId = new DwItemAttribute(this.i, 'UserChallengeCommentId');
    UserChallengeCommentIdDisplay = new DwItemAttribute(this.i, 'UserChallengeCommentIdDisplay');
    RecipientUserChallengeId = new DwItemAttribute(this.i, 'RecipientUserChallengeId');
    RecipientUserChallengeIdDisplay = new DwItemAttribute(this.i, 'RecipientUserChallengeIdDisplay');
    EnrollmentChallengeDefinitionId = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionId');
    EnrollmentChallengeDefinitionIdDisplay = new DwItemAttribute('UserChallenge', 'EnrollmentChallengeDefinitionIdDisplay');
    EnrollmentIsRegistrationComplete = new DwItemAttribute('UserChallenge', 'EnrollmentIsRegistrationComplete');
    ProfileUserId = new DwItemAttribute('UserProfile', 'ProfileUserId');
    ProfileUserIdDisplay = new DwItemAttribute('UserProfile', 'ProfileUserIdDisplay');
    RecipientUserId = new DwItemAttribute('dw_User', 'RecipientUserId');
    RecipientFirstName = new DwItemAttribute('dw_User', 'RecipientFirstName');
    RecipientLastName = new DwItemAttribute('dw_User', 'RecipientLastName');
    RecipientEmail = new DwItemAttribute('dw_User', 'RecipientEmail');
    RecipientIsActive = new DwItemAttribute('dw_User', 'RecipientIsActive');
}


// Generated Query Classes for MetaData Service

class MetaDataQueries {
    FitnessEmailEnrollment : FitnessEmailEnrollmentQueryMetaData = new FitnessEmailEnrollmentQueryMetaData();
    FitnessEmailInvitation : FitnessEmailInvitationQueryMetaData = new FitnessEmailInvitationQueryMetaData();
    FitnessEmailTeamRequest : FitnessEmailTeamRequestQueryMetaData = new FitnessEmailTeamRequestQueryMetaData();
    FitnessEmailTeamMember : FitnessEmailTeamMemberQueryMetaData = new FitnessEmailTeamMemberQueryMetaData();
    FitnessEmailOrder : FitnessEmailOrderQueryMetaData = new FitnessEmailOrderQueryMetaData();
    FitnessEmailChallenge : FitnessEmailChallengeQueryMetaData = new FitnessEmailChallengeQueryMetaData();
    FitnessEmailComment : FitnessEmailCommentQueryMetaData = new FitnessEmailCommentQueryMetaData();
    FitnessEmailAwardEvent : FitnessEmailAwardEventQueryMetaData = new FitnessEmailAwardEventQueryMetaData();
    FitnessEmailAccount : FitnessEmailAccountQueryMetaData = new FitnessEmailAccountQueryMetaData();
    FitnessEmailCommentRecipients : FitnessEmailCommentRecipientsQueryMetaData = new FitnessEmailCommentRecipientsQueryMetaData();
}

export class AppMetaData {

    static DwAddress : DwAddressMetaData = new DwAddressMetaData();
    static DwAnnouncement : DwAnnouncementMetaData = new DwAnnouncementMetaData();
    static AppearanceBackfillAssignment : AppearanceBackfillAssignmentMetaData = new AppearanceBackfillAssignmentMetaData();
    static AppearancePreset : AppearancePresetMetaData = new AppearancePresetMetaData();
    static BadgeAward : BadgeAwardMetaData = new BadgeAwardMetaData();
    static BadgeAwardEvent : BadgeAwardEventMetaData = new BadgeAwardEventMetaData();
    static BadgeAwardEventType : BadgeAwardEventTypeMetaData = new BadgeAwardEventTypeMetaData();
    static BadgeAwardMode : BadgeAwardModeMetaData = new BadgeAwardModeMetaData();
    static BadgeAwardRetentionPolicy : BadgeAwardRetentionPolicyMetaData = new BadgeAwardRetentionPolicyMetaData();
    static BadgeAwardState : BadgeAwardStateMetaData = new BadgeAwardStateMetaData();
    static BadgeAwardType : BadgeAwardTypeMetaData = new BadgeAwardTypeMetaData();
    static BadgeCalculationRun : BadgeCalculationRunMetaData = new BadgeCalculationRunMetaData();
    static BadgeCalculationRunState : BadgeCalculationRunStateMetaData = new BadgeCalculationRunStateMetaData();
    static BadgeCalculationRunType : BadgeCalculationRunTypeMetaData = new BadgeCalculationRunTypeMetaData();
    static BadgeCalculationType : BadgeCalculationTypeMetaData = new BadgeCalculationTypeMetaData();
    static BadgeCategory : BadgeCategoryMetaData = new BadgeCategoryMetaData();
    static BadgeDefinition : BadgeDefinitionMetaData = new BadgeDefinitionMetaData();
    static BadgeMetricType : BadgeMetricTypeMetaData = new BadgeMetricTypeMetaData();
    static BadgeProgress : BadgeProgressMetaData = new BadgeProgressMetaData();
    static BadgeProgressState : BadgeProgressStateMetaData = new BadgeProgressStateMetaData();
    static BadgeRecipientType : BadgeRecipientTypeMetaData = new BadgeRecipientTypeMetaData();
    static BadgeSubject : BadgeSubjectMetaData = new BadgeSubjectMetaData();
    static BadgeTeamAggregationType : BadgeTeamAggregationTypeMetaData = new BadgeTeamAggregationTypeMetaData();
    static BadgeTiePolicy : BadgeTiePolicyMetaData = new BadgeTiePolicyMetaData();
    static BadgeTier : BadgeTierMetaData = new BadgeTierMetaData();
    static BannerAnimation : BannerAnimationMetaData = new BannerAnimationMetaData();
    static ChallengeBadgeConfiguration : ChallengeBadgeConfigurationMetaData = new ChallengeBadgeConfigurationMetaData();
    static ChallengeBadgeRule : ChallengeBadgeRuleMetaData = new ChallengeBadgeRuleMetaData();
    static ChallengeDefActivityType : ChallengeDefActivityTypeMetaData = new ChallengeDefActivityTypeMetaData();
    static ChallengeDefinition : ChallengeDefinitionMetaData = new ChallengeDefinitionMetaData();
    static ChallengeDefinitionProduct : ChallengeDefinitionProductMetaData = new ChallengeDefinitionProductMetaData();
    static ChallengeGoal : ChallengeGoalMetaData = new ChallengeGoalMetaData();
    static ChallengeMedia : ChallengeMediaMetaData = new ChallengeMediaMetaData();
    static ChallengeTeam : ChallengeTeamMetaData = new ChallengeTeamMetaData();
    static ChallengeTeamJoinRequest : ChallengeTeamJoinRequestMetaData = new ChallengeTeamJoinRequestMetaData();
    static ChallengeTeamJoinRequestStatus : ChallengeTeamJoinRequestStatusMetaData = new ChallengeTeamJoinRequestStatusMetaData();
    static ChallengeTeamMember : ChallengeTeamMemberMetaData = new ChallengeTeamMemberMetaData();
    static DwCodeSet : DwCodeSetMetaData = new DwCodeSetMetaData();
    static DwCodeValue : DwCodeValueMetaData = new DwCodeValueMetaData();
    static DwCodeValueRelation : DwCodeValueRelationMetaData = new DwCodeValueRelationMetaData();
    static DwCodeValueTransition : DwCodeValueTransitionMetaData = new DwCodeValueTransitionMetaData();
    static DwCountry : DwCountryMetaData = new DwCountryMetaData();
    static EmailChallenge : EmailChallengeMetaData = new EmailChallengeMetaData();
    static FitnessActivity : FitnessActivityMetaData = new FitnessActivityMetaData();
    static FitnessActivityDisplayGroup : FitnessActivityDisplayGroupMetaData = new FitnessActivityDisplayGroupMetaData();
    static FitnessActivityDisplayGroupUOM : FitnessActivityDisplayGroupUOMMetaData = new FitnessActivityDisplayGroupUOMMetaData();
    static FitnessActivityType : FitnessActivityTypeMetaData = new FitnessActivityTypeMetaData();
    static InformationRequest : InformationRequestMetaData = new InformationRequestMetaData();
    static LeaderboardEntry : LeaderboardEntryMetaData = new LeaderboardEntryMetaData();
    static LeaderboardSnapshot : LeaderboardSnapshotMetaData = new LeaderboardSnapshotMetaData();
    static MarketingSource : MarketingSourceMetaData = new MarketingSourceMetaData();
    static MediaCommentType : MediaCommentTypeMetaData = new MediaCommentTypeMetaData();
    static MediaPost : MediaPostMetaData = new MediaPostMetaData();
    static MediaPostComment : MediaPostCommentMetaData = new MediaPostCommentMetaData();
    static DwOrder : DwOrderMetaData = new DwOrderMetaData();
    static DwOrderBatch : DwOrderBatchMetaData = new DwOrderBatchMetaData();
    static DwOrderBatchStatus : DwOrderBatchStatusMetaData = new DwOrderBatchStatusMetaData();
    static DwOrderDetail : DwOrderDetailMetaData = new DwOrderDetailMetaData();
    static DwOrderStatus : DwOrderStatusMetaData = new DwOrderStatusMetaData();
    static DwPostalCode : DwPostalCodeMetaData = new DwPostalCodeMetaData();
    static DwProduct : DwProductMetaData = new DwProductMetaData();
    static DwProductCategory : DwProductCategoryMetaData = new DwProductCategoryMetaData();
    static DwProductColor : DwProductColorMetaData = new DwProductColorMetaData();
    static DwProductMedia : DwProductMediaMetaData = new DwProductMediaMetaData();
    static DwProductOption : DwProductOptionMetaData = new DwProductOptionMetaData();
    static DwProductOptionDetail : DwProductOptionDetailMetaData = new DwProductOptionDetailMetaData();
    static DwProductSize : DwProductSizeMetaData = new DwProductSizeMetaData();
    static DwProductType : DwProductTypeMetaData = new DwProductTypeMetaData();
    static Recipient : RecipientMetaData = new RecipientMetaData();
    static RecipientPhoto : RecipientPhotoMetaData = new RecipientPhotoMetaData();
    static RecipientUpdate : RecipientUpdateMetaData = new RecipientUpdateMetaData();
    static RecipientUpdatePhoto : RecipientUpdatePhotoMetaData = new RecipientUpdatePhotoMetaData();
    static RegistrationOrderDetail : RegistrationOrderDetailMetaData = new RegistrationOrderDetailMetaData();
    static RoActivityDisplay : RoActivityDisplayMetaData = new RoActivityDisplayMetaData();
    static RoChallengeAdminSummary : RoChallengeAdminSummaryMetaData = new RoChallengeAdminSummaryMetaData();
    static RoChallengeCollectionSummary : RoChallengeCollectionSummaryMetaData = new RoChallengeCollectionSummaryMetaData();
    static RoChallengeDonationAdmin : RoChallengeDonationAdminMetaData = new RoChallengeDonationAdminMetaData();
    static RoChallengeRegistrationDaily : RoChallengeRegistrationDailyMetaData = new RoChallengeRegistrationDailyMetaData();
    static RoChallengeStreakerAdmin : RoChallengeStreakerAdminMetaData = new RoChallengeStreakerAdminMetaData();
    static RoChallengeTeamDonationAdmin : RoChallengeTeamDonationAdminMetaData = new RoChallengeTeamDonationAdminMetaData();
    static RoDonationsByTeam : RoDonationsByTeamMetaData = new RoDonationsByTeamMetaData();
    static RoPublicDisplayImage : RoPublicDisplayImageMetaData = new RoPublicDisplayImageMetaData();
    static RoStreakerDisplay : RoStreakerDisplayMetaData = new RoStreakerDisplayMetaData();
    static RoTeamDisplay : RoTeamDisplayMetaData = new RoTeamDisplayMetaData();
    static RoTeamFitnessActivityStats : RoTeamFitnessActivityStatsMetaData = new RoTeamFitnessActivityStatsMetaData();
    static RoTeamFitnessStats : RoTeamFitnessStatsMetaData = new RoTeamFitnessStatsMetaData();
    static RoUserDonations : RoUserDonationsMetaData = new RoUserDonationsMetaData();
    static RoUserFitnessActivityStats : RoUserFitnessActivityStatsMetaData = new RoUserFitnessActivityStatsMetaData();
    static RoUserFitnessStats : RoUserFitnessStatsMetaData = new RoUserFitnessStatsMetaData();
    static RoUserProfileDisplay : RoUserProfileDisplayMetaData = new RoUserProfileDisplayMetaData();
    static DwShippingRate : DwShippingRateMetaData = new DwShippingRateMetaData();
    static ShirtSize : ShirtSizeMetaData = new ShirtSizeMetaData();
    static DwShoppingCartRule : DwShoppingCartRuleMetaData = new DwShoppingCartRuleMetaData();
    static DwShoppingCartRuleAction : DwShoppingCartRuleActionMetaData = new DwShoppingCartRuleActionMetaData();
    static DwShoppingCartRuleActionType : DwShoppingCartRuleActionTypeMetaData = new DwShoppingCartRuleActionTypeMetaData();
    static DwShoppingCartRuleCondition : DwShoppingCartRuleConditionMetaData = new DwShoppingCartRuleConditionMetaData();
    static DwShoppingCartRuleConditionType : DwShoppingCartRuleConditionTypeMetaData = new DwShoppingCartRuleConditionTypeMetaData();
    static DwStateProvince : DwStateProvinceMetaData = new DwStateProvinceMetaData();
    static StatsDedup20261015RollupBackup : StatsDedup20261015RollupBackupMetaData = new StatsDedup20261015RollupBackupMetaData();
    static StatsDedup20261015SummaryBackup : StatsDedup20261015SummaryBackupMetaData = new StatsDedup20261015SummaryBackupMetaData();
    static DwTimeZone : DwTimeZoneMetaData = new DwTimeZoneMetaData();
    static UnitOfMeasure : UnitOfMeasureMetaData = new UnitOfMeasureMetaData();
    static UnitOfMeasureType : UnitOfMeasureTypeMetaData = new UnitOfMeasureTypeMetaData();
    static DwUser : DwUserMetaData = new DwUserMetaData();
    static UserChallenge : UserChallengeMetaData = new UserChallengeMetaData();
    static UserChallengeComment : UserChallengeCommentMetaData = new UserChallengeCommentMetaData();
    static UserChallengeCommentLegacyLikeBackup20261013 : UserChallengeCommentLegacyLikeBackup20261013MetaData = new UserChallengeCommentLegacyLikeBackup20261013MetaData();
    static UserChallengeCommentRecipient : UserChallengeCommentRecipientMetaData = new UserChallengeCommentRecipientMetaData();
    static UserChallengeCommentType : UserChallengeCommentTypeMetaData = new UserChallengeCommentTypeMetaData();
    static UserChallengeEmail : UserChallengeEmailMetaData = new UserChallengeEmailMetaData();
    static UserChallengeFriend : UserChallengeFriendMetaData = new UserChallengeFriendMetaData();
    static UserChallengeStatus : UserChallengeStatusMetaData = new UserChallengeStatusMetaData();
    static UserFitnessSummary : UserFitnessSummaryMetaData = new UserFitnessSummaryMetaData();
    static UserFitnessSummaryRollup : UserFitnessSummaryRollupMetaData = new UserFitnessSummaryRollupMetaData();
    static DwUserPayment : DwUserPaymentMetaData = new DwUserPaymentMetaData();
    static UserProfile : UserProfileMetaData = new UserProfileMetaData();
    static YearsStreaking : YearsStreakingMetaData = new YearsStreakingMetaData();
    static Queries = new MetaDataQueries();
}
// Generated Entity Interfaces
export interface DwAddressEntity extends DwOrmData {
    // Attributes
    AddressId?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    CountryId?: number;
    CountyName?: string;
    PostalCode?: string;
    PostalCodePlus4?: string;
    Phone?: string;
    Fax?: string;
    Latitude?: number;
    Longitude?: number;
    TimezoneId?: number;
    ObservesDst?: boolean;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    StateProvinceIdDisplay?: string;
    CountryIdDisplay?: string;
    TimezoneIdDisplay?: string;

    // Relations
    DwCountry? : DwCountryEntity;
    DwStateProvince? : DwStateProvinceEntity;
    TimezoneIdDwTimeZone? : DwTimeZoneEntity;
    BillingDwOrder? : DwOrderEntity[];
    ShippingDwOrder? : DwOrderEntity[];
    UserProfile? : UserProfileEntity[];
}

export interface DwAnnouncementEntity extends DwOrmData {
    // Attributes
    AnnouncementId?: number;
    AnnouncementTitle?: string;
    AnnouncementShortDesc?: string;
    AnnouncementFull?: string;
    AnnouncementDate?: string;
    ExpirationDate?: string;
    Priority?: number;
    ShowDate?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface AppearanceBackfillAssignmentEntity extends DwOrmData {
    // Attributes
    BatchId?: string;
    EntityType?: string;
    EntityId?: number;
    AppearancePresetId?: number;
    PreviousModifiedBy?: number;
    PreviousModifiedDateTime?: string;
    AssignedModifiedDateTime?: string;
    AppliedDateTime?: string;
    RolledBackDateTime?: string;


    // Relations
}

export interface AppearancePresetEntity extends DwOrmData {
    // Attributes
    AppearancePresetId?: number;
    PresetKey?: string;
    Name?: string;
    ChallengeDefinitionId?: number;
    BannerColorStart?: string;
    BannerColorEnd?: string;
    BannerMediaId?: number;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    AvatarMediaId?: number;
    AppliesToUsers?: boolean;
    AppliesToTeams?: boolean;
    IsActive?: boolean;
    AllowRandomDefault?: boolean;
    SortOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    BannerAnimationKey?: string;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;
    BannerMediaIdDisplay?: string;
    AvatarMediaIdDisplay?: string;
    BannerAnimationKeyDisplay?: string;

    // Relations
    BannerBannerAnimation? : BannerAnimationEntity;
    ChallengeDefinition? : ChallengeDefinitionEntity;
    ChallengeTeam? : ChallengeTeamEntity[];
    UserProfile? : UserProfileEntity[];
}

export interface BadgeAwardEntity extends DwOrmData {
    // Attributes
    BadgeAwardId?: number;
    ChallengeDefinitionId?: number;
    BadgeDefinitionId?: number;
    BadgeRecipientTypeId?: number;
    BadgeAwardModeId?: number;
    BadgeSubjectId?: number;
    ChallengeBadgeRuleId?: number;
    BadgeTierId?: number;
    BadgeAwardTypeId?: number;
    EarnedDateTime?: string;
    AwardedDateTime?: string;
    MetricValueAtAward?: number;
    RankAtAward?: number;
    BadgeCalculationRunId?: number;
    LeaderboardEntryId?: number;
    BadgeAwardStateId?: number;
    IsBackfilled?: boolean;
    CorrectionReason?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeAwardEventEntity extends DwOrmData {
    // Attributes
    BadgeAwardEventId?: number;
    BadgeAwardId?: number;
    ChallengeDefinitionId?: number;
    BadgeAwardEventTypeId?: number;
    EffectiveDateTime?: string;
    RecordedDateTime?: string;
    Reason?: string;
    BadgeCalculationRunId?: number;
    MetricValue?: number;
    RankPosition?: number;
    OperationKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeAwardEventTypeEntity extends DwOrmData {
    // Attributes
    BadgeAwardEventTypeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeAwardModeEntity extends DwOrmData {
    // Attributes
    BadgeAwardModeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeAwardRetentionPolicyEntity extends DwOrmData {
    // Attributes
    BadgeAwardRetentionPolicyId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeAwardStateEntity extends DwOrmData {
    // Attributes
    BadgeAwardStateId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeAwardTypeEntity extends DwOrmData {
    // Attributes
    BadgeAwardTypeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeCalculationRunEntity extends DwOrmData {
    // Attributes
    BadgeCalculationRunId?: number;
    ChallengeDefinitionId?: number;
    BadgeCalculationRunTypeId?: number;
    BadgeCalculationRunStateId?: number;
    ReportingDate?: string;
    ScoreThroughDate?: string;
    SourceReadStartedDateTime?: string;
    SourceReadCompletedDateTime?: string;
    ConfigurationRevision?: number;
    StartedDateTime?: string;
    CompletedDateTime?: string;
    PublishedDateTime?: string;
    PreviousBadgeCalculationRunId?: number;
    OperationKey?: string;
    BoardCount?: number;
    EntryCount?: number;
    AwardCount?: number;
    ErrorSummary?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
}

export interface BadgeCalculationRunStateEntity extends DwOrmData {
    // Attributes
    BadgeCalculationRunStateId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeCalculationRunTypeEntity extends DwOrmData {
    // Attributes
    BadgeCalculationRunTypeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeCalculationTypeEntity extends DwOrmData {
    // Attributes
    BadgeCalculationTypeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    BadgeAwardModeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    BadgeDefinitionBadgeAwardModeId? : BadgeDefinitionEntity[];
}

export interface BadgeCategoryEntity extends DwOrmData {
    // Attributes
    BadgeCategoryId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    BadgeDefinition? : BadgeDefinitionEntity[];
}

export interface BadgeDefinitionEntity extends DwOrmData {
    // Attributes
    BadgeDefinitionId?: number;
    BadgeKey?: string;
    DefinitionVersion?: number;
    Name?: string;
    Description?: string;
    BadgeCategoryId?: number;
    BadgeCalculationTypeId?: number;
    BadgeAwardModeId?: number;
    DefaultIconKey?: string;
    DisplayOrder?: number;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    BadgeCalculationTypeBadgeAwardModeId? : BadgeCalculationTypeEntity;
    BadgeCategory? : BadgeCategoryEntity;
    BadgeTierBadgeAwardModeId? : BadgeTierEntity[];
    ChallengeBadgeRule? : ChallengeBadgeRuleEntity[];
    ChallengeBadgeRuleBadgeAwardModeId? : ChallengeBadgeRuleEntity[];
}

export interface BadgeMetricTypeEntity extends DwOrmData {
    // Attributes
    BadgeMetricTypeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    BadgeCalculationTypeId?: number;
    UnitKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeProgressEntity extends DwOrmData {
    // Attributes
    BadgeProgressId?: number;
    ChallengeDefinitionId?: number;
    BadgeDefinitionId?: number;
    BadgeRecipientTypeId?: number;
    BadgeAwardModeId?: number;
    BadgeSubjectId?: number;
    ChallengeBadgeRuleId?: number;
    CurrentMetricValue?: number;
    CurrentBadgeTierId?: number;
    NextBadgeTierId?: number;
    NextThresholdValue?: number;
    ProgressPercent?: number;
    BadgeProgressStateId?: number;
    LastBadgeCalculationRunId?: number;
    LastCalculatedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeProgressStateEntity extends DwOrmData {
    // Attributes
    BadgeProgressStateId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeRecipientTypeEntity extends DwOrmData {
    // Attributes
    BadgeRecipientTypeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeSubjectEntity extends DwOrmData {
    // Attributes
    BadgeSubjectId?: number;
    ChallengeDefinitionId?: number;
    BadgeRecipientTypeId?: number;
    UserChallengeId?: number;
    ChallengeTeamId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    ChallengeTeam? : ChallengeTeamEntity;
    ChallengeDefinitionIdChallengeTeam? : ChallengeTeamEntity;
    UserChallenge? : UserChallengeEntity;
    ChallengeDefinitionIdUserChallenge? : UserChallengeEntity;
}

export interface BadgeTeamAggregationTypeEntity extends DwOrmData {
    // Attributes
    BadgeTeamAggregationTypeId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeTiePolicyEntity extends DwOrmData {
    // Attributes
    BadgeTiePolicyId?: number;
    Code?: string;
    Name?: string;
    DisplayOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface BadgeTierEntity extends DwOrmData {
    // Attributes
    BadgeTierId?: number;
    BadgeDefinitionId?: number;
    BadgeAwardModeId?: number;
    TierKey?: string;
    TierOrder?: number;
    Name?: string;
    ThresholdValue?: number;
    MinRank?: number;
    MaxRank?: number;
    RequirementText?: string;
    FrameKey?: string;
    SymbolMaterialKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    BadgeDefinitionBadgeAwardModeId? : BadgeDefinitionEntity;
}

export interface BannerAnimationEntity extends DwOrmData {
    // Attributes
    BannerAnimationId?: number;
    AnimationKey?: string;
    Name?: string;
    RendererKey?: string;
    IsActive?: boolean;
    IsSelectable?: boolean;
    SortOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    BannerAppearancePreset? : AppearancePresetEntity[];
    BannerChallengeTeam? : ChallengeTeamEntity[];
    BannerUserProfile? : UserProfileEntity[];
}

export interface ChallengeBadgeConfigurationEntity extends DwOrmData {
    // Attributes
    ChallengeBadgeConfigurationId?: number;
    ChallengeDefinitionId?: number;
    Enabled?: boolean;
    ConfigurationRevision?: number;
    TimeZoneIdentifier?: string;
    NightlyCalculationLocalTime?: string;
    FinalizationEligibleDateTime?: string;
    PublishedBadgeCalculationRunId?: number;
    FinalBadgeCalculationRunId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
}

export interface ChallengeBadgeRuleEntity extends DwOrmData {
    // Attributes
    ChallengeBadgeRuleId?: number;
    ChallengeDefinitionId?: number;
    BadgeDefinitionId?: number;
    BadgeCalculationTypeId?: number;
    BadgeAwardModeId?: number;
    RuleKey?: string;
    RuleVersion?: number;
    BadgeRecipientTypeId?: number;
    FitnessActivityTypeId?: number;
    BadgeMetricTypeId?: number;
    BadgeTeamAggregationTypeId?: number;
    BadgeTiePolicyId?: number;
    BadgeAwardRetentionPolicyId?: number;
    AvailableFromDate?: string;
    AvailableThroughDate?: string;
    Enabled?: boolean;
    DisplayOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    BadgeDefinitionBadgeAwardModeId? : BadgeDefinitionEntity;
    BadgeDefinition? : BadgeDefinitionEntity;
    ChallengeDefinition? : ChallengeDefinitionEntity;
    FitnessActivityType? : FitnessActivityTypeEntity;
}

export interface ChallengeDefActivityTypeEntity extends DwOrmData {
    // Attributes
    ChallengeDefActivityTypeId?: number;
    ChallengeDefinitionId?: number;
    FitnessActivityTypeId?: number;
    IsIncluded?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IncludeInLeaderboards?: boolean;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;
    FitnessActivityTypeIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    FitnessActivityType? : FitnessActivityTypeEntity;
}

export interface ChallengeDefinitionEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    Name?: string;
    Description?: string;
    ChallengeEndDate?: string;
    ChallengeStartDate?: string;
    HasShirt?: boolean;
    EntryFee?: number;
    IsCurrent?: boolean;
    RegistrationStartDate?: string;
    MailShirtFee?: number;
    RegistrationEndDate?: string;
    ProductId?: number;
    StoreStartDate?: string;
    StoreEndDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    StoreShippingMessage?: string;
    AfterOrderShippingMessage?: string;
    GracePeriodHours?: number;

    // Display Attributes
    ProductIdDisplay?: string;

    // Relations
    DwProduct? : DwProductEntity;
    AppearancePreset? : AppearancePresetEntity[];
    BadgeCalculationRun? : BadgeCalculationRunEntity[];
    BadgeSubject? : BadgeSubjectEntity[];
    ChallengeBadgeConfiguration? : ChallengeBadgeConfigurationEntity[];
    ChallengeBadgeRule? : ChallengeBadgeRuleEntity[];
    ChallengeDefActivityType? : ChallengeDefActivityTypeEntity[];
    ChallengeDefinitionProduct? : ChallengeDefinitionProductEntity[];
    ChallengeGoal? : ChallengeGoalEntity[];
    ChallengeMedia? : ChallengeMediaEntity[];
    ChallengeTeam? : ChallengeTeamEntity[];
    EmailChallenge? : EmailChallengeEntity[];
    Recipient? : RecipientEntity[];
    RegistrationOrderDetail? : RegistrationOrderDetailEntity[];
    ShirtSize? : ShirtSizeEntity[];
    UserChallenge? : UserChallengeEntity[];
}

export interface ChallengeDefinitionProductEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionProductId?: number;
    ChallengeDefinitionId?: number;
    ProductId?: number;
    IncludedInChallenge?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;
    ProductIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    DwProduct? : DwProductEntity;
}

export interface ChallengeGoalEntity extends DwOrmData {
    // Attributes
    ChallengeGoalId?: number;
    ChallengeDefinitionId?: number;
    Title?: string;
    Description?: string;
    MeasureKey?: number;
    TargetValue?: number;
    CurrencyCode?: string;
    ParentChallengeGoalId?: number;
    DisplayOrder?: number;
    IsVisible?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
}

export interface ChallengeMediaEntity extends DwOrmData {
    // Attributes
    ChallengeMediaId?: number;
    MediaKeyName?: string;
    ChallengeDefinitionId?: number;
    MediaId?: number;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;
    MediaIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
}

export interface ChallengeTeamEntity extends DwOrmData {
    // Attributes
    ChallengeTeamId?: number;
    ChallengeDefinitionId?: number;
    TeamName?: string;
    TeamDescription?: string;
    TeamPictureMediaId?: number;
    IsPrivateTeam?: boolean;
    PartyReferenceId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    TeamBackgroundMediaId?: number;
    RequestApprovalToJoin?: boolean;
    TeamLocked?: boolean;
    TeamLocation?: string;
    TeamJoinCode?: string;
    TeamSlug?: string;
    AppearancePresetId?: number;
    BannerColorStart?: string;
    BannerColorEnd?: string;
    BannerUseGradient?: boolean;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    BannerImageMode?: number;
    AvatarImageMode?: number;
    BannerAnimationKey?: string;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;
    TeamPictureMediaIdDisplay?: string;
    PartyReferenceIdDisplay?: string;
    TeamBackgroundMediaIdDisplay?: string;
    AppearancePresetIdDisplay?: string;
    BannerAnimationKeyDisplay?: string;

    // Relations
    BannerBannerAnimation? : BannerAnimationEntity;
    AppearancePreset? : AppearancePresetEntity;
    ChallengeDefinition? : ChallengeDefinitionEntity;
    BadgeSubject? : BadgeSubjectEntity[];
    ChallengeDefinitionIdBadgeSubject? : BadgeSubjectEntity[];
    ChallengeTeamJoinRequest? : ChallengeTeamJoinRequestEntity[];
    ChallengeTeamMember? : ChallengeTeamMemberEntity[];
    RegistrationOrderDetail? : RegistrationOrderDetailEntity[];
}

export interface ChallengeTeamJoinRequestEntity extends DwOrmData {
    // Attributes
    ChallengeTeamJoinRequestId?: number;
    ChallengeTeamId?: number;
    UserChallengeId?: number;
    ChallengeTeamJoinRequestStatusId?: number;
    RequestNotes?: string;
    RejectionNotes?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ChallengeTeamIdDisplay?: string;
    UserChallengeIdDisplay?: string;
    ChallengeTeamJoinRequestStatusIdDisplay?: string;

    // Relations
    ChallengeTeam? : ChallengeTeamEntity;
    ChallengeTeamJoinRequestStatus? : ChallengeTeamJoinRequestStatusEntity;
    UserChallenge? : UserChallengeEntity;
}

export interface ChallengeTeamJoinRequestStatusEntity extends DwOrmData {
    // Attributes
    ChallengeTeamJoinRequestStatusId?: number;
    RequestStatus?: string;


    // Relations
    ChallengeTeamJoinRequest? : ChallengeTeamJoinRequestEntity[];
}

export interface ChallengeTeamMemberEntity extends DwOrmData {
    // Attributes
    ChallengeTeamMemberId?: number;
    ChallengeTeamId?: number;
    UserChallengeId?: number;
    IsTeamAdmin?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ChallengeTeamIdDisplay?: string;
    UserChallengeIdDisplay?: string;

    // Relations
    ChallengeTeam? : ChallengeTeamEntity;
    UserChallenge? : UserChallengeEntity;
}

export interface DwCodeSetEntity extends DwOrmData {
    // Attributes
    CodeSetId?: number;
    CodeSetName?: string;
    IsActvie?: boolean;
    UseTransitions?: boolean;
    TransitionCodeSetId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes

    // Relations
    DwCodeValue? : DwCodeValueEntity[];
    ParentDwCodeValueRelation? : DwCodeValueRelationEntity[];
    ChildDwCodeValueRelation? : DwCodeValueRelationEntity[];
}

export interface DwCodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    DwCodeSet? : DwCodeSetEntity;
    ParentDwCodeValueRelation? : DwCodeValueRelationEntity[];
    ChildDwCodeValueRelation? : DwCodeValueRelationEntity[];
    FromDwCodeValueTransition? : DwCodeValueTransitionEntity[];
    ToDwCodeValueTransition? : DwCodeValueTransitionEntity[];
    ParentDwCodeValueTransition? : DwCodeValueTransitionEntity[];
}

export interface DwCodeValueRelationEntity extends DwOrmData {
    // Attributes
    CodeValueRelationId?: number;
    ParentCodeSetId?: number;
    ParentCodeValueId?: number;
    ChildCodeSetId?: number;
    ChildCodeValueId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ParentCodeSetIdDisplay?: string;
    ParentCodeValueIdDisplay?: string;
    ChildCodeSetIdDisplay?: string;
    ChildCodeValueIdDisplay?: string;

    // Relations
    ParentDwCodeSet? : DwCodeSetEntity;
    ChildDwCodeSet? : DwCodeSetEntity;
    ParentDwCodeValue? : DwCodeValueEntity;
    ChildDwCodeValue? : DwCodeValueEntity;
}

export interface DwCodeValueTransitionEntity extends DwOrmData {
    // Attributes
    CodeValueTransitionId?: number;
    FromCodeValueId?: number;
    ToCodeValueId?: number;
    CanTransitionPermission?: string;
    ParentCodeValueId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FromCodeValueIdDisplay?: string;
    ToCodeValueIdDisplay?: string;
    ParentCodeValueIdDisplay?: string;

    // Relations
    FromDwCodeValue? : DwCodeValueEntity;
    ToDwCodeValue? : DwCodeValueEntity;
    ParentDwCodeValue? : DwCodeValueEntity;
}

export interface DwCountryEntity extends DwOrmData {
    // Attributes
    CountryId?: number;
    CountryName?: string;
    CountryShortName?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;


    // Relations
    DwAddress? : DwAddressEntity[];
    DwShippingRate? : DwShippingRateEntity[];
    DwStateProvince? : DwStateProvinceEntity[];
}

export interface EmailChallengeEntity extends DwOrmData {
    // Attributes
    EmailChallengeId?: number;
    UserId?: number;
    ChallengeDefinitionId?: number;
    FriendName?: string;
    FriendEmail?: string;
    EmailSent?: boolean;
    EmailSentDateTime?: string;
    Registered?: boolean;
    RegisteredUserId?: number;
    RegisteredDateTime?: string;
    NameMatch?: boolean;
    CodeMatch?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ExcludeFromStats?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    ChallengeDefinitionIdDisplay?: string;
    RegisteredUserIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    RegisteredDwUser? : DwUserEntity;
    DwUser? : DwUserEntity;
}

export interface FitnessActivityEntity extends DwOrmData {
    // Attributes
    FitnessActivityId?: number;
    UserChallengeId?: number;
    FitnessActivityTypeId?: number;
    Name?: string;
    ActivityDate?: string;
    StartTime?: string;
    DurationSeconds?: number;
    CaloriesKCal?: number;
    DistanceMeters?: number;
    DistanceUnitOfMeasureId?: number;
    Laps?: number;
    LapLengthMeters?: number;
    LapUnitOfMeasureId?: number;
    AverageHeartRate?: number;
    AveragePaceMetersPerSecond?: number;
    Steps?: number;
    ElevationGainMeters?: number;
    ElevationGainUnitOfMeasureId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ActivityPictureMediaId?: number;
    Comments?: string;
    ActivityCount?: number;

    // Display Attributes
    UserChallengeIdDisplay?: string;
    FitnessActivityTypeIdDisplay?: string;
    DistanceUnitOfMeasureIdDisplay?: string;
    LapUnitOfMeasureIdDisplay?: string;
    ElevationGainUnitOfMeasureIdDisplay?: string;
    ActivityPictureMediaIdDisplay?: string;

    // Relations
    FitnessActivityType? : FitnessActivityTypeEntity;
    DistanceUnitOfMeasure? : UnitOfMeasureEntity;
    LapUnitOfMeasure? : UnitOfMeasureEntity;
    ElevationGainUnitOfMeasure? : UnitOfMeasureEntity;
    UserChallenge? : UserChallengeEntity;
    UserChallengeComment? : UserChallengeCommentEntity[];
}

export interface FitnessActivityDisplayGroupEntity extends DwOrmData {
    // Attributes
    FitnessActivityDisplayGroupId?: number;
    ShowDuration?: boolean;
    ShowCalories?: boolean;
    ShowDistance?: boolean;
    ShowLaps?: boolean;
    ShowAverageHeattRate?: boolean;
    ShowPace?: boolean;
    ShowSteps?: boolean;
    ShowElevationGain?: boolean;
    DisplayGroupName?: string;
    ShowLapLength?: boolean;
    DefaultUnitOfMeasureId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ShowCount?: boolean;

    // Display Attributes
    DefaultUnitOfMeasureIdDisplay?: string;

    // Relations
    DefaultUnitOfMeasure? : UnitOfMeasureEntity;
    FitnessActivityDisplayGroupUOM? : FitnessActivityDisplayGroupUOMEntity[];
    FitnessActivityGroupIdFitnessActivityType? : FitnessActivityTypeEntity[];
}

export interface FitnessActivityDisplayGroupUOMEntity extends DwOrmData {
    // Attributes
    FitnessActivityDisplayGroupUOMId?: number;
    FitnessActivityDisplayGroupId?: number;
    UnitOfMeasureId?: number;
    IsDefault?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FitnessActivityDisplayGroupIdDisplay?: string;
    UnitOfMeasureIdDisplay?: string;

    // Relations
    FitnessActivityDisplayGroup? : FitnessActivityDisplayGroupEntity;
    UnitOfMeasure? : UnitOfMeasureEntity;
}

export interface FitnessActivityTypeEntity extends DwOrmData {
    // Attributes
    FitnessActivityTypeId?: number;
    ActivityTypeName?: string;
    ActivityTypeDescription?: string;
    IconCss?: string;
    FitnessActivityGroupId?: number;
    ActivityDisplayPresent?: string;
    ActivityDisplayPast?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CountDisplay?: string;
    IsStandard?: boolean;
    IncludeInLeaderboards?: boolean;

    // Display Attributes
    FitnessActivityGroupIdDisplay?: string;

    // Relations
    FitnessActivityGroupIdFitnessActivityDisplayGroup? : FitnessActivityDisplayGroupEntity;
    ChallengeBadgeRule? : ChallengeBadgeRuleEntity[];
    ChallengeDefActivityType? : ChallengeDefActivityTypeEntity[];
    FitnessActivity? : FitnessActivityEntity[];
    UserFitnessSummaryRollup? : UserFitnessSummaryRollupEntity[];
}

export interface InformationRequestEntity extends DwOrmData {
    // Attributes
    InformationRequestId?: number;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    Comments?: string;


    // Relations
}

export interface LeaderboardEntryEntity extends DwOrmData {
    // Attributes
    LeaderboardEntryId?: number;
    ChallengeDefinitionId?: number;
    BadgeDefinitionId?: number;
    BadgeRecipientTypeId?: number;
    BadgeAwardModeId?: number;
    LeaderboardSnapshotId?: number;
    BadgeCalculationRunId?: number;
    ChallengeBadgeRuleId?: number;
    BadgeSubjectId?: number;
    MetricTotal?: number;
    MemberCount?: number;
    ContributorCount?: number;
    ScoreValue?: number;
    RankPosition?: number;
    BadgeTierId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface LeaderboardSnapshotEntity extends DwOrmData {
    // Attributes
    LeaderboardSnapshotId?: number;
    ChallengeDefinitionId?: number;
    BadgeDefinitionId?: number;
    BadgeRecipientTypeId?: number;
    BadgeAwardModeId?: number;
    BadgeCalculationRunId?: number;
    ChallengeBadgeRuleId?: number;
    ScorePeriodStartDate?: string;
    ScoreThroughDate?: string;
    BadgeMetricTypeId?: number;
    UnitKey?: string;
    BadgeTeamAggregationTypeId?: number;
    BadgeTiePolicyId?: number;
    EligibleSubjectCount?: number;
    ConfigurationRevision?: number;
    CalculationCompletedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface MarketingSourceEntity extends DwOrmData {
    // Attributes
    MarketingSourceId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    SortOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    MarketingSourceCvUserChallenge? : UserChallengeEntity[];
}

export interface MediaCommentTypeEntity extends DwOrmData {
    // Attributes
    MediaCommentTypeId?: number;
    CommentType?: string;
    CommentTypeIconCss?: string;


    // Relations
    MediaPostComment? : MediaPostCommentEntity[];
}

export interface MediaPostEntity extends DwOrmData {
    // Attributes
    MediaPostId?: number;
    PartyReferenceId?: number;
    PostTitle?: string;
    PostBody?: string;
    MediaId?: number;
    UserId?: number;

    // Display Attributes
    PartyReferenceIdDisplay?: string;
    MediaIdDisplay?: string;
    UserIdDisplay?: string;

    // Relations
    DwUser? : DwUserEntity;
    MediaPostComment? : MediaPostCommentEntity[];
}

export interface MediaPostCommentEntity extends DwOrmData {
    // Attributes
    MediaPostCommentId?: number;
    MediaPostId?: number;
    MediaCommentTypeId?: number;
    Comment?: string;

    // Display Attributes
    MediaPostIdDisplay?: string;
    MediaCommentTypeIdDisplay?: string;

    // Relations
    MediaCommentType? : MediaCommentTypeEntity;
    MediaPost? : MediaPostEntity;
}

export interface DwOrderEntity extends DwOrmData {
    // Attributes
    OrderId?: number;
    UserId?: number;
    OrderStatusId?: number;
    BillingAddressId?: number;
    ShippingAddressSameAsBilling?: boolean;
    ShippingAddressId?: number;
    UserPaymentId?: number;
    SubTotalAmount?: number;
    ShippingAmount?: number;
    TotalAmount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    OrderBatchId?: number;
    ProcessedDateTime?: string;
    ProcessingEmailSent?: boolean;
    ShippedDateTime?: string;
    ShippedEmailSent?: boolean;
    DiscountAmount?: number;
    PromotionCode?: string;

    // Display Attributes
    UserIdDisplay?: string;
    OrderStatusIdDisplay?: string;
    BillingAddressIdDisplay?: string;
    ShippingAddressIdDisplay?: string;
    UserPaymentIdDisplay?: string;
    OrderBatchIdDisplay?: string;

    // Relations
    BillingDwAddress? : DwAddressEntity;
    ShippingDwAddress? : DwAddressEntity;
    DwOrderBatch? : DwOrderBatchEntity;
    DwOrderStatus? : DwOrderStatusEntity;
    DwUser? : DwUserEntity;
    DwUserPayment? : DwUserPaymentEntity;
    DwOrderDetail? : DwOrderDetailEntity[];
    UserChallenge? : UserChallengeEntity[];
}

export interface DwOrderBatchEntity extends DwOrmData {
    // Attributes
    OrderBatchId?: number;
    BatchName?: string;
    OrderBatchStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    OrderBatchStatusIdDisplay?: string;

    // Relations
    DwOrderBatchStatus? : DwOrderBatchStatusEntity;
    DwOrder? : DwOrderEntity[];
}

export interface DwOrderBatchStatusEntity extends DwOrmData {
    // Attributes
    OrderBatchStatusId?: number;
    BatchStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    DwOrderBatch? : DwOrderBatchEntity[];
}

export interface DwOrderDetailEntity extends DwOrmData {
    // Attributes
    OrderDetailId?: number;
    OrderId?: number;
    ProductId?: number;
    ProductSizeId?: number;
    ProductColorId?: number;
    Price?: number;
    Quantity?: number;
    ProductOptionDetail1Id?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    OrderIdDisplay?: string;
    ProductIdDisplay?: string;
    ProductSizeIdDisplay?: string;
    ProductOptionDetail1IdDisplay?: string;

    // Relations
    DwOrder? : DwOrderEntity;
    DwProduct? : DwProductEntity;
    ProductOptionDetail1IdDwProductOptionDetail? : DwProductOptionDetailEntity;
    DwProductSize? : DwProductSizeEntity;
    RegistrationOrderDetail? : RegistrationOrderDetailEntity[];
    SwagRegistrationOrderDetail? : RegistrationOrderDetailEntity[];
}

export interface DwOrderStatusEntity extends DwOrmData {
    // Attributes
    OrderStatusId?: number;
    OrderStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    DwOrder? : DwOrderEntity[];
}

export interface DwPostalCodeEntity extends DwOrmData {
    // Attributes
    PostalCodeId?: number;
    StateProvinceId?: number;
    PostalCode?: string;
    Plus4?: string;
    City?: string;
    County?: string;
    AreaCode?: string;
    Latitude?: number;
    Longitude?: number;
    GmtOffset?: number;
    ObservesDst?: boolean;
    IsMetropolitanArea?: boolean;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    StateProvinceIdDisplay?: string;

    // Relations
    DwStateProvince? : DwStateProvinceEntity;
}

export interface DwProductEntity extends DwOrmData {
    // Attributes
    ProductId?: number;
    ProductName?: string;
    ProductMeaning?: string;
    ProductDescription?: string;
    ProductTypeId?: number;
    ProductCategoryId?: number;
    ProductDefaultPrice?: number;
    ProductCode?: string;
    HasSizes?: boolean;
    RequiresShipping?: boolean;
    IsActive?: boolean;
    AdditionalShippingAmount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    SizingChartUrl?: string;
    ProductCost?: number;

    // Display Attributes
    ProductTypeIdDisplay?: string;
    ProductCategoryIdDisplay?: string;

    // Relations
    DwProductCategory? : DwProductCategoryEntity;
    DwProductType? : DwProductTypeEntity;
    ChallengeDefinition? : ChallengeDefinitionEntity[];
    ChallengeDefinitionProduct? : ChallengeDefinitionProductEntity[];
    DwOrderDetail? : DwOrderDetailEntity[];
    DwProductColor? : DwProductColorEntity[];
    DwProductMedia? : DwProductMediaEntity[];
    DwProductOption? : DwProductOptionEntity[];
    DwProductSize? : DwProductSizeEntity[];
    DwShoppingCartRuleCondition? : DwShoppingCartRuleConditionEntity[];
}

export interface DwProductCategoryEntity extends DwOrmData {
    // Attributes
    ProductCategoryId?: number;
    CategoryDisplay?: string;
    CategoryMeaning?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    DwProduct? : DwProductEntity[];
}

export interface DwProductColorEntity extends DwOrmData {
    // Attributes
    ProductColorId?: number;
    ProductId?: number;
    Color?: string;
    ColorDescription?: string;
    ProductMediaId?: number;
    ColorOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ProductIdDisplay?: string;
    ProductMediaIdDisplay?: string;

    // Relations
    DwProduct? : DwProductEntity;
    DwProductMedia? : DwProductMediaEntity;
}

export interface DwProductMediaEntity extends DwOrmData {
    // Attributes
    ProductMediaId?: number;
    ProductId?: number;
    MediaTypeId?: number;
    MediaName?: string;
    IsDefault?: boolean;
    MediaUrl?: string;
    MediaOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    MediaId?: number;

    // Display Attributes
    ProductIdDisplay?: string;
    MediaTypeIdDisplay?: string;
    MediaIdDisplay?: string;

    // Relations
    DwProduct? : DwProductEntity;
    DwProductColor? : DwProductColorEntity[];
}

export interface DwProductOptionEntity extends DwOrmData {
    // Attributes
    ProductOptionId?: number;
    ProductId?: number;
    ProductOptionName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ProductIdDisplay?: string;

    // Relations
    DwProduct? : DwProductEntity;
    DwProductOptionDetail? : DwProductOptionDetailEntity[];
}

export interface DwProductOptionDetailEntity extends DwOrmData {
    // Attributes
    ProductOptionDetailId?: number;
    ProductOptionId?: number;
    DetailName?: string;
    DetailDescription?: string;
    ExtraCost?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ProductOptionIdDisplay?: string;

    // Relations
    DwProductOption? : DwProductOptionEntity;
    ProductOptionDetail1IdDwOrderDetail? : DwOrderDetailEntity[];
}

export interface DwProductSizeEntity extends DwOrmData {
    // Attributes
    ProductSizeId?: number;
    ProductId?: number;
    Size?: string;
    ExtraCost?: number;
    SizeOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ProductIdDisplay?: string;

    // Relations
    DwProduct? : DwProductEntity;
    DwOrderDetail? : DwOrderDetailEntity[];
}

export interface DwProductTypeEntity extends DwOrmData {
    // Attributes
    ProductTypeId?: number;
    ProductType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    DwProduct? : DwProductEntity[];
}

export interface RecipientEntity extends DwOrmData {
    // Attributes
    RecipientId?: number;
    ChallengeDefinitionId?: number;
    RecipientName?: string;
    Slug?: string;
    ShortDescription?: string;
    FullDescriptionHtml?: string;
    InternalNotes?: string;
    RevealAtDateTime?: string;
    IsPublished?: boolean;
    DisplayOrder?: number;
    SourceUrl?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    RecipientPhoto? : RecipientPhotoEntity[];
    RecipientUpdate? : RecipientUpdateEntity[];
}

export interface RecipientPhotoEntity extends DwOrmData {
    // Attributes
    RecipientPhotoId?: number;
    RecipientId?: number;
    MediaId?: number;
    Caption?: string;
    AltText?: string;
    DisplayOrder?: number;
    IsDefault?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CardFitWholePhoto?: boolean;
    CardPositionXPercent?: number;
    CardPositionYPercent?: number;

    // Display Attributes
    RecipientIdDisplay?: string;
    MediaIdDisplay?: string;

    // Relations
    Recipient? : RecipientEntity;
}

export interface RecipientUpdateEntity extends DwOrmData {
    // Attributes
    RecipientUpdateId?: number;
    RecipientId?: number;
    Title?: string;
    BodyHtml?: string;
    PublishAtDateTime?: string;
    IsPublished?: boolean;
    SourceUrl?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    RecipientIdDisplay?: string;

    // Relations
    Recipient? : RecipientEntity;
    RecipientUpdatePhoto? : RecipientUpdatePhotoEntity[];
}

export interface RecipientUpdatePhotoEntity extends DwOrmData {
    // Attributes
    RecipientUpdatePhotoId?: number;
    RecipientUpdateId?: number;
    MediaId?: number;
    Caption?: string;
    AltText?: string;
    DisplayOrder?: number;
    IsDefault?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    RecipientUpdateIdDisplay?: string;
    MediaIdDisplay?: string;

    // Relations
    RecipientUpdate? : RecipientUpdateEntity;
}

export interface RegistrationOrderDetailEntity extends DwOrmData {
    // Attributes
    RegistrationOrderDetailId?: number;
    OrderDetailId?: number;
    SwagOrderDetailId?: number;
    ChallengeDefinitionId?: number;
    ParticipantEmail?: string;
    ParticipantFirstName?: string;
    ParticipantLastName?: string;
    YearsStreaking?: number;
    MarketingSourceCv?: number;
    MarketingSourceOther?: string;
    ChallengedByUserId?: number;
    UserChallengeId?: number;
    FulfilledDateTime?: string;
    FulfillmentError?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ChallengeTeamId?: number;
    TeamJoinCodeUsed?: string;

    // Display Attributes
    OrderDetailIdDisplay?: string;
    SwagOrderDetailIdDisplay?: string;
    ChallengeDefinitionIdDisplay?: string;
    UserChallengeIdDisplay?: string;
    ChallengeTeamIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    ChallengeTeam? : ChallengeTeamEntity;
    DwOrderDetail? : DwOrderDetailEntity;
    SwagDwOrderDetail? : DwOrderDetailEntity;
    UserChallenge? : UserChallengeEntity;
}

export interface RoActivityDisplayEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    FitnessActivityId?: number;
    UserChallengeId?: number;
    UserProfileId?: number;
    UserId?: number;
    IsRegistrationComplete?: boolean;
    FitnessActivityTypeId?: number;
    Name?: string;
    Comments?: string;
    ActivityDate?: string;
    StartTime?: string;
    DurationSeconds?: number;
    DistanceMeters?: number;
    ActivityCount?: number;
    Steps?: number;
    CaloriesKCal?: number;
    Laps?: number;
    LapLengthMeters?: number;
    AverageHeartRate?: number;
    AveragePaceMetersPerSecond?: number;
    ElevationGainMeters?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    DistanceUnitOfMeasureId?: number;
    DistanceUOMName?: string;
    DistanceUOMShortName?: string;
    DistanceMultiplierToBase?: number;
    LapUnitOfMeasureId?: number;
    LapUOMName?: string;
    LapUOMShortName?: string;
    ElevationGainUnitOfMeasureId?: number;
    ElevationUOMName?: string;
    ElevationUOMShortName?: string;
    ActivityTypeName?: string;
    IconCss?: string;
    CountDisplay?: string;
    FitnessActivityGroupId?: number;
    ShowCount?: boolean;
    ShowDuration?: boolean;
    ShowDistance?: boolean;
    FirstName?: string;
    LastName?: string;
    AuthorDisplayName?: string;
    ProfileSlug?: string;
    AppearancePresetId?: number;
    BannerColorStart?: string;
    BannerColorEnd?: string;
    BannerUseGradient?: boolean;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    BannerAnimationKey?: string;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    BannerMediaId?: number;
    BannerMediaPath?: string;
    BannerWidth?: number;
    BannerHeight?: number;
    ActivityPictureMediaId?: number;
    ActivityMediaId?: number;
    ActivityMediaPath?: string;
    ActivityWidth?: number;
    ActivityHeight?: number;
    LikeCount?: number;
    CommentCount?: number;


    // Relations
}

export interface RoChallengeAdminSummaryEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    ChallengeName?: string;
    IsCurrent?: boolean;
    ChallengeStartDate?: string;
    ChallengeEndDate?: string;
    StreakerCount?: number;
    TeamCount?: number;
    DonationCount?: number;
    RecordedDonationAmount?: number;
    PaidDonationAmount?: number;


    // Relations
}

export interface RoChallengeCollectionSummaryEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    RegistrationAmount?: number;
    ExtraShirtAmount?: number;
    DonationAmount?: number;
    ShippingAmount?: number;
    DiscountAmount?: number;
    TotalAmount?: number;
    TotalExcludingShipping?: number;
    OrdersNeedingReview?: number;


    // Relations
}

export interface RoChallengeDonationAdminEntity extends DwOrmData {
    // Attributes
    OrderDetailId?: number;
    OrderId?: number;
    UserId?: number;
    DonorName?: string;
    OrderDateTime?: string;
    OrderStatus?: string;
    ProductId?: number;
    ProductName?: string;
    DonationAmount?: number;
    PaidDonationAmount?: number;
    ChallengeDefinitionId?: number;
    AttributionStatus?: string;
    ChallengeName?: string;
    IsCurrent?: boolean;
    NeedsAttributionReview?: boolean;


    // Relations
}

export interface RoChallengeRegistrationDailyEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    RegistrationDate?: string;
    DailyRegistrations?: number;
    DailyOrderValue?: number;
    OrdersNeedingReview?: number;
    ChallengeName?: string;
    IsCurrent?: boolean;
    TotalRegistered?: number;
    TotalOrderValue?: number;
    RegistrationDailyKey?: string;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;

    // Relations
}

export interface RoChallengeStreakerAdminEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    UserChallengeId?: number;
    ChallengeName?: string;
    IsCurrent?: boolean;
    UserProfileId?: number;
    UserId?: number;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    ProfileSlug?: string;
    DisplayName?: string;
    RegistrationDateTime?: string;
    RowNumber?: number;
    IsMilestone?: boolean;


    // Relations
}

export interface RoChallengeTeamDonationAdminEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    ChallengeTeamId?: number;
    TeamName?: string;
    IsCurrent?: boolean;
    TeamMemberCount?: number;
    RecordedDonationAmount?: number;
    PaidDonationAmount?: number;


    // Relations
}

export interface RoDonationsByTeamEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    ChallengeDefinitionName?: string;
    IsCurrent?: boolean;
    ChallengeTeamId?: number;
    TeamName?: string;
    TeamMemberCount?: number;
    DonationAmount?: number;
    DonationAmountPerMember?: number;


    // Relations
}

export interface RoPublicDisplayImageEntity extends DwOrmData {
    // Attributes
    MediaId?: number;
    MediaPath?: string;
    Width?: number;
    Height?: number;


    // Relations
}

export interface RoStreakerDisplayEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    UserChallengeId?: number;
    UserProfileId?: number;
    UserId?: number;
    FirstName?: string;
    LastName?: string;
    DisplayName?: string;
    ProfileSlug?: string;
    UserDescription?: string;
    IsRegistrationComplete?: boolean;
    UploadedAvatarMediaId?: number;
    UploadedBannerMediaId?: number;
    AppearancePresetId?: number;
    BannerColorStart?: string;
    BannerColorEnd?: string;
    BannerUseGradient?: boolean;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    BannerAnimationKey?: string;
    AvatarImageMode?: number;
    BannerImageMode?: number;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    BannerMediaId?: number;
    BannerMediaPath?: string;
    BannerWidth?: number;
    BannerHeight?: number;


    // Relations
}

export interface RoTeamDisplayEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    ChallengeTeamId?: number;
    TeamName?: string;
    DisplayName?: string;
    TeamSlug?: string;
    TeamDescription?: string;
    TeamLocation?: string;
    IsPrivateTeam?: boolean;
    RequestApprovalToJoin?: boolean;
    TeamLocked?: boolean;
    UploadedAvatarMediaId?: number;
    UploadedBannerMediaId?: number;
    AppearancePresetId?: number;
    BannerColorStart?: string;
    BannerColorEnd?: string;
    BannerUseGradient?: boolean;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    BannerAnimationKey?: string;
    AvatarImageMode?: number;
    BannerImageMode?: number;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    BannerMediaId?: number;
    BannerMediaPath?: string;
    BannerWidth?: number;
    BannerHeight?: number;


    // Relations
}

export interface RoTeamFitnessActivityStatsEntity extends DwOrmData {
    // Attributes
    TeamActivityKey?: string;
    ChallengeDefinitionId?: number;
    ChallengeTeamId?: number;
    DisplayName?: string;
    TeamSlug?: string;
    IsPrivateTeam?: boolean;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    MemberCount?: number;
    SummarizedMemberCount?: number;
    ContributorCount?: number;
    FitnessActivityTypeId?: number;
    ActivityTypeName?: string;
    IconCss?: string;
    CountDisplay?: string;
    TotalActivities?: number;
    TotalDistanceMeters?: number;
    TotalDurationSeconds?: number;
    TotalRepCount?: number;
    TotalElevationGainMeters?: number;
    DistanceMetersPerMember?: number;
    DurationSecondsPerMember?: number;
    RepCountPerMember?: number;
    StatsUpdatedDateTime?: string;


    // Relations
}

export interface RoTeamFitnessStatsEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    ChallengeTeamId?: number;
    DisplayName?: string;
    TeamSlug?: string;
    IsPrivateTeam?: boolean;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    MemberCount?: number;
    SummarizedMemberCount?: number;
    TotalActivities?: number;
    TotalDurationSeconds?: number;
    StatsUpdatedDateTime?: string;


    // Relations
}

export interface RoUserDonationsEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserFullName?: string;
    ChallengeDefinitionId?: number;
    IsCurrent?: boolean;
    ChallengeDefinitionName?: string;
    UserChallengeId?: number;
    ChallengeTeamId?: number;
    TeamName?: string;
    TeamMemberCount?: number;
    OrderDetailId?: number;
    DonationAmount?: number;


    // Relations
}

export interface RoUserFitnessActivityStatsEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    UserChallengeId?: number;
    UserProfileId?: number;
    UserId?: number;
    DisplayName?: string;
    ProfileSlug?: string;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    UserFitnessSummaryId?: number;
    UserFitnessSummaryRollupId?: number;
    FitnessActivityTypeId?: number;
    ActivityTypeName?: string;
    IconCss?: string;
    CountDisplay?: string;
    TotalActivities?: number;
    TotalDistanceMeters?: number;
    TotalDurationSeconds?: number;
    TotalRepCount?: number;
    TotalElevationGainMeters?: number;
    AveragePaceMetersPerSecond?: number;
    FastestPaceMetersPerSecond?: number;
    SlowestPaceMetersPerSecond?: number;
    AverageDistanceMeters?: number;
    LongestDistanceMeters?: number;
    ShortestDistanceMeters?: number;
    StatsUpdatedDateTime?: string;


    // Relations
}

export interface RoUserFitnessStatsEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    UserChallengeId?: number;
    UserProfileId?: number;
    UserId?: number;
    FirstName?: string;
    LastName?: string;
    DisplayName?: string;
    ProfileSlug?: string;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    UserFitnessSummaryId?: number;
    UserChallengeStatusId?: number;
    TotalExerciseDays?: number;
    TotalMissedDays?: number;
    TotalPenaltyDays?: number;
    LongestStreakDays?: number;
    CurrentStreakDays?: number;
    TotalActivities?: number;
    TotalDurationSeconds?: number;
    AverageDurationSeconds?: number;
    LastActivityDate?: string;
    StatsUpdatedDateTime?: string;


    // Relations
}

export interface RoUserProfileDisplayEntity extends DwOrmData {
    // Attributes
    UserProfileId?: number;
    UserId?: number;
    FirstName?: string;
    LastName?: string;
    DisplayName?: string;
    ProfileSlug?: string;
    UserDescription?: string;
    UploadedAvatarMediaId?: number;
    UploadedBannerMediaId?: number;
    AppearancePresetId?: number;
    BannerColorStart?: string;
    BannerColorEnd?: string;
    BannerUseGradient?: boolean;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    BannerAnimationKey?: string;
    AvatarImageMode?: number;
    BannerImageMode?: number;
    AvatarMediaId?: number;
    AvatarMediaPath?: string;
    AvatarWidth?: number;
    AvatarHeight?: number;
    BannerMediaId?: number;
    BannerMediaPath?: string;
    BannerWidth?: number;
    BannerHeight?: number;


    // Relations
    UserChallenge? : UserChallengeEntity[];
}

export interface DwShippingRateEntity extends DwOrmData {
    // Attributes
    ShippingRateId?: number;
    CountryId?: number;
    StateProvinceId?: number;
    PostalPrefix?: string;
    BaseAmount?: number;
    AdditionalUnitAmount?: number;
    IsActive?: boolean;
    StartDate?: string;
    EndDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CountryIdDisplay?: string;
    StateProvinceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    DwCountry? : DwCountryEntity;
    DwStateProvince? : DwStateProvinceEntity;
}

export interface ShirtSizeEntity extends DwOrmData {
    // Attributes
    ShirtSizeId?: number;
    ChallengeDefinitionId?: number;
    ShirtSize?: string;
    Cost?: number;
    ShippingCost?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    UserChallenge? : UserChallengeEntity[];
}

export interface DwShoppingCartRuleEntity extends DwOrmData {
    // Attributes
    ShoppingCartRuleId?: number;
    PromotionCode?: string;
    RuleName?: string;
    RuleDescription?: string;
    StartDate?: string;
    EndDate?: string;
    IsActive?: boolean;
    AllowedUses?: number;
    UsesPerCustomer?: number;
    CurrentUses?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    DwShoppingCartRuleAction? : DwShoppingCartRuleActionEntity[];
    DwShoppingCartRuleCondition? : DwShoppingCartRuleConditionEntity[];
}

export interface DwShoppingCartRuleActionEntity extends DwOrmData {
    // Attributes
    ShoppingCartRuleActionId?: number;
    ShoppingCartRuleId?: number;
    ShoppingCartRuleActionTypeId?: number;
    DiscountAmount?: number;
    MaximumDiscountAmount?: number;
    PercentDiscount?: number;
    ApplyToShippingAmount?: boolean;
    FreeShipping?: boolean;
    MaximumProductUses?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ShoppingCartRuleIdDisplay?: string;
    ShoppingCartRuleActionTypeIdDisplay?: string;

    // Relations
    DwShoppingCartRule? : DwShoppingCartRuleEntity;
    DwShoppingCartRuleActionType? : DwShoppingCartRuleActionTypeEntity;
}

export interface DwShoppingCartRuleActionTypeEntity extends DwOrmData {
    // Attributes
    ShoppingCartRuleActionTypeId?: number;
    ActionType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    DwShoppingCartRuleAction? : DwShoppingCartRuleActionEntity[];
}

export interface DwShoppingCartRuleConditionEntity extends DwOrmData {
    // Attributes
    ShoppingCartRuleConditionId?: number;
    ShoppingCartRuleId?: number;
    ShoppingCartRuleConditionTypeId?: number;
    ProductId?: number;
    Amount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ShoppingCartRuleIdDisplay?: string;
    ShoppingCartRuleConditionTypeIdDisplay?: string;
    ProductIdDisplay?: string;

    // Relations
    DwProduct? : DwProductEntity;
    DwShoppingCartRule? : DwShoppingCartRuleEntity;
    DwShoppingCartRuleConditionType? : DwShoppingCartRuleConditionTypeEntity;
}

export interface DwShoppingCartRuleConditionTypeEntity extends DwOrmData {
    // Attributes
    ShoppingCartRuleConditionTypeId?: number;
    ConditionType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    DwShoppingCartRuleCondition? : DwShoppingCartRuleConditionEntity[];
}

export interface DwStateProvinceEntity extends DwOrmData {
    // Attributes
    StateProvinceId?: number;
    CountryId?: number;
    StateProvinceName?: string;
    StateProvinceShortName?: string;
    StateCode?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    CountryIdDisplay?: string;

    // Relations
    DwCountry? : DwCountryEntity;
    DwAddress? : DwAddressEntity[];
    DwPostalCode? : DwPostalCodeEntity[];
    DwShippingRate? : DwShippingRateEntity[];
}

export interface StatsDedup20261015RollupBackupEntity extends DwOrmData {
    // Attributes
    UserFitnessSummaryRollupId?: number;
    UserFitnessSummaryId?: number;
    FitnessActivityTypeId?: number;
    TotalActivities?: number;
    TotalDistanceMeters?: number;
    TotalDurationSeconds?: number;
    TotalElevationGainMeters?: number;
    AveragePaceMetersPerSecond?: number;
    FastestPaceMetersPerSecond?: number;
    SlowestPaceMetersPerSecond?: number;
    AverageDistanceMeters?: number;
    LongestDistanceMeters?: number;
    ShortestDistanceMeters?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    TotalRepCount?: number;
    DeletedByStatsCleanup?: boolean;
    StatsCleanupSurvivorSummaryId?: number;
    StatsCleanupSurvivorRollupId?: number;
    StatsCleanupOperationId?: string;
    StatsCleanupBackupDateTime?: string;


    // Relations
}

export interface StatsDedup20261015SummaryBackupEntity extends DwOrmData {
    // Attributes
    UserFitnessSummaryId?: number;
    UserChallengeId?: number;
    UserChallengeStatusId?: number;
    TotalExerciseDays?: number;
    TotalMissedDays?: number;
    TotalPenaltyDays?: number;
    LongestStreakDays?: number;
    CurrentStreakDays?: number;
    TotalActivities?: number;
    TotalDurationSeconds?: number;
    AverageDurationSeconds?: number;
    LastActivityDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    DeletedByStatsCleanup?: boolean;
    StatsCleanupSurvivorSummaryId?: number;
    StatsCleanupOperationId?: string;
    StatsCleanupBackupDateTime?: string;


    // Relations
}

export interface DwTimeZoneEntity extends DwOrmData {
    // Attributes
    TimeZoneId?: number;
    TimeZoneName?: string;
    TimeZoneShortName?: string;
    GmtOffSet?: number;
    TimeZoneDescription?: string;
    IANAIdentifier?: string;
    DotNetBCLIdentifier?: string;


    // Relations
    TimezoneIdDwAddress? : DwAddressEntity[];
}

export interface UnitOfMeasureEntity extends DwOrmData {
    // Attributes
    UnitOfMeasureId?: number;
    UOMName?: string;
    MultiplierToBase?: number;
    UnitOfMeasureTypeId?: number;
    UOMShortName?: string;
    UOMNameSingular?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UnitOfMeasureTypeIdDisplay?: string;

    // Relations
    UnitOfMeasureType? : UnitOfMeasureTypeEntity;
    DistanceFitnessActivity? : FitnessActivityEntity[];
    LapFitnessActivity? : FitnessActivityEntity[];
    ElevationGainFitnessActivity? : FitnessActivityEntity[];
    DefaultFitnessActivityDisplayGroup? : FitnessActivityDisplayGroupEntity[];
    FitnessActivityDisplayGroupUOM? : FitnessActivityDisplayGroupUOMEntity[];
    BaseUnitOfMeasureType? : UnitOfMeasureTypeEntity[];
}

export interface UnitOfMeasureTypeEntity extends DwOrmData {
    // Attributes
    UnitOfMeasureTypeId?: number;
    TypeName?: string;
    BaseUnitOfMeasureId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    BaseUnitOfMeasureIdDisplay?: string;

    // Relations
    BaseUnitOfMeasure? : UnitOfMeasureEntity;
    UnitOfMeasure? : UnitOfMeasureEntity[];
}

export interface DwUserEntity extends DwOrmData {
    // Attributes
    AlternateName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    Email?: string;
    FirstName?: string;
    ForcePasswordChange?: boolean;
    IsActive?: boolean;
    IsEmailVerified?: boolean;
    IsTwoFactorAuthenticationEnabled?: boolean;
    LastLoginDateTime?: string;
    LastName?: string;
    LastPasswordChangeDateTime?: string;
    MobilePhone?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    OrganizationId?: number;
    PartyReferenceId?: number;
    Password?: number;
    TwoFactorAuthenticationTypeId?: number;
    UserBackgroundMediaId?: number;
    UserId?: number;
    UserKey?: string;
    UserName?: string;
    UserPictureMediaId?: number;
    UserTypeId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    OrganizationIdDisplay?: string;
    PartyReferenceIdDisplay?: string;
    TwoFactorAuthenticationTypeIdDisplay?: string;
    UserBackgroundMediaIdDisplay?: string;
    UserPictureMediaIdDisplay?: string;
    UserTypeIdDisplay?: string;

    // Relations
    RegisteredEmailChallenge? : EmailChallengeEntity[];
    EmailChallenge? : EmailChallengeEntity[];
    MediaPost? : MediaPostEntity[];
    DwOrder? : DwOrderEntity[];
    ChallengedByUserChallenge? : UserChallengeEntity[];
    UserChallengeEmail? : UserChallengeEmailEntity[];
    DwUserPayment? : DwUserPaymentEntity[];
    UserProfile? : UserProfileEntity;
}

export interface UserChallengeEntity extends DwOrmData {
    // Attributes
    UserChallengeId?: number;
    ChallengeDefinitionId?: number;
    UserProfileId?: number;
    IncludeShirt?: boolean;
    MailShirt?: boolean;
    ShirtSizeId?: number;
    ShirtDeliveryCv?: number;
    ShirtDeliveryInstructions?: string;
    IsRegistrationComplete?: boolean;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    YearsStreakingCv?: number;
    OrderId?: number;
    MarketingSourceCv?: number;
    MarketingSourceOther?: string;
    ChallengeCodeUsed?: string;
    ChallengedByUserId?: number;
    CreatedBy?: number;
    ModifiedBy?: number;

    // Display Attributes
    ChallengeDefinitionIdDisplay?: string;
    UserProfileIdDisplay?: string;
    ShirtSizeIdDisplay?: string;
    YearsStreakingCvDisplay?: string;
    OrderIdDisplay?: string;
    MarketingSourceCvDisplay?: string;
    ChallengedByUserIdDisplay?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    MarketingSourceCvMarketingSource? : MarketingSourceEntity;
    DwOrder? : DwOrderEntity;
    RoUserProfileDisplay? : RoUserProfileDisplayEntity;
    ShirtSize? : ShirtSizeEntity;
    ChallengedByDwUser? : DwUserEntity;
    UserProfile? : UserProfileEntity;
    YearsStreakingCvYearsStreaking? : YearsStreakingEntity;
    BadgeSubject? : BadgeSubjectEntity[];
    ChallengeDefinitionIdBadgeSubject? : BadgeSubjectEntity[];
    ChallengeTeamJoinRequest? : ChallengeTeamJoinRequestEntity[];
    ChallengeTeamMember? : ChallengeTeamMemberEntity[];
    FitnessActivity? : FitnessActivityEntity[];
    RegistrationOrderDetail? : RegistrationOrderDetailEntity[];
    FromUserChallengeComment? : UserChallengeCommentEntity[];
    UserChallengeComment? : UserChallengeCommentEntity[];
    RecipientUserChallengeCommentRecipient? : UserChallengeCommentRecipientEntity[];
    UserChallengeEmail? : UserChallengeEmailEntity[];
    FriendUserChallengeFriend? : UserChallengeFriendEntity[];
    UserChallengeFriend? : UserChallengeFriendEntity[];
    UserFitnessSummary? : UserFitnessSummaryEntity[];
}

export interface UserChallengeCommentEntity extends DwOrmData {
    // Attributes
    UserChallengeCommentId?: number;
    UserChallengeId?: number;
    FitnessActivityId?: number;
    UserChallengeCommentTypeId?: number;
    FromUserChallengeId?: number;
    Comment?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    ParentUserChallengeCommentId?: number;
    ReplyToEveryone?: boolean;
    ClientRequestId?: string;

    // Display Attributes
    UserChallengeIdDisplay?: string;
    FitnessActivityIdDisplay?: string;
    UserChallengeCommentTypeIdDisplay?: string;
    FromUserChallengeIdDisplay?: string;

    // Relations
    FitnessActivity? : FitnessActivityEntity;
    FromUserChallenge? : UserChallengeEntity;
    UserChallenge? : UserChallengeEntity;
    UserChallengeCommentType? : UserChallengeCommentTypeEntity;
    UserChallengeCommentRecipient? : UserChallengeCommentRecipientEntity[];
}

export interface UserChallengeCommentLegacyLikeBackup20261013Entity extends DwOrmData {
    // Attributes
    UserChallengeCommentId?: number;
    UserChallengeId?: number;
    FitnessActivityId?: number;
    UserChallengeCommentTypeId?: number;
    FromUserChallengeId?: number;
    Comment?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;


    // Relations
}

export interface UserChallengeCommentRecipientEntity extends DwOrmData {
    // Attributes
    UserChallengeCommentRecipientId?: number;
    UserChallengeCommentId?: number;
    RecipientUserChallengeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UserChallengeCommentIdDisplay?: string;
    RecipientUserChallengeIdDisplay?: string;

    // Relations
    RecipientUserChallenge? : UserChallengeEntity;
    UserChallengeComment? : UserChallengeCommentEntity;
}

export interface UserChallengeCommentTypeEntity extends DwOrmData {
    // Attributes
    UserChallengeCommentTypeId?: number;
    CommntType?: string;
    CommentTypeIconCss?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    UserChallengeComment? : UserChallengeCommentEntity[];
}

export interface UserChallengeEmailEntity extends DwOrmData {
    // Attributes
    UserChallengeEmailId?: number;
    UserChallengeId?: number;
    FriendName?: string;
    FriendEmail?: string;
    EmailSent?: boolean;
    EmailSentDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    UserId?: number;

    // Display Attributes
    UserChallengeIdDisplay?: string;
    UserIdDisplay?: string;

    // Relations
    DwUser? : DwUserEntity;
    UserChallenge? : UserChallengeEntity;
}

export interface UserChallengeFriendEntity extends DwOrmData {
    // Attributes
    UserChallengeFriendId?: number;
    UserChallengeId?: number;
    FriendUserChallengeId?: number;
    CanEnterActivities?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UserChallengeIdDisplay?: string;
    FriendUserChallengeIdDisplay?: string;

    // Relations
    FriendUserChallenge? : UserChallengeEntity;
    UserChallenge? : UserChallengeEntity;
}

export interface UserChallengeStatusEntity extends DwOrmData {
    // Attributes
    UserChallengeStatusId?: number;
    UserChallengeStatus?: string;
    MinDaysMissed?: number;
    MaxDaysMissed?: number;
    Description?: string;
    IconCss?: string;
    LeewayDays?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    BadgeOrder?: number;
    BadgeColor?: string;


    // Relations
    UserFitnessSummary? : UserFitnessSummaryEntity[];
}

export interface UserFitnessSummaryEntity extends DwOrmData {
    // Attributes
    UserFitnessSummaryId?: number;
    UserChallengeId?: number;
    UserChallengeStatusId?: number;
    TotalExerciseDays?: number;
    TotalMissedDays?: number;
    TotalPenaltyDays?: number;
    LongestStreakDays?: number;
    CurrentStreakDays?: number;
    TotalActivities?: number;
    TotalDurationSeconds?: number;
    AverageDurationSeconds?: number;
    LastActivityDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UserChallengeIdDisplay?: string;
    UserChallengeStatusIdDisplay?: string;

    // Relations
    UserChallenge? : UserChallengeEntity;
    UserChallengeStatus? : UserChallengeStatusEntity;
    UserFitnessSummaryRollup? : UserFitnessSummaryRollupEntity[];
}

export interface UserFitnessSummaryRollupEntity extends DwOrmData {
    // Attributes
    UserFitnessSummaryRollupId?: number;
    UserFitnessSummaryId?: number;
    FitnessActivityTypeId?: number;
    TotalActivities?: number;
    TotalDistanceMeters?: number;
    TotalDurationSeconds?: number;
    TotalElevationGainMeters?: number;
    AveragePaceMetersPerSecond?: number;
    FastestPaceMetersPerSecond?: number;
    SlowestPaceMetersPerSecond?: number;
    AverageDistanceMeters?: number;
    LongestDistanceMeters?: number;
    ShortestDistanceMeters?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    TotalRepCount?: number;

    // Display Attributes
    UserFitnessSummaryIdDisplay?: string;
    FitnessActivityTypeIdDisplay?: string;

    // Relations
    FitnessActivityType? : FitnessActivityTypeEntity;
    UserFitnessSummary? : UserFitnessSummaryEntity;
}

export interface DwUserPaymentEntity extends DwOrmData {
    // Attributes
    UserPaymentId?: number;
    UserId?: number;
    PaymentDescription?: string;
    TotalPaymentAmount?: number;
    CreditCardLast4?: string;
    Success?: boolean;
    Issues?: string;
    PaymentReferenceId?: string;
    PaymentStartDatTime?: string;
    PaymentCompleteDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PaymentMode?: string;
    PaymentAccount?: string;

    // Display Attributes
    UserIdDisplay?: string;

    // Relations
    DwUser? : DwUserEntity;
    DwOrder? : DwOrderEntity[];
}

export interface UserProfileEntity extends DwOrmData {
    // Attributes
    UserProfileId?: number;
    UserId?: number;
    AddressId?: number;
    MyChallengeCode?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    UserDescription?: string;
    ProfileSlug?: string;
    AppearancePresetId?: number;
    BannerColorStart?: string;
    BannerColorEnd?: string;
    BannerUseGradient?: boolean;
    AvatarBackgroundColor?: string;
    AvatarTextColor?: string;
    BannerImageMode?: number;
    AvatarImageMode?: number;
    BannerAnimationKey?: string;
    DonationsAnonymous?: boolean;
    IncludeDonationsInTeamTotals?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    AddressIdDisplay?: string;
    AppearancePresetIdDisplay?: string;
    BannerAnimationKeyDisplay?: string;

    // Relations
    DwAddress? : DwAddressEntity;
    BannerBannerAnimation? : BannerAnimationEntity;
    AppearancePreset? : AppearancePresetEntity;
    DwUser? : DwUserEntity;
    UserChallenge? : UserChallengeEntity[];
}

export interface YearsStreakingEntity extends DwOrmData {
    // Attributes
    YearsStreakingId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    SortOrder?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    YearsStreakingCvUserChallenge? : UserChallengeEntity[];
}

// Generated Query Interfaces
/** Entity for Query Meaning FitnessEmailEnrollment  */
export interface FitnessEmailEnrollmentQueryEntity extends DwOrmData {
    // Attributes
    UserChallengeId?: number;
    UserProfileId?: number;
    UserProfileIdDisplay?: string;
    ChallengeDefinitionId?: number;
    ChallengeDefinitionIdDisplay?: string;
    IsRegistrationComplete?: boolean;
    ProfileUserId?: number;
    ProfileUserIdDisplay?: string;
    RecipientUserId?: number;
    RecipientFirstName?: string;
    RecipientLastName?: string;
    RecipientEmail?: string;
    RecipientIsActive?: boolean;
    StreakName?: string;
    StreakChallengeStartDate?: string;
    StreakChallengeEndDate?: string;
    StreakRegistrationEndDate?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    MarketingSourceCvMarketingSource? : MarketingSourceEntity;
    DwOrder? : DwOrderEntity;
    RoUserProfileDisplay? : RoUserProfileDisplayEntity;
    ShirtSize? : ShirtSizeEntity;
    ChallengedByDwUser? : DwUserEntity;
    UserProfile? : UserProfileEntity;
    YearsStreakingCvYearsStreaking? : YearsStreakingEntity;
    BadgeSubject? : BadgeSubjectEntity[];
    ChallengeDefinitionIdBadgeSubject? : BadgeSubjectEntity[];
    ChallengeTeamJoinRequest? : ChallengeTeamJoinRequestEntity[];
    ChallengeTeamMember? : ChallengeTeamMemberEntity[];
    FitnessActivity? : FitnessActivityEntity[];
    RegistrationOrderDetail? : RegistrationOrderDetailEntity[];
    FromUserChallengeComment? : UserChallengeCommentEntity[];
    UserChallengeComment? : UserChallengeCommentEntity[];
    RecipientUserChallengeCommentRecipient? : UserChallengeCommentRecipientEntity[];
    UserChallengeEmail? : UserChallengeEmailEntity[];
    FriendUserChallengeFriend? : UserChallengeFriendEntity[];
    UserChallengeFriend? : UserChallengeFriendEntity[];
    UserFitnessSummary? : UserFitnessSummaryEntity[];
}

/** Entity for Query Meaning FitnessEmailInvitation  */
export interface FitnessEmailInvitationQueryEntity extends DwOrmData {
    // Attributes
    EmailChallengeId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    ChallengeDefinitionId?: number;
    ChallengeDefinitionIdDisplay?: string;
    FriendName?: string;
    FriendEmail?: string;
    EmailSent?: boolean;
    EmailSentDateTime?: string;
    TenantId?: number;
    TenantIdDisplay?: string;
    Registered?: boolean;
    RegisteredUserId?: number;
    RegisteredUserIdDisplay?: string;
    RegisteredDateTime?: string;
    NameMatch?: boolean;
    CodeMatch?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ExcludeFromStats?: boolean;
    InviterFirstName?: string;
    InviterLastName?: string;
    InviterEmail?: string;
    StreakName?: string;
    StreakChallengeStartDate?: string;
    StreakChallengeEndDate?: string;
    StreakRegistrationEndDate?: string;

    // Relations
    ChallengeDefinition? : ChallengeDefinitionEntity;
    RegisteredDwUser? : DwUserEntity;
    DwUser? : DwUserEntity;
}

/** Entity for Query Meaning FitnessEmailTeamRequest  */
export interface FitnessEmailTeamRequestQueryEntity extends DwOrmData {
    // Attributes
    ChallengeTeamJoinRequestId?: number;
    ChallengeTeamId?: number;
    ChallengeTeamIdDisplay?: string;
    UserChallengeId?: number;
    UserChallengeIdDisplay?: string;
    ChallengeTeamJoinRequestStatusId?: number;
    ChallengeTeamJoinRequestStatusIdDisplay?: string;
    RequestNotes?: string;
    RejectionNotes?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    EnrollmentChallengeDefinitionId?: number;
    EnrollmentChallengeDefinitionIdDisplay?: string;
    EnrollmentIsRegistrationComplete?: boolean;
    ProfileUserId?: number;
    ProfileUserIdDisplay?: string;
    RecipientUserId?: number;
    RecipientFirstName?: string;
    RecipientLastName?: string;
    RecipientEmail?: string;
    RecipientIsActive?: boolean;
    TeamTeamName?: string;
    TeamChallengeDefinitionId?: number;
    TeamChallengeDefinitionIdDisplay?: string;
    StreakName?: string;
    StreakChallengeStartDate?: string;
    StreakChallengeEndDate?: string;
    StreakRegistrationEndDate?: string;

    // Relations
    ChallengeTeam? : ChallengeTeamEntity;
    ChallengeTeamJoinRequestStatus? : ChallengeTeamJoinRequestStatusEntity;
    UserChallenge? : UserChallengeEntity;
}

/** Entity for Query Meaning FitnessEmailTeamMember  */
export interface FitnessEmailTeamMemberQueryEntity extends DwOrmData {
    // Attributes
    ChallengeTeamMemberId?: number;
    ChallengeTeamId?: number;
    ChallengeTeamIdDisplay?: string;
    UserChallengeId?: number;
    UserChallengeIdDisplay?: string;
    IsTeamAdmin?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    EnrollmentChallengeDefinitionId?: number;
    EnrollmentChallengeDefinitionIdDisplay?: string;
    EnrollmentIsRegistrationComplete?: boolean;
    ProfileUserId?: number;
    ProfileUserIdDisplay?: string;
    RecipientUserId?: number;
    RecipientFirstName?: string;
    RecipientLastName?: string;
    RecipientEmail?: string;
    RecipientIsActive?: boolean;
    TeamTeamName?: string;
    TeamChallengeDefinitionId?: number;
    TeamChallengeDefinitionIdDisplay?: string;
    StreakName?: string;
    StreakChallengeStartDate?: string;
    StreakChallengeEndDate?: string;
    StreakRegistrationEndDate?: string;

    // Relations
    ChallengeTeam? : ChallengeTeamEntity;
    UserChallenge? : UserChallengeEntity;
}

/** Entity for Query Meaning FitnessEmailOrder  */
export interface FitnessEmailOrderQueryEntity extends DwOrmData {
    // Attributes
    OrderId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    OrderStatusId?: number;
    OrderStatusIdDisplay?: string;
    BillingAddressId?: number;
    BillingAddressIdDisplay?: string;
    ShippingAddressSameAsBilling?: boolean;
    ShippingAddressId?: number;
    ShippingAddressIdDisplay?: string;
    UserPaymentId?: number;
    UserPaymentIdDisplay?: string;
    SubTotalAmount?: number;
    ShippingAmount?: number;
    TotalAmount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    OrderBatchId?: number;
    OrderBatchIdDisplay?: string;
    ProcessedDateTime?: string;
    ProcessingEmailSent?: boolean;
    ShippedDateTime?: string;
    ShippedEmailSent?: boolean;
    DiscountAmount?: number;
    PromotionCode?: string;
    RecipientUserId?: number;
    RecipientFirstName?: string;
    RecipientLastName?: string;
    RecipientEmail?: string;
    RecipientIsActive?: boolean;

    // Relations
    BillingDwAddress? : DwAddressEntity;
    ShippingDwAddress? : DwAddressEntity;
    DwOrderBatch? : DwOrderBatchEntity;
    DwOrderStatus? : DwOrderStatusEntity;
    DwUser? : DwUserEntity;
    DwUserPayment? : DwUserPaymentEntity;
    DwOrderDetail? : DwOrderDetailEntity[];
    UserChallenge? : UserChallengeEntity[];
}

/** Entity for Query Meaning FitnessEmailChallenge  */
export interface FitnessEmailChallengeQueryEntity extends DwOrmData {
    // Attributes
    ChallengeDefinitionId?: number;
    Name?: string;
    Description?: string;
    ChallengeEndDate?: string;
    ChallengeStartDate?: string;
    HasShirt?: boolean;
    EntryFee?: number;
    IsCurrent?: boolean;
    TenantId?: number;
    TenantIdDisplay?: string;
    RegistrationStartDate?: string;
    MailShirtFee?: number;
    RegistrationEndDate?: string;
    ProductId?: number;
    ProductIdDisplay?: string;
    StoreStartDate?: string;
    StoreEndDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    StoreShippingMessage?: string;
    AfterOrderShippingMessage?: string;
    GracePeriodHours?: number;

    // Relations
    DwProduct? : DwProductEntity;
    AppearancePreset? : AppearancePresetEntity[];
    BadgeCalculationRun? : BadgeCalculationRunEntity[];
    BadgeSubject? : BadgeSubjectEntity[];
    ChallengeBadgeConfiguration? : ChallengeBadgeConfigurationEntity[];
    ChallengeBadgeRule? : ChallengeBadgeRuleEntity[];
    ChallengeDefActivityType? : ChallengeDefActivityTypeEntity[];
    ChallengeDefinitionProduct? : ChallengeDefinitionProductEntity[];
    ChallengeGoal? : ChallengeGoalEntity[];
    ChallengeMedia? : ChallengeMediaEntity[];
    ChallengeTeam? : ChallengeTeamEntity[];
    EmailChallenge? : EmailChallengeEntity[];
    Recipient? : RecipientEntity[];
    RegistrationOrderDetail? : RegistrationOrderDetailEntity[];
    ShirtSize? : ShirtSizeEntity[];
    UserChallenge? : UserChallengeEntity[];
}

/** Entity for Query Meaning FitnessEmailComment  */
export interface FitnessEmailCommentQueryEntity extends DwOrmData {
    // Attributes
    UserChallengeCommentId?: number;
    UserChallengeId?: number;
    UserChallengeIdDisplay?: string;
    FitnessActivityId?: number;
    FitnessActivityIdDisplay?: string;
    UserChallengeCommentTypeId?: number;
    UserChallengeCommentTypeIdDisplay?: string;
    FromUserChallengeId?: number;
    FromUserChallengeIdDisplay?: string;
    Comment?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    ParentUserChallengeCommentId?: number;
    ReplyToEveryone?: boolean;
    ClientRequestId?: string;
    ActivityUserChallengeId?: number;
    ActivityUserChallengeIdDisplay?: string;
    EnrollmentChallengeDefinitionId?: number;
    EnrollmentChallengeDefinitionIdDisplay?: string;
    EnrollmentIsRegistrationComplete?: boolean;
    ProfileUserId?: number;
    ProfileUserIdDisplay?: string;
    RecipientUserId?: number;
    RecipientFirstName?: string;
    RecipientLastName?: string;
    RecipientEmail?: string;
    RecipientIsActive?: boolean;

    // Relations
    FitnessActivity? : FitnessActivityEntity;
    FromUserChallenge? : UserChallengeEntity;
    UserChallenge? : UserChallengeEntity;
    UserChallengeCommentType? : UserChallengeCommentTypeEntity;
    UserChallengeCommentRecipient? : UserChallengeCommentRecipientEntity[];
}

/** Entity for Query Meaning FitnessEmailAwardEvent  */
export interface FitnessEmailAwardEventQueryEntity extends DwOrmData {
    // Attributes
    BadgeAwardEventId?: number;
    BadgeAwardId?: number;
    ChallengeDefinitionId?: number;
    BadgeAwardEventTypeId?: number;
    EffectiveDateTime?: string;
    RecordedDateTime?: string;
    Reason?: string;
    BadgeCalculationRunId?: number;
    MetricValue?: number;
    RankPosition?: number;
    OperationKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Relations
}

/** Entity for Query Meaning FitnessEmailAccount  */
export interface FitnessEmailAccountQueryEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    IsActive?: boolean;

    // Relations
    RegisteredEmailChallenge? : EmailChallengeEntity[];
    EmailChallenge? : EmailChallengeEntity[];
    MediaPost? : MediaPostEntity[];
    DwOrder? : DwOrderEntity[];
    ChallengedByUserChallenge? : UserChallengeEntity[];
    UserChallengeEmail? : UserChallengeEmailEntity[];
    DwUserPayment? : DwUserPaymentEntity[];
    UserProfile? : UserProfileEntity;
}

/** Entity for Query Meaning FitnessEmailCommentRecipients  */
export interface FitnessEmailCommentRecipientsQueryEntity extends DwOrmData {
    // Attributes
    UserChallengeCommentRecipientId?: number;
    UserChallengeCommentId?: number;
    UserChallengeCommentIdDisplay?: string;
    RecipientUserChallengeId?: number;
    RecipientUserChallengeIdDisplay?: string;
    EnrollmentChallengeDefinitionId?: number;
    EnrollmentChallengeDefinitionIdDisplay?: string;
    EnrollmentIsRegistrationComplete?: boolean;
    ProfileUserId?: number;
    ProfileUserIdDisplay?: string;
    RecipientUserId?: number;
    RecipientFirstName?: string;
    RecipientLastName?: string;
    RecipientEmail?: string;
    RecipientIsActive?: boolean;

    // Relations
    RecipientUserChallenge? : UserChallengeEntity;
    UserChallengeComment? : UserChallengeCommentEntity;
}

    // Lookup Value Enums  {
export enum OrderStatusAllItems {
        Pending = 1,
        Cancelled = 2,
        PaymentComplete = 3,
        Processing = 4,
        PaymentFailed = 5,
        Shipped = 6,
        PaymentInProgress = 7,
    }

export enum OrderBatchStatusAllItems {
        Pending = 1,
        Processing = 2,
        Shipped = 3,
        Cancelled = 4,
    }

export enum ChallengeTeamJoinRequestStatusAllItems {
        Pending = 1,
        Approved = 2,
        Rejected = 3,
        Cancelled = 4,
    }

export enum UserChallengeStatusAllItems {
        GoldStreakers = 1,
        SilverStreakers = 2,
        BronzeStreakers = 3,
        GreenStreakers = 4,
        RedStreakers = 5,
        DonorStreakers = 6,
    }

export enum FitnessActivityDisplayGroupAllItems {
        RunningWalking = 1,
        Swimming = 2,
        OtherCardio = 3,
        NoCountOther = 4,
        CountType = 6,
        Sport = 7,
    }

export enum FitnessActivityDisplayGroupUOMAllItems {
        FitnessActivityDisplayGroupUOMId1 = 1,
        FitnessActivityDisplayGroupUOMId2 = 2,
        FitnessActivityDisplayGroupUOMId3 = 3,
        FitnessActivityDisplayGroupUOMId4 = 4,
    }

export enum ShoppingCartRuleActionTypeAllItems {
        PercentDiscount = 1,
        AmountDiscount = 2,
        ProductPercentDiscount = 3,
        ProductAmountDiscount = 4,
    }

export enum ShoppingCartRuleConditionTypeAllItems {
        HasProduct = 1,
        TotalAmountGreaterThan = 2,
    }

export enum ProductTypeAllItems {
        Registration = 1,
        Donation = 2,
        Gear = 3,
    }

export enum UserChallengeCommentTypeAllItems {
        Like = 1,
        Taunt = 2,
    }

export enum UnitOfMeasureTypeAllItems {
        Distance = 1,
        Time = 2,
        Volume = 3,
        WeightMass = 4,
        Pace = 5,
    }

export enum MediaCommentTypeAllItems {
    }

export enum FitnessActivityTypeAllItems {
        Running = 1,
        Biking = 2,
        Swimming = 3,
        OtherCardio = 4,
        Walking = 5,
        Hiking = 7,
        WeightLifting = 8,
        Elliptical = 9,
        Burpees = 10,
        Other = 12,
        GivingBlood = 13,
        HIIT = 14,
        Pushups = 1001,
        Yoga = 2001,
        Planks = 2002,
        HandWashing = 2003,
        SocialDistancing = 2004,
        Mindfulness = 2005,
        DryJanuary = 2006,
        Tennis = 2007,
    }

export enum ChallengeDefActivityTypeAllItems {
    }

export enum ProductOptionAllItems {
        LogoOptions = 1,
        // Duplicate property Name found
        LogoOptions_3 = 3,
        // Duplicate property Name found
        LogoOptions_4 = 4,
        BackLogoOption = 5,
        // Duplicate property Name found
        BackLogoOption_6 = 6,
    }

export enum ProductOptionDetailAllItems {
        HolidayStreaker = 1,
        IAmAStreaker = 2,
        // Duplicate property Name found
        HolidayStreaker_3 = 3,
        // Duplicate property Name found
        IAmAStreaker_4 = 4,
        // Duplicate property Name found
        HolidayStreaker_5 = 5,
        // Duplicate property Name found
        IAmAStreaker_6 = 6,
        NoLogo = 7,
        IAmAStreaker500 = 8,
        // Duplicate property Name found
        NoLogo_9 = 9,
        // Duplicate property Name found
        IAmAStreaker500_10 = 10,
    }




